/*
* @license
* Broadcast Theme (c) Presidio Creative
*
* The contents of this file should not be modified.
* add any minor changes to assets/custom.js
*
*/
/*
 * @license
 * Broadcast Theme (c) Presidio Creative
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t) {
  "use strict";
  !(function () {
    const t = { NODE_ENV: "production" };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, t)
        );
    } catch (t) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
    (window.theme.getWindowWidth = function () {
      return (
        document.documentElement.clientWidth ||
        document.body.clientWidth ||
        window.innerWidth
      );
    }),
    (window.theme.getWindowHeight = function () {
      return (
        document.documentElement.clientHeight ||
        document.body.clientHeight ||
        window.innerHeight
      );
    }),
    (window.theme.isMobile = function () {
      return window.theme.getWindowWidth() < window.theme.sizes.small;
    });
  (window.theme.formatMoney = function (t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    let i = "";
    const s = /\{\{\s*(\w+)\s*\}\}/,
      o = e || "${{amount}}";
    function r(t, e = 2, i = ",", s = ".") {
      if (isNaN(t) || null == t) return 0;
      const o = (t = (t / 100).toFixed(e)).split(".");
      return (
        o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) +
        (o[1] ? s + o[1] : "")
      );
    }
    switch (o.match(s)[1]) {
      case "amount":
        i = r(t, 2);
        break;
      case "amount_no_decimals":
        i = r(t, 0);
        break;
      case "amount_with_comma_separator":
        i = r(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = r(t, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        i = r(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        i = r(t, 0, " ", "");
        break;
      case "amount_with_space_separator":
        i = r(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        i = r(t, 2, " ", ".");
    }
    return o.replace(s, i);
  }),
    (window.theme.debounce = function (t, e) {
      let i;
      return function () {
        if (t) {
          const s = () => t.apply(this, arguments);
          clearTimeout(i), (i = setTimeout(s, e));
        }
      };
    });
  let e = o(),
    i = !0;
  function s() {
    const {
        windowHeight: t,
        headerHeight: s,
        logoHeight: r,
        footerHeight: n,
        collectionNavHeight: a,
      } = window.theme.readHeights(),
      l = o();
    (!i || l !== e || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      (e = l),
      (i = !1)),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${a}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${s}px`),
      document.documentElement.style.setProperty("--footer-height", `${n}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - s - r / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - s - n + "px"
      );
  }
  function o() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function r(t) {
    const e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  (window.theme.readHeights = function () {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = r('[data-section-type*="footer"]')),
      (t.headerHeight = r("[data-header-height]")),
      (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]")
        ? t.headerHeight
        : 0),
      (t.collectionNavHeight = r("[data-collection-nav]")),
      (t.logoHeight = (function () {
        const t = r("[data-footer-logo]");
        return t > 0 ? t + 20 : 0;
      })()),
      t
    );
  }),
    s(),
    window.addEventListener("DOMContentLoaded", s),
    document.addEventListener("theme:resize", s),
    document.addEventListener("shopify:section:load", s),
    (window.theme.scrollTo = (t) => {
      const e = document.querySelector("[data-header-sticky]")
        ? document.querySelector("[data-header-height]").offsetHeight
        : 0;
      window.scrollTo({
        top: t + window.scrollY - e,
        left: 0,
        behavior: "smooth",
      });
    });
  const n = {},
    a = {
      forceFocus(t, e) {
        e = e || {};
        var i = t.tabIndex;
        (t.tabIndex = -1),
          (t.dataset.tabIndex = i),
          t.focus(),
          void 0 !== e.className && t.classList.add(e.className),
          t.addEventListener("blur", function s(o) {
            o.target.removeEventListener(o.type, s),
              (t.tabIndex = i),
              delete t.dataset.tabIndex,
              void 0 !== e.className && t.classList.remove(e.className);
          });
      },
      focusHash(t) {
        t = t || {};
        var e = window.location.hash,
          i = document.getElementById(e.slice(1));
        if (i && t.ignore && i.matches(t.ignore)) return !1;
        e && i && this.forceFocus(i, t);
      },
      bindInPageLinks(t) {
        return (
          (t = t || {}),
          Array.prototype.slice
            .call(document.querySelectorAll('a[href^="#"]'))
            .filter((e) => {
              if ("#" === e.hash || "" === e.hash) return !1;
              if (t.ignore && e.matches(t.ignore)) return !1;
              if (((i = e.hash.substr(1)), null === document.getElementById(i)))
                return !1;
              var i,
                s = document.querySelector(e.hash);
              return (
                !!s &&
                (e.addEventListener("click", () => {
                  this.forceFocus(s, t);
                }),
                !0)
              );
            })
        );
      },
      focusable(t) {
        return Array.prototype.slice
          .call(
            t.querySelectorAll(
              "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
            )
          )
          .filter(
            (t) =>
              !(
                !(
                  t.offsetWidth ||
                  t.offsetHeight ||
                  t.getClientRects().length
                ) || !this.isVisible(t)
              )
          );
      },
      trapFocus(t, e) {
        e = e || {};
        var i = this.focusable(t),
          s = e.elementToFocus || t,
          o = i[0],
          r = i[i.length - 1];
        this.removeTrapFocus(),
          (n.focusin = function (e) {
            t !== e.target &&
              !t.contains(e.target) &&
              o &&
              o === e.target &&
              o.focus(),
              (e.target !== t && e.target !== r && e.target !== o) ||
                document.addEventListener("keydown", n.keydown);
          }),
          (n.focusout = function () {
            document.removeEventListener("keydown", n.keydown);
          }),
          (n.keydown = function (e) {
            "Tab" === e.code &&
              (e.target !== r || e.shiftKey || (e.preventDefault(), o.focus()),
              (e.target !== t && e.target !== o) ||
                !e.shiftKey ||
                (e.preventDefault(), r.focus()));
          }),
          document.addEventListener("focusout", n.focusout),
          document.addEventListener("focusin", n.focusin),
          this.forceFocus(s, e);
      },
      removeTrapFocus() {
        document.removeEventListener("focusin", n.focusin),
          document.removeEventListener("focusout", n.focusout),
          document.removeEventListener("keydown", n.keydown);
      },
      autoFocusLastElement() {
        window.a11y.lastElement &&
          document.body.classList.contains("is-focused") &&
          setTimeout(() => {
            var t;
            null === (t = window.a11y.lastElement) || void 0 === t || t.focus();
          });
      },
      accessibleLinks(t, e) {
        if ("string" != typeof t) throw new TypeError(t + " is not a String.");
        if (0 !== (t = document.querySelectorAll(t)).length) {
          (e = e || {}).messages = e.messages || {};
          var i,
            s,
            o,
            r = {
              newWindow: e.messages.newWindow || "Opens in a new window.",
              external: e.messages.external || "Opens external website.",
              newWindowExternal:
                e.messages.newWindowExternal ||
                "Opens external website in a new window.",
            },
            n = e.prefix || "a11y",
            a = {
              newWindow: n + "-new-window-message",
              external: n + "-external-message",
              newWindowExternal: n + "-new-window-external-message",
            };
          t.forEach((t) => {
            var e = t.getAttribute("target"),
              i = t.getAttribute("rel"),
              s = (function (t) {
                return t.hostname !== window.location.hostname;
              })(t),
              o = "_blank" === e,
              r = null === i || -1 === i.indexOf("noopener");
            if (o && r) {
              var n = null === i ? "noopener" : i + " noopener";
              t.setAttribute("rel", n);
            }
            s && o
              ? t.setAttribute("aria-describedby", a.newWindowExternal)
              : s
              ? t.setAttribute("aria-describedby", a.external)
              : o && t.setAttribute("aria-describedby", a.newWindow);
          }),
            (i = r),
            (s = document.createElement("ul")),
            (o = Object.keys(i).reduce(
              (t, e) => t + "<li id=" + a[e] + ">" + i[e] + "</li>",
              ""
            )),
            s.setAttribute("hidden", !0),
            (s.innerHTML = o),
            document.body.appendChild(s);
        }
      },
      isVisible(t) {
        var e = window.getComputedStyle(t);
        return "none" !== e.display && "hidden" !== e.visibility;
      },
    };
  function l() {
    if (document.querySelector("cart-items")) return;
    const t = document.createElement("cart-items");
    document.body.appendChild(t);
  }
  function d(t) {
    t.querySelectorAll(".form-field").forEach((t) => {
      const e = t.querySelector("label"),
        i = t.querySelector("input, textarea");
      e &&
        i &&
        (i.addEventListener("keyup", (t) => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        i.value && i.value.length && e.classList.add("label--float"));
    });
  }
  (window.theme = window.theme || {}),
    (window.theme.a11y = a),
    (window.theme.throttle = (t, e) => {
      let i, s;
      return function o(...r) {
        const n = Date.now();
        (s = clearTimeout(s)),
          !i || n - i >= e
            ? (t.apply(null, r), (i = n))
            : (s = setTimeout(o.bind(null, ...r), e - (n - i)));
      };
    });
  let c = window.theme.getWindowWidth(),
    h = window.theme.getWindowHeight();
  let u = window.scrollY,
    p = null,
    m = null,
    v = null,
    g = null,
    b = 0;
  function w(e) {
    setTimeout(() => {
      b && clearTimeout(b),
        t.disablePageScroll(e.detail, {
          allowTouchMove: (t) => "TEXTAREA" === t.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function f(t) {
    const e = t.detail;
    e ? (b = setTimeout(y, e)) : y();
  }
  function y() {
    t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  const E = (t, e = "", i) => {
    const s = i || document.createElement("div");
    return (
      s.classList.add(e), t.parentNode.insertBefore(s, t), s.appendChild(t)
    );
  };
  function L(t) {
    t.querySelectorAll(".rte table").forEach((t) => {
      E(t, "rte__table-wrapper"),
        t.setAttribute("data-scroll-lock-scrollable", "");
    });
    t.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((t) => {
      E(t, "rte__video-wrapper");
    });
  }
  function S(t) {
    const e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          const e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          const i = e.getAttribute("aria-controls"),
            s = document.querySelector(`#${i}`),
            o = () => {
              s.classList.remove("expanding"),
                s.removeEventListener("transitionend", o);
            },
            r = () => {
              s.classList.add("expanding"),
                s.removeEventListener("transitionstart", r);
            };
          s.addEventListener("transitionstart", r),
            s.addEventListener("transitionend", o),
            s.classList.toggle("expanded");
        });
      });
  }
  const A = "is-loading",
    k = "img.is-loading";
  const C = "[data-aos]:not(.aos-animate)",
    q = "[data-aos-anchor]",
    T = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
    M = "aos-animate",
    x = { attributes: !1, childList: !0, subtree: !0 };
  let I = [];
  const P = (t) => {
      for (const e of t)
        if ("childList" === e.type) {
          const t = e.target,
            i = t.querySelectorAll(C),
            s = t.querySelectorAll(q);
          i.length &&
            i.forEach((t) => {
              O.observe(t);
            }),
            s.length && H(s);
        }
    },
    O = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add(M), e.unobserve(t.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    D = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio) {
            const i = t.target.querySelectorAll(C);
            i.length &&
              i.forEach((t) => {
                t.classList.add(M);
              }),
              e.unobserve(t.target);
            const s = I.indexOf("#" + t.target.id);
            -1 !== s && I.splice(s, 1);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function H(t) {
    t.length &&
      !Shopify.visualPreviewMode &&
      t.forEach((t) => {
        const e = t.dataset.aosAnchor;
        if (e && -1 === I.indexOf(e)) {
          const t = document.querySelector(e);
          t && (D.observe(t), I.push(e));
        }
      });
  }
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      (!(function () {
        const t = document.querySelectorAll(T);
        t.length &&
          t.forEach((t) => {
            O.observe(t);
          });
      })(),
      (function () {
        const t = document.querySelectorAll(q);
        t.length && H(t);
      })(),
      new MutationObserver(P).observe(document.body, x),
      document.addEventListener("shopify:section:unload", (t) => {
        var e;
        const i =
            "#" +
            (null === (e = t.target.querySelector("[data-section-id]")) ||
            void 0 === e
              ? void 0
              : e.id),
          s = I.indexOf(i);
        -1 !== s && I.splice(s, 1);
      })),
    window.addEventListener(
      "resize",
      window.theme.debounce(function () {
        document.dispatchEvent(
          new CustomEvent("theme:resize", { bubbles: !0 })
        ),
          c !== window.theme.getWindowWidth() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:width", { bubbles: !0 })
            ),
            (c = window.theme.getWindowWidth())),
          h !== window.theme.getWindowHeight() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:height", { bubbles: !0 })
            ),
            (h = window.theme.getWindowHeight()));
      }, 50)
    ),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.scrollY;
                t > u
                  ? ((m = !0), (p = !1))
                  : t < u
                  ? ((m = !1), (p = !0))
                  : ((p = null), (m = null)),
                  (u = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", {
                      detail: { up: p, down: m, position: t },
                      bubbles: !1,
                    })
                  ),
                  p &&
                    !v &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  m &&
                    !g &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  (g = m),
                  (v = p);
              })();
            }));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", w),
        window.addEventListener("theme:scroll:unlock", f);
    })(),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    document.addEventListener(
      "load",
      (t) => {
        "img" == t.target.tagName.toLowerCase() &&
          t.target.classList.contains(A) &&
          (t.target.classList.remove(A),
          t.target.parentNode.classList.remove(A),
          t.target.parentNode.parentNode.classList.contains(A) &&
            t.target.parentNode.parentNode.classList.remove(A));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      S(document),
        d(document),
        L(document),
        document.querySelectorAll(k).forEach((t) => {
          t.complete &&
            (t.classList.remove(A),
            t.parentNode.classList.remove(A),
            t.parentNode.parentNode.classList.contains(A) &&
              t.parentNode.parentNode.classList.remove(A));
        }),
        document.body.classList.add("is-loaded"),
        l(),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode &&
            document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      d(e), L(e), S(document);
    });
  const F = "is-focused",
    _ = "[data-skip-content]",
    B = 'a[href="#"]';
  function $(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  (window.a11y = new (class {
    init() {
      (this.a11y = window.theme.a11y),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(_)),
        (this.linkesWithOnlyHash = document.querySelectorAll(B)),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(F);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add(F);
        });
    }
    constructor() {
      this.init();
    }
  })()),
    (window.theme.waitForAnimationEnd = function (t) {
      return new Promise((e) => {
        null == t ||
          t.addEventListener("animationend", function i(s) {
            s.target == t && (t.removeEventListener("animationend", i), e());
          });
      });
    }),
    (window.theme.waitForAllAnimationsEnd = function (t) {
      return new Promise((e, i) => {
        const s = t.querySelectorAll("[data-aos]");
        let o = 0;
        function r(t) {
          o++,
            o === s.length && e(),
            t.target.removeEventListener("animationend", r);
        }
        s.forEach((t) => {
          t.addEventListener("animationend", r);
        }),
          o || i();
      });
    }),
    ($.prototype = Error.prototype);
  const W = "is-animated",
    N = "is-added",
    R = "is-disabled",
    V = "is-empty",
    U = "is-hidden",
    z = "is-hiding",
    j = "is-loading",
    J = "is-open",
    X = "is-removed",
    Q = "is-success",
    K = "is-visible",
    Y = "is-expanded",
    G = "is-updated",
    Z = "variant--soldout",
    tt = "variant--unavailable",
    et = {
      apiContent: "[data-api-content]",
      apiLineItems: "[data-api-line-items]",
      apiUpsellItems: "[data-api-upsell-items]",
      apiBundleItems: "[data-api-bundle-items]",
      apiCartPrice: "[data-api-cart-price]",
      animation: "[data-animation]",
      additionalCheckoutButtons: ".additional-checkout-buttons",
      buttonSkipUpsellProduct: "[data-skip-upsell-product]",
      cartBarAdd: "[data-add-to-cart-bar]",
      cartCloseError: "[data-cart-error-close]",
      cartDrawer: "cart-drawer",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartEmpty: "[data-cart-empty]",
      cartErrors: "[data-cart-errors]",
      cartItemRemove: "[data-item-remove]",
      cartPage: "[data-cart-page]",
      cartForm: "[data-cart-form]",
      cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
      cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
      cartCheckoutButton: "[data-cart-checkout-button]",
      cartTotal: "[data-cart-total]",
      checkoutButtons: "[data-checkout-buttons]",
      errorMessage: "[data-error-message]",
      formCloseError: "[data-close-error]",
      formErrorsContainer: "[data-cart-errors-container]",
      formWrapper: "[data-form-wrapper]",
      freeShipping: "[data-free-shipping]",
      freeShippingGraph: "[data-progress-graph]",
      freeShippingProgress: "[data-progress-bar]",
      headerWrapper: "[data-header-wrapper]",
      item: "[data-item]",
      itemsHolder: "[data-items-holder]",
      leftToSpend: "[data-left-to-spend]",
      navDrawer: "[data-drawer]",
      outerSection: "[data-section-id]",
      priceHolder: "[data-cart-price-holder]",
      quickAddHolder: "[data-quick-add-holder]",
      quickAddModal: "[data-quick-add-modal]",
      qtyInput: 'input[name="updates[]"]',
      upsellProductsHolder: "[data-upsell-products]",
      bundleProductsHolder: "[data-bundle-products]",
      upsellWidget: "[data-upsell-widget]",
      bundleWidget: "[data-bundle-widget]",
      termsErrorMessage: "[data-terms-error-message]",
      collapsibleBody: "[data-collapsible-body]",
      discountInput: "[data-discount-input]",
      discountField: "[data-discount-field]",
      discountButton: "[data-apply-discount]",
      discountBody: "[data-discount-body]",
      discountCode: "[data-discount-code]",
      discountErrorMessage: "[data-discount-error-message]",
      removeDiscount: "[data-remove-discount]",
      noscript: "noscript",
    },
    it = "data-cart-total",
    st = "disabled",
    ot = "data-free-shipping",
    rt = "data-free-shipping-limit",
    // --- ADDED ---
    tiersAttr = "data-free-shipping-tiers",   // on the .free-shipping wrapper
    tierMsgSel = "[data-tier-message]",   // target element for step message
    prodHandleAttr = "data-product-handle",  // optional attr on each [data-item]
    markersSel = "[data-markers]",
    trackSel = "[data-track]",
    nt = "data-item",
    at = "data-item-index",
    lt = "data-item-title",
    dt = "open",
    ct = "data-quick-add-holder",
    ht = "data-scroll-locked",
    ut = "data-upsell-auto-open",
    pt = "name",
    mt = "data-max-inventory-reached",
    vt = "data-error-message-position";
  let gt = class extends HTMLElement {
    connectedCallback() {
      (this.cartPage = document.querySelector(et.cartPage)),
        (this.cartForm = document.querySelector(et.cartForm)),
        (this.cartDrawer = document.querySelector(et.cartDrawer)),
        (this.cartEmpty = document.querySelector(et.cartEmpty)),
        (this.cartTermsCheckbox = document.querySelector(et.cartTermsCheckbox)),
        (this.cartCheckoutButtonWrapper = document.querySelector(
          et.cartCheckoutButtonWrapper
        )),
        (this.cartCheckoutButton = document.querySelector(
          et.cartCheckoutButton
        )),
        (this.checkoutButtons = document.querySelector(et.checkoutButtons)),
        (this.itemsHolder = document.querySelector(et.itemsHolder)),
        (this.priceHolder = document.querySelector(et.priceHolder)),
        (this.items = document.querySelectorAll(et.item)),
        (this.cartTotal = document.querySelector(et.cartTotal)),
        (this.freeShipping = document.querySelectorAll(et.freeShipping)),
        (this.cartErrorHolder = document.querySelector(et.cartErrors)),
        (this.cartCloseErrorMessage = document.querySelector(
          et.cartCloseError
        )),
        (this.headerWrapper = document.querySelector(et.headerWrapper)),
        (this.navDrawer = document.querySelector(et.navDrawer)),
        (this.upsellProductsHolder = document.querySelector(
          et.upsellProductsHolder
        )),
        (this.bundleProductsHolder = document.querySelector(
          et.bundleProductsHolder
        )),
        (this.subtotal = window.theme.subtotal),
        (this.discountInput = document.querySelector(et.discountInput)),
        (this.discountField = document.querySelector(et.discountField)),
        (this.discountButton = document.querySelector(et.discountButton)),
        (this.hasDiscountBlock = !!document.querySelector(et.discountButton)),
        (this.discountErrorMessage = document.querySelector(
          et.discountErrorMessage
        )),
        (this.existingDiscountCodes = []),
        (this.discounts = document.querySelectorAll(et.discountBody)),
        (this.cart = this.cartDrawer || this.cartPage),
        this.hasDiscountBlock &&
          (this.discountButton.addEventListener("click", (t) => {
            t.preventDefault();
            const e = this.discountInput.value.trim();
            (this.discountInput.value = ""), e && this.applyDiscount(e);
          }),
          this.bindDiscountEventListeners()),
        (this.animateItems = this.animateItems.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        "drawer" == theme.settings.cartType &&
          (document.addEventListener(
            "theme:cart-drawer:open",
            this.animateItems
          ),
          document.addEventListener(
            "theme:cart-drawer:close",
            this.onCartDrawerClose
          )),
        (this.skipUpsellProductsArray = []),
        (this.skipBundleProductsArray = []),
        this.skipUpsellOrBundleProductEvent(),
        this.checkSkippedUpsellOrBundleProductsFromStorage(),
        this.toggleCartUpsellOrBundleWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 *
            Number(this.freeShipping[0].getAttribute(rt)) *
            window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        (this.build = this.build.bind(this)),
        (this.updateCart = this.updateCart.bind(this)),
        (this.productAddCallback = this.productAddCallback.bind(this)),
        (this.formSubmitHandler = window.theme.throttle(
          this.formSubmitHandler.bind(this),
          50
        )),
        this.cartPage && this.animateItems(),
        this.cart &&
          ((this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.cartCount = this.getCartItemCount())),
        (this.toggleClassesOnContainers =
          this.toggleClassesOnContainers.bind(this)),
        (this.totalItems = this.items.length),
        (this.showCannotAddMoreInCart = !1),
        (this.cartUpdateFailed = !1),
        (this.discountError = !1),
        this.cartEvents(),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        document.addEventListener("theme:product:add", this.productAddCallback),
        document.addEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.addEventListener(
          "theme:cart:refresh",
          this.getCart.bind(this)
        );
    }
    disconnectedCallback() {
      document.removeEventListener("theme:cart:add", this.cartAddEvent),
        document.removeEventListener("theme:cart:refresh", this.cartAddEvent),
        document.removeEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        document.removeEventListener(
          "theme:product:add",
          this.productAddCallback
        ),
        document.removeEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.documentElement.hasAttribute(ht) &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }

    getTierIconSVG() {
  return `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7803 8.28033C13.0732 7.98744 13.0732 7.51256 12.7803 7.21967C12.4874 6.92678 12.0126 6.92678 11.7197 7.21967L7.21967 11.7197C6.92678 12.0126 6.92678 12.4874 7.21967 12.7803C7.51256 13.0732 7.98744 13.0732 8.28033 12.7803L12.7803 8.28033Z" fill="#4A4A4A"></path><path d="M9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8Z" fill="#4A4A4A"></path><path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" fill="#4A4A4A"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0943 3.51441C11.2723 1.72371 8.72775 1.72371 7.90568 3.51441C7.73011 3.89684 7.28948 4.07936 6.89491 3.93308C5.04741 3.24816 3.24816 5.04741 3.93308 6.89491C4.07936 7.28948 3.89684 7.73011 3.51441 7.90568C1.72371 8.72775 1.72371 11.2723 3.51441 12.0943C3.89684 12.2699 4.07936 12.7105 3.93308 13.1051C3.24816 14.9526 5.04741 16.7519 6.89491 16.0669C7.28948 15.9207 7.73011 16.1032 7.90568 16.4856C8.72775 18.2763 11.2723 18.2763 12.0943 16.4856C12.2699 16.1032 12.7105 15.9207 13.1051 16.0669C14.9526 16.7519 16.7519 14.9526 16.0669 13.1051C15.9207 12.7105 16.1032 12.2699 16.4856 12.0943C18.2763 11.2723 18.2763 8.72775 16.4856 7.90568C16.1032 7.73011 15.9207 7.28948 16.0669 6.89491C16.7519 5.04741 14.9526 3.24816 13.1051 3.93308C12.7105 4.07936 12.2699 3.89684 12.0943 3.51441ZM9.26889 4.14023C9.55587 3.51511 10.4441 3.51511 10.7311 4.14023C11.2341 5.23573 12.4963 5.75856 13.6265 5.33954C14.2715 5.10044 14.8996 5.72855 14.6605 6.3735C14.2415 7.50376 14.7643 8.76597 15.8598 9.26889C16.4849 9.55587 16.4849 10.4441 15.8598 10.7311C14.7643 11.2341 14.2415 12.4963 14.6605 13.6265C14.8996 14.2715 14.2715 14.8996 13.6265 14.6605C12.4963 14.2415 11.2341 14.7643 10.7311 15.8598C10.4441 16.4849 9.55587 16.4849 9.26889 15.8598C8.76597 14.7643 7.50376 14.2415 6.3735 14.6605C5.72855 14.8996 5.10044 14.2715 5.33954 13.6265C5.75856 12.4963 5.23573 11.2341 4.14023 10.7311C3.51511 10.4441 3.51511 9.55587 4.14023 9.26889C5.23573 8.76597 5.75856 7.50376 5.33954 6.3735C5.10044 5.72855 5.72855 5.10044 6.3735 5.33954C7.50376 5.75856 8.76597 5.23573 9.26889 4.14023Z" fill="#4A4A4A"></path></svg>`;
}

// Create markers once per widget (or if count changed)
// (keep your selectors/constants from earlier)
ensureTierMarkers(wrap, tiers) {
  const ul = wrap?.querySelector?.(markersSel);
  if (!ul || !Array.isArray(tiers) || tiers.length === 0) return;

  // Always rebuild
  ul.innerHTML = "";

  // Defensive copy + sort ascending by threshold
  const sorted = [...tiers].sort((a, b) => (a.threshold ?? 0) - (b.threshold ?? 0));

  const thresholds = sorted.map(t => Number(t.threshold) || 0);
  // Use 0 -> max so markers align with a 0..max linear progress scale
  const baseMin = 0;
  const max = Math.max(...thresholds, 0);
  const denom = (max - baseMin) || 1; // avoid /0

  const frag = document.createDocumentFragment();

  sorted.forEach((t, idx) => {
    const thr = Number(t.threshold) || 0;
    // Position by distance to achieve threshold on 0..max (no clamping)
    const pct = ((thr - baseMin) / denom) * 100;

    const li = document.createElement("li");
    li.className = "free-shipping__marker";
    li.style.left = pct + "%";
    li.setAttribute("data-tier-idx", String(idx));
    li.setAttribute("data-threshold", String(thr)); // for activation logic downstream

    // Accessibility: announce tier with label + threshold as a fallback
    const ariaLabelParts = [];
    if (t.label) ariaLabelParts.push(String(t.label));
    if (Number.isFinite(thr)) ariaLabelParts.push(String(thr));
    li.setAttribute("aria-label", ariaLabelParts.join(" - ") || "Tier");

    // Bullet container
    const bullet = document.createElement("div");
    bullet.className = "fs-bullet";
    bullet.setAttribute("aria-hidden", "true");

    if (t.icon) {
      const img = document.createElement("img");
      img.src = String(t.icon);
      img.alt = (t.label || "tier").replace(/"/g, "&quot;");
      bullet.appendChild(img);
    } else {
      bullet.innerHTML = (typeof this?.getTierIconSVG === "function")
        ? this.getTierIconSVG()
        : "";
    }

    li.appendChild(bullet);

    if (t.label) {
      const label = document.createElement("div");
      label.className = "fs-label";
      label.textContent = String(t.label).replace(/<br\s*\/?>/gi, "\n");
      label.style.whiteSpace = "pre-line";
      li.appendChild(label);
    }

    frag.appendChild(li);
  });

  ul.appendChild(frag);
}




// Activate markers by comparing the real progress (0..100) to each marker's % position.
updateMarkersState(wrap, overallPercent /* 0..100 */, tiers) {
  const ul = wrap.querySelector(markersSel);
  if (!ul) return;

  const EPS = 1e-9; // tolerance for float noise (not "rounding")

  const items = Array.from(ul.querySelectorAll(".free-shipping__marker"));

  // Read each marker's % position from the inline left set in ensureTierMarkers.
  // (If you later add data-pos, this also supports it.)
  const pairs = items.map((el, i) => {
    let p = parseFloat(el.style.left);
    if (!Number.isFinite(p)) p = parseFloat(el.dataset.pos); // optional fallback
    return { i, p: Number.isFinite(p) ? p : 0 };
  });

  // Ensure ascending by position (defensive; DOM is usually already sorted).
  pairs.sort((a, b) => a.p - b.p);

  // Count how many markers are at or behind the current progress.
  // (progress >= position) => "done"
  let doneCount = 0;
  for (let k = 0; k < pairs.length; k++) {
    if (overallPercent + EPS >= pairs[k].p) doneCount++;
    else break;
  }

  // Clear & set classes: previous = done, next = active
  items.forEach(el => { el.classList.remove("done", "active"); });
  for (let k = 0; k < doneCount; k++) items[pairs[k].i].classList.add("done");
  if (doneCount < pairs.length) items[pairs[doneCount].i].classList.add("active");
}

    onCartDrawerClose() {
      var t, e;
      (this.resetAnimatedItems(),
      (null === (t = this.cartDrawer) || void 0 === t
        ? void 0
        : t.classList.contains(J)) && this.cart.classList.remove(G),
      this.cartEmpty.classList.remove(G),
      this.cartErrorHolder.classList.remove(Y),
      this.cart.querySelectorAll(et.animation).forEach((t) => {
        const e = () => {
          t.classList.remove(z), t.removeEventListener("animationend", e);
        };
        t.classList.add(z), t.addEventListener("animationend", e);
      }),
      this.hasDiscountBlock) &&
        (null === (e = this.discountErrorMessage) ||
          void 0 === e ||
          e.classList.add("hidden"));
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(et.item)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart(
              { id: e.detail.id, quantity: e.detail.quantity },
              t
            );
          });
        });
    }
    cartRemoveEvents() {
      document.querySelectorAll(et.cartItemRemove).forEach((t) => {
        const e = t.closest(et.item);
        t.addEventListener("click", (i) => {
          i.preventDefault(),
            t.classList.contains(R) ||
              this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (t) => {
            t.preventDefault(), this.cartErrorHolder.classList.remove(Y);
          });
    }
    cartAddEvent(t) {
      let e = "",
        i = t.detail.button;
      if (i.hasAttribute("disabled")) return;
      const s = i.closest("form");
      if (!s.checkValidity()) return void s.reportValidity();
      e = new FormData(s);
      if (
        ([...s.elements].some((t) => t.closest(et.noscript)) &&
          (e = this.handleFormDataDuplicates([...s.elements], e)),
        null !== s && s.querySelector('[type="file"]'))
      )
        return;
      "drawer" === theme.settings.cartType &&
        this.cartDrawer &&
        t.preventDefault();
      const o = s.getAttribute(mt),
        r = s.getAttribute(vt);
      (this.showCannotAddMoreInCart = !1),
        "true" === o && "cart" === r && (this.showCannotAddMoreInCart = !0),
        this.addToCart(e, i);
    }
    bindDiscountEventListeners() {
      this.hasDiscountBlock &&
        ((this.discounts = document.querySelectorAll(et.discountBody)),
        this.discounts.forEach((t) => {
          const e = t.dataset.discountCode;
          this.existingDiscountCodes.includes(e) ||
            this.existingDiscountCodes.push(e);
          const i = t.querySelector(et.removeDiscount);
          i &&
            (i.removeEventListener("click", this.handleRemoveDiscount),
            i.addEventListener("click", (t) => {
              t.preventDefault(), this.removeDiscount(e);
            }));
        }));
    }
    applyDiscount(t) {
      if (this.existingDiscountCodes.includes(t))
        return (
          this.discountErrorMessage.classList.remove("hidden"),
          void (this.discountErrorMessage.textContent =
            window.theme.strings.discount_already_applied)
        );
      this.existingDiscountCodes.push(t),
        this.updateCartDiscounts(this.existingDiscountCodes.join(","));
    }
    removeDiscount(t) {
      this.existingDiscountCodes.includes(t) &&
        ((this.existingDiscountCodes = this.existingDiscountCodes.filter(
          (e) => e !== t
        )),
        this.updateCartDiscounts(this.existingDiscountCodes.join(",")));
    }
    updateCartDiscounts(t) {
      var e;
      const i =
        null ===
          (e = t
            .split(",")
            .filter((t) => t)
            .pop()) || void 0 === e
          ? void 0
          : e.trim();
      this.disableCartButtons(),
        this.discountErrorMessage.classList.add("hidden"),
        fetch(window.theme.routes.cart_update_url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ discount: t }),
        })
          .then((t) => {
            if (!t.ok) throw new Error(`HTTP error! status: ${t.status}`);
            return t.text();
          })
          .then((t) => {
            let e;
            try {
              e = JSON.parse(t);
            } catch (e) {
              throw (
                (console.error("Failed to parse cart update response:", t),
                new Error("Invalid JSON response from server."))
              );
            }
            if (i) {
              e.discount_codes &&
              Array.isArray(e.discount_codes) &&
              e.discount_codes.some((t) => t.code === i && t.applicable)
                ? (this.discountError = !1)
                : ((this.discountError = !0),
                  (this.existingDiscountCodes =
                    this.existingDiscountCodes.filter((t) => t !== i)));
            } else this.discountError = !1;
            this.getCart();
          })
          .catch((t) => {
            console.log(t);
          });
    }
    handleFormDataDuplicates(t, e) {
      return t.length && "object" == typeof e
        ? (t.forEach((t) => {
            if (t.closest(et.noscript)) {
              const i = t.getAttribute(pt),
                s = t.value;
              if (i) {
                const t = e.getAll(i);
                t.length > 1 && t.splice(t.indexOf(s), 1),
                  e.delete(i),
                  e.set(i, t[0]);
              }
            }
          }),
          e)
        : e;
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.removeEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.addEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      const t = document.querySelector(et.cartTermsCheckbox).checked,
        e = document.querySelector(et.termsErrorMessage);
      if (t) e.classList.remove(Y), this.cartCheckoutButton.removeAttribute(st);
      else {
        if (document.querySelector(et.termsErrorMessage).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(st, !0),
          e.classList.add(Y);
      }
    }
    formErrorsEvents(t) {
      const e = t.querySelector(et.formCloseError);
      null == e ||
        e.addEventListener("click", (e) => {
          e.preventDefault(), t && t.classList.remove(K);
        });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          const e = document.createElement("div");
          e.innerHTML = t;
          const i = e.querySelector(et.apiContent);
          this.build(i);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      this.cart && this.cart.classList.add(j);
      const i = null == e ? void 0 : e.closest(et.quickAddHolder);
      e && (e.classList.add(j), (e.disabled = !0)),
        i && i.classList.add(K),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            (t.status &&
              (this.addToCartError(t, e),
              e && (e.classList.remove(j), (e.disabled = !1)),
              !this.showCannotAddMoreInCart)) ||
              (this.cart
                ? (e &&
                    (e.classList.remove(j),
                    e.classList.add(N),
                    e.dispatchEvent(
                      new CustomEvent("theme:product:add", {
                        detail: { response: t, button: e },
                        bubbles: !0,
                      })
                    )),
                  "page" === theme.settings.cartType &&
                    (window.location = theme.routes.cart_url),
                  this.getCart())
                : (window.location = theme.routes.cart_url));
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(j);
      let i = t.quantity;
      null !== e && (i ? e.classList.add(j) : e.classList.add(X)),
        this.disableCartButtons();
      const s = this.cart.querySelector(`[${nt}="${t.id}"]`) || e,
        o = (null == s ? void 0 : s.hasAttribute(at))
          ? parseInt(s.getAttribute(at))
          : 0,
        r = (null == s ? void 0 : s.hasAttribute(lt))
          ? s.getAttribute(lt)
          : null;
      if (0 === o) return;
      const n = { line: o, quantity: i };
      fetch(theme.routes.cart_change_url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(n),
      })
        .then((t) => t.text())
        .then((t) => {
          if (JSON.parse(t).errors)
            return (
              (this.cartUpdateFailed = !0),
              this.updateErrorText(r),
              this.toggleErrorMessage(),
              this.resetLineItem(e),
              this.enableCartButtons(),
              void this.bindDiscountEventListeners()
            );
          this.getCart();
        })
        .catch((t) => {
          console.log(t), this.enableCartButtons();
        });
    }
    resetLineItem(t) {
      const e = t.querySelector(et.qtyInput),
        i = e.getAttribute("value");
      (e.value = i), t.classList.remove(j);
    }
    disableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${et.cartItemRemove}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(R), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(st, !0);
          });
    }
    enableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${et.cartItemRemove}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(R), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(st);
          }),
        this.cart.classList.remove(j);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector(et.errorMessage).innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(
          Y,
          this.cartUpdateFailed || this.showCannotAddMoreInCart
        ),
        (this.showCannotAddMoreInCart = !1),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new $({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    hideAddToCartErrorMessage() {
      const t = this.button.closest(et.upsellHolder)
          ? this.button.closest(et.upsellHolder)
          : this.button.closest(et.productForm),
        e = null == t ? void 0 : t.querySelector(et.formErrorsContainer);
      null == e || e.classList.remove(K);
    }
    addToCartError(t, e) {
      var i;
      if (this.showCannotAddMoreInCart) return;
      if (null !== e) {
        const i =
          e.closest(et.outerSection) ||
          e.closest(et.quickAddHolder) ||
          e.closest(et.quickAddModal);
        let s = null == i ? void 0 : i.querySelector(et.formErrorsContainer);
        const o = e.closest(et.quickAddHolder);
        if (
          (o &&
            o.querySelector(et.formErrorsContainer) &&
            (s = o.querySelector(et.formErrorsContainer)),
          s)
        ) {
          let e = `${t.message}: ${t.description}`;
          t.message == t.description && (e = t.message),
            (s.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            s.classList.add(K),
            this.formErrorsEvents(s);
        }
        e.dispatchEvent(
          new CustomEvent("theme:product:add-error", {
            detail: { response: t, button: e },
            bubbles: !0,
          })
        );
      }
      const s = null == e ? void 0 : e.closest(et.quickAddHolder);
      s &&
        s.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: s,
            },
          })
        ),
        null === (i = this.cart) || void 0 === i || i.classList.remove(j);
    }
    productAddCallback(t) {
      let e = [],
        i = null;
      const s = "theme:product:add-error" == t.type,
        o = t.detail.button,
        r = document.querySelector(et.cartBarAdd);
      e.push(o),
        (i = o.closest(et.quickAddHolder)),
        r && e.push(r),
        e.forEach((t) => {
          t.classList.remove(j), s || t.classList.add(N);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            var e, i;
            t.classList.remove(N);
            (null === (e = t.closest(et.formWrapper)) || void 0 === e
              ? void 0
              : e.classList.contains(Z)) ||
              (null === (i = t.closest(et.formWrapper)) || void 0 === i
                ? void 0
                : i.classList.contains(tt)) ||
              (t.disabled = !1);
          }),
            null == i || i.classList.remove(K);
        }, 1e3);
    }
    toggleClassesOnContainers() {
      const t = this.hasItemsInCart();
      this.cart.classList.toggle(V, !t),
        !t &&
          this.cartDrawer &&
          setTimeout(() => {
            this.a11y.trapFocus(this.cartDrawer, {
              elementToFocus: this.cartDrawer.querySelector(et.cartDrawerClose),
            });
          }, 100);
    }
    build(t) {
      var e;
      const i = t.querySelector(et.apiLineItems),
        s = t.querySelector(et.apiUpsellItems),
        o = t.querySelector(et.apiBundleItems),
        r = Boolean(null === i && null === s && null === o),
        n = t.querySelector(et.apiCartPrice),
        a = t.querySelector(et.cartTotal);
      this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
        r
          ? ((this.itemsHolder.innerHTML = t.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = ""),
            this.bundleProductsHolder &&
              (this.bundleProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = i.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = s.innerHTML),
            this.bundleProductsHolder &&
              (this.bundleProductsHolder.innerHTML = o.innerHTML),
            this.skipUpsellOrBundleProductEvent(),
            this.checkSkippedUpsellOrBundleProductsFromStorage(),
            this.toggleCartUpsellOrBundleWidgetVisibility()),
        (this.newTotalItems =
          i && i.querySelectorAll(et.item).length
            ? i.querySelectorAll(et.item).length
            : 0),
        (this.subtotal =
          a && a.hasAttribute(it) ? parseInt(a.getAttribute(it)) : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            bubbles: !0,
            detail: { cartCount: this.cartCount },
          })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : window.theme.formatMoney(
                this.subtotal,
                theme.moneyWithCurrencyFormat
              )),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        (null === (e = this.cartDrawer) || void 0 === e
          ? void 0
          : e.classList.contains(J)) && this.cart.classList.add(G),
        this.cart.classList.remove(j),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(et.animation).forEach((t) => {
            t.classList.remove(W);
          }),
        this.hasDiscountBlock &&
          (this.discountField &&
            (this.discountField.value = this.existingDiscountCodes.join(",")),
          this.discountError
            ? ((this.discountErrorMessage.textContent =
                window.theme.strings.discount_not_applicable),
              this.discountErrorMessage.classList.remove("hidden"))
            : this.discountErrorMessage.classList.add("hidden")),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        this.animateItems(),
        this.bindDiscountEventListeners(),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: !0 })
        );
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(et.qtyInput)).reduce(
        (t, e) => t + parseInt(e.value),
        0
      );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(_subtotal) {
  // Re-query in case DOM was rebuilt
  this.freeShipping = document.querySelectorAll(et.freeShipping);
  if (!this.freeShipping.length) return;

  const metrics = this.getCartMetrics();

  this.freeShipping.forEach((wrap) => {
    const result = this.evaluateTiersForWidget(wrap, metrics);

    // Success state
    wrap.classList.toggle(Q, result.completed === true);

    // In tiers mode, populate the tier message; otherwise keep default
    const msgEl = wrap.querySelector(tierMsgSel);
    if (result.hasTiers && msgEl) {
      if (result.completed) {
        // hide tier message when the success message is shown
        msgEl.textContent = "";
      } else {
        msgEl.innerHTML = result.messageHTML || "";
      }
    }

    // In single-limit mode, keep updating the legacy [data-left-to-spend]
    if (!result.hasTiers) {
      const leftEl = wrap.querySelector(et.leftToSpend);
      if (leftEl && result.leftDisplay != null) {
        leftEl.innerHTML = result.leftDisplay;
      }
    }
  });
}

updateProgress() {
  // Keep selector fresh (your build() re-renders HTML)
  this.freeShipping = document.querySelectorAll(et.freeShipping);
  if (!this.freeShipping.length) return;

  const metrics = this.getCartMetrics();
  const circ = this.circumference || (28 * Math.PI);



  this.freeShipping.forEach((wrap) => {
    const res = this.evaluateTiersForWidget(wrap, metrics);
    const tiers = this.parseTierConfig(wrap);
    console.log(tiers);
    // Linear progress bar
    const bar = wrap.querySelector(et.freeShippingProgress);
    if (bar) {
      bar.value = res.percent;
    }

    // Circle graph stroke dash
    const graph = wrap.querySelector(et.freeShippingGraph);
    if (graph) {
      const offset = circ - (res.percent / 100) * circ;
      graph.style.setProperty("--stroke-dashoffset", `${offset}`);
    }

    if (tiers && tiers.length) {
      this.ensureTierMarkers(wrap, tiers);
      this.updateMarkersState(wrap, res.percent, tiers);
    }
  });
}

    skipUpsellOrBundleProductEvent() {
      var t, e;
      if (
        null === this.upsellProductsHolder &&
        null === this.bundleProductsHolder
      )
        return;
      const i = [
        ...((null === (t = this.upsellProductsHolder) || void 0 === t
          ? void 0
          : t.querySelectorAll(et.buttonSkipUpsellProduct)) || []),
        ...((null === (e = this.bundleProductsHolder) || void 0 === e
          ? void 0
          : e.querySelectorAll(et.buttonSkipUpsellProduct)) || []),
      ];
      i.length &&
        i.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            const i = t.closest(et.quickAddHolder).getAttribute(ct),
              s = !!t.closest(et.upsellWidget),
              o = !!t.closest(et.bundleWidget);
            s &&
              !this.skipUpsellProductsArray.includes(i) &&
              (this.skipUpsellProductsArray.push(i),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellOrBundleProduct(i, "upsell")),
              o &&
                !this.skipBundleProductsArray.includes(i) &&
                (this.skipBundleProductsArray.push(i),
                window.sessionStorage.setItem(
                  "skip_bundle_products",
                  this.skipBundleProductsArray
                ),
                this.removeUpsellOrBundleProduct(i, "bundle")),
              this.toggleCartUpsellOrBundleWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellOrBundleProductsFromStorage() {
      [
        {
          key: "upsell",
          storageKey: "skip_upsell_products",
          array: this.skipUpsellProductsArray,
        },
        {
          key: "bundle",
          storageKey: "skip_bundle_products",
          array: this.skipBundleProductsArray,
        },
      ].forEach(({ key: t, storageKey: e, array: i }) => {
        const s = window.sessionStorage.getItem(e);
        s &&
          s.split(",").forEach((e) => {
            i.includes(e) || i.push(e), this.removeUpsellOrBundleProduct(e, t);
          });
      });
    }
    removeUpsellOrBundleProduct(t, e = "upsell") {
      const i = {
        upsell: this.upsellProductsHolder,
        bundle: this.bundleProductsHolder,
      }[e];
      if (!i) return;
      const s = i.querySelector(`[${ct}="${t}"]`);
      s && s.parentNode && s.parentNode.remove();
    }
    toggleCartUpsellOrBundleWidgetVisibility() {
      var t, e, i, s;
      if (!this.upsellProductsHolder && !this.bundleProductsHolder) return;
      const o =
          null === (t = this.upsellProductsHolder) || void 0 === t
            ? void 0
            : t.querySelectorAll(et.quickAddHolder),
        r =
          null === (e = this.bundleProductsHolder) || void 0 === e
            ? void 0
            : e.querySelectorAll(et.quickAddHolder),
        n =
          null === (i = this.upsellProductsHolder) || void 0 === i
            ? void 0
            : i.closest(et.upsellWidget),
        a =
          null === (s = this.bundleProductsHolder) || void 0 === s
            ? void 0
            : s.closest(et.bundleWidget);
      if (!n && !a) return;
      const l = (t, e, i) => {
        if (
          t &&
          (t.classList.toggle(U, !e.length),
          e.length && !t.hasAttribute(dt) && t.hasAttribute(i))
        ) {
          t.setAttribute(dt, !0);
          const e = t.querySelector(et.collapsibleBody);
          e && (e.style.height = "auto");
        }
      };
      l(n, o, ut), l(a, r, ut);
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(et.animation).forEach((t) => {
        t.classList.remove(W), t.classList.remove(z);
      });
    }
    animateItems(t) {
      requestAnimationFrame(() => {
        let e = this.cart;
        t && t.detail && t.detail.target && (e = t.detail.target),
          null == e ||
            e.querySelectorAll(et.animation).forEach((t) => {
              t.classList.add(W);
            });
      });
    }



    // --- ADDED: helper to safely parse per-widget tier JSON ---
parseTierConfig(el) {
  const raw = el.getAttribute(tiersAttr);
  if (!raw) return null;
  try {
    // Because the attribute is HTML-escaped, decode basic entities:
    const decoded = raw
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">");
    const tiers = JSON.parse(decoded);
    // Normalize minimal schema
    return Array.isArray(tiers) ? tiers.map((t) => {
      const o = Object.assign({}, t);
      o.type = (o.type || "amount").toLowerCase();
      return o;
    }) : null;
  } catch (e) {
    console.warn("Invalid tiers JSON:", e);
    return null;
  }
}

// --- ADDED: gather cart metrics once per update ---
getCartMetrics() {
  const qty = this.getCartItemCount();       // you already have this
  const subtotal = this.subtotal || 0;       // in cents
  const items = Array.from(this.cart.querySelectorAll(et.item));
  // Build a simple tally of product handles -> quantity
  const tally = {};
  items.forEach((itemEl) => {
    // qty from the input
    const qEl = itemEl.querySelector(et.qtyInput);
    const q = qEl ? parseInt(qEl.value, 10) || 0 : 0;

    // handle from attribute or anchor href
    let handle = itemEl.getAttribute(prodHandleAttr);
    if (!handle) {
      const a = itemEl.querySelector('a[href*="/products/"]');
      if (a && a.getAttribute("href")) {
        const href = a.getAttribute("href");
        // Extract handle between /products/ and next slash or end
        const m = href.match(/\/products\/([^/?#]+)/i);
        if (m) handle = decodeURIComponent(m[1]);
      }
    }

    if (handle) {
      tally[handle] = (tally[handle] || 0) + q;
    }
  });

  return { qty, subtotal, tally };
}

// --- ADDED: convert one tier into progress + remaining info ---
evaluateTierProgress(tier, metrics) {
  const rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) ? Number(window.Shopify.currency.rate) : 1;
  let progress = 0;
  let remainingText = "";
  let remainingCount = 0;

  if (tier.type === "amount") {
    // threshold is in shop currency units; convert to cents & active currency
    const targetCents = Math.max(0, Math.round(100 * Number(tier.threshold || 0) * rate));
    const leftCents = Math.max(0, targetCents - metrics.subtotal);
    const fmt = window.theme && window.theme.formatMoney ? window.theme.formatMoney(leftCents, theme.moneyFormat) : (leftCents / 100).toFixed(2);
    progress = targetCents > 0 ? Math.min(1, metrics.subtotal / targetCents) : 1;
    remainingText = fmt.replace(".00", "");
    remainingCount = leftCents; // in cents
  } else if (tier.type === "quantity") {
    const target = Math.max(0, parseInt(tier.threshold || tier.min || 0, 10));
    const left = Math.max(0, target - metrics.qty);
    progress = target > 0 ? Math.min(1, metrics.qty / target) : 1;
    remainingText = String(left);
    remainingCount = left;
  } else if (tier.type === "products") {
    // requires "handles":[], and a "quantity" (# of units from that set)
    const handles = Array.isArray(tier.handles) ? tier.handles : [];
    const target = Math.max(1, parseInt(tier.quantity || tier.min || 1, 10));
    let have = 0;
    handles.forEach(h => { if (metrics.tally[h]) have += metrics.tally[h]; });
    const left = Math.max(0, target - have);
    progress = target > 0 ? Math.min(1, have / target) : 1;
    remainingText = String(left);
    remainingCount = left;
  } else {
    // Unknown type -> treat as 100% to avoid blocking
    progress = 1;
    remainingText = "";
    remainingCount = 0;
  }

  return { progress, remainingText, remainingCount };
}

// --- ADDED: format a tier message with placeholders ---
formatTierMessage(tier, data) {
  let msg = tier.message || "";
  // amount tier: ||amount|| = money; generic ||left|| also supported
  msg = msg.replace(/\|\|amount\|\|/g, data.remainingText);
  // quantity tier: ||qty_remaining|| or generic
  msg = msg.replace(/\|\|qty_remaining\|\|/g, data.remainingText);
  // products tier: ||product_remaining|| or generic
  msg = msg.replace(/\|\|product_remaining\|\|/g, data.remainingText);
  msg = msg.replace(/\|\|left\|\|/g, data.remainingText);
  return msg;
}

// --- ADDED: compute multi-tier status for one widget element ---
  evaluateTiersForWidget(el, metrics) {
    const tiers = this.parseTierConfig(el);
    if (!tiers || !tiers.length) {
      // single-tier fallback (unchanged)
      const limitAttr = el.getAttribute(rt);
      const limit = limitAttr ? Number(limitAttr) : 0;
      const rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) ? Number(window.Shopify.currency.rate) : 1;

      // NOTE: If metrics.subtotal is shop-cents, you likely should NOT multiply by rate here.
      const targetCents = Math.round(100 * limit * rate);
      const leftCents = Math.max(0, targetCents - metrics.subtotal);
      const fmt = (window.theme && window.theme.formatMoney)
        ? window.theme.formatMoney(leftCents, theme.moneyFormat)
        : (leftCents / 100).toFixed(2);

      const pct = targetCents > 0 ? Math.min(100, (metrics.subtotal / targetCents) * 100) : 100;

      return {
        hasTiers: false,
        completed: metrics.subtotal >= targetCents,
        percent: isNaN(pct) ? 100 : pct,
        messageHTML: null,
        leftDisplay: fmt.replace(".00","")
      };
    }

    // ---- Determine dominant type & its max goal ----
    const amountTiers   = tiers.filter(t => t.type === "amount");
    const quantityTiers = tiers.filter(t => t.type === "quantity");
    const productTiers  = tiers.filter(t => t.type === "products");

    let mode = null; // "amount" | "quantity" | "products"
    if (amountTiers.length) mode = "amount";
    else if (quantityTiers.length) mode = "quantity";
    else mode = "products";

    // Helper: get amount threshold in cents (avoid double converting!)
    const toTargetCents = (t) => {
      const rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
        ? Number(window.Shopify.currency.rate)
        : 1;

      // If metrics.subtotal is shop-cents, set rate = 1 here.
      return Math.max(0, Math.round(100 * Number(t.threshold || 0) * rate));
    };

    let goal = 0;       // numeric goal for the chosen mode
    let current = 0;    // current progress measured in the same unit

    if (mode === "amount") {
      goal = amountTiers.reduce((m, t) => Math.max(m, toTargetCents(t)), 0);
      current = Math.max(0, metrics.subtotal); // assume shop-cents; adjust if you use presentment
    } else if (mode === "quantity") {
      const q = (t) => Math.max(0, parseInt(t.threshold || t.min || 0, 10));
      goal = quantityTiers.reduce((m, t) => Math.max(m, q(t)), 0);
      current = Math.max(0, metrics.qty || 0);
    } else {
      // products mode: use the biggest required quantity across product tiers
      const q = (t) => Math.max(1, parseInt(t.quantity || t.min || 1, 10));
      goal = productTiers.reduce((m, t) => Math.max(m, q(t)), 0);
      // "current" is total matching count across all handles (union)
      let have = 0;
      productTiers.forEach(t => {
        const handles = Array.isArray(t.handles) ? t.handles : [];
        handles.forEach(h => { if (metrics.tally && metrics.tally[h]) have += metrics.tally[h]; });
      });
      current = Math.max(0, have);
    }

    // ---- Compute overall percent vs max goal ----
    const overall = goal > 0 ? (current / goal) * 100 : 100;

    // ---- Keep your existing "first unmet tier" message behavior ----
    let completedCount = 0;
    let currentMsg = "";
    let partial = 0;

    for (let i = 0; i < tiers.length; i++) {
      const t = tiers[i];
      const step = this.evaluateTierProgress(t, metrics);

      if (step.progress >= 1) {
        completedCount += 1;
        continue;
      }
      partial = step.progress;
      currentMsg = this.formatTierMessage(t, step);
      break;
    }

    const done = completedCount === tiers.length;

    return {
      hasTiers: true,
      completed: done,
      // Use overall vs max goal (optionally clamp for UI bounds)
      percent: Math.max(0, Math.min(100, overall)),
      messageHTML: currentMsg || "",
      leftDisplay: null
    };
  }



    constructor() {
      super(), (this.a11y = window.theme.a11y);
    }
  };
  customElements.get("cart-items") || customElements.define("cart-items", gt);
  const bt = "data-cart-count",
    wt = "data-limit";
  let ft = class extends HTMLElement {
    connectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    disconnectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    onCartChange(t) {
      (this.cartCount = t.detail.cartCount), this.update();
    }
    update() {
      if (null !== this.cartCount) {
        this.setAttribute(bt, this.cartCount);
        let t = this.cartCount;
        this.limit && this.cartCount >= this.limit && (t = "9+"),
          (this.innerText = t);
      }
    }
    constructor() {
      super(),
        (this.cartCount = null),
        (this.limit = this.getAttribute(wt)),
        (this.onCartChangeCallback = this.onCartChange.bind(this));
    }
  };
  customElements.get("cart-count") || customElements.define("cart-count", ft);
  const yt = "is-open",
    Et = "is-closing",
    Lt = "drawer--duplicate",
    St = "drawer-editor-error",
    At = {
      cartDrawer: "cart-drawer",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerSection: '[data-section-type="cart-drawer"]',
      cartDrawerInner: "[data-cart-drawer-inner]",
      shopifySection: ".shopify-section",
    },
    kt = "data-drawer-underlay";
  let Ct = class extends HTMLElement {
    connectedCallback() {
      const t = this.closest(At.shopifySection);
      if (window.theme.hasCartDrawer) {
        if (!window.Shopify.designMode) return void t.remove();
        {
          const t = document.createElement("div");
          t.classList.add(St),
            (t.innerText = "Cart drawer section already exists."),
            this.querySelector(`.${St}`) ||
              this.querySelector(At.cartDrawerInner).append(t),
            this.classList.add(Lt);
        }
      }
      (window.theme.hasCartDrawer = !0),
        this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
        document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
        document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.addEventListener(
          "theme:product:added",
          this.openCartDrawerOnProductAdded
        ),
        document.addEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        );
    }
    disconnectedCallback() {
      document.removeEventListener(
        "theme:product:added",
        this.openCartDrawerOnProductAdded
      ),
        document.removeEventListener(
          "theme:cart:toggle",
          this.toggleCartDrawer
        ),
        document.removeEventListener(
          "theme:quick-add:open",
          this.closeCartDrawer
        ),
        document.removeEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        ),
        document.querySelectorAll(At.cartDrawer).length <= 1 &&
          (window.theme.hasCartDrawer = !1),
        l();
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen || this.openCartDrawer();
    }
    openCartDrawerOnSelect(t) {
      (t.target.querySelector(At.shopifySection) ||
        t.target.closest(At.shopifySection) ||
        t.target) === this.cartDrawerSection && this.openCartDrawer(!0);
    }
    closeCartDrawerOnDeselect() {
      this.cartDrawerIsOpen && this.closeCartDrawer();
    }
    openCartDrawer(t = !1) {
      (!t && this.classList.contains(Lt)) ||
        ((this.cartDrawerIsOpen = !0),
        (this.onBodyClickEvent =
          this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:open", {
            detail: { target: this },
            bubbles: !0,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.classList.add(yt),
        this.observeAdditionalCheckoutButtons(),
        window.theme.waitForAnimationEnd(this.cartDrawerInner).then(() => {
          this.a11y.trapFocus(this, {
            elementToFocus: this.querySelector(At.cartDrawerClose),
          });
        }));
    }
    closeCartDrawer() {
      this.classList.contains(yt) &&
        (this.classList.add(Et),
        this.classList.remove(yt),
        (this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:close", { bubbles: !0 })
        ),
        this.a11y.removeTrapFocus(),
        this.a11y.autoFocusLastElement(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        window.theme.waitForAnimationEnd(this.cartDrawerInner).then(() => {
          this.classList.remove(Et);
        }));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    closeCartEvents() {
      this.cartDrawerClose.addEventListener("click", (t) => {
        t.preventDefault(), this.closeCartDrawer();
      }),
        this.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        });
    }
    onBodyClick(t) {
      t.target.hasAttribute(kt) && this.closeCartDrawer();
    }
    observeAdditionalCheckoutButtons() {
      const t = this.querySelector(At.additionalCheckoutButtons);
      if (t) {
        const e = new MutationObserver(() => {
          this.a11y.trapFocus(this, {
            elementToFocus: this.querySelector(At.cartDrawerClose),
          }),
            e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
    constructor() {
      super(),
        (this.cartDrawerIsOpen = !1),
        (this.cartDrawerClose = this.querySelector(At.cartDrawerClose)),
        (this.cartDrawerInner = this.querySelector(At.cartDrawerInner)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.openCartDrawerOnProductAdded =
          this.openCartDrawerOnProductAdded.bind(this)),
        (this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this)),
        (this.closeCartDrawerOnDeselect =
          this.closeCartDrawerOnDeselect.bind(this)),
        (this.cartDrawerSection = this.closest(At.shopifySection)),
        (this.a11y = window.theme.a11y),
        this.closeCartEvents();
    }
  };
  customElements.get("cart-drawer") || customElements.define("cart-drawer", Ct);
  let qt = class extends HTMLElement {
    connectedCallback() {
      (this.collapsibles = this.querySelectorAll("[data-collapsible]")),
        this.toggle(),
        document.addEventListener("theme:resize:width", this.toggle),
        this.collapsibles.forEach((t) => {
          const e = t.querySelector("[data-collapsible-trigger]"),
            i = t.querySelector("[data-collapsible-body]");
          null == e ||
            e.addEventListener("click", this.onCollapsibleClickBound),
            null == i ||
              i.addEventListener("transitionend", this.onTransitionEndBound);
        });
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.toggle),
        this.collapsibles &&
          this.collapsibles.forEach((t) => {
            const e = t.querySelector("[data-collapsible-trigger]"),
              i = t.querySelector("[data-collapsible-body]");
            null == e ||
              e.removeEventListener("click", this.onCollapsibleClickBound),
              null == i ||
                i.removeEventListener(
                  "transitionend",
                  this.onTransitionEndBound
                );
          }),
        (this.collapsibles = null);
    }
    toggle() {
      const t = !window.theme.isMobile();
      this.collapsibles.forEach((e) => {
        if (!e.hasAttribute("desktop") && !e.hasAttribute("mobile")) return;
        const i = e.hasAttribute("desktop")
            ? e.getAttribute("desktop")
            : "true",
          s = e.hasAttribute("mobile") ? e.getAttribute("mobile") : "true",
          o = (t && "true" == i) || (!t && "true" == s),
          r = e.querySelector("[data-collapsible-body]");
        o
          ? (e.removeAttribute("disabled"),
            e
              .querySelector("[data-collapsible-trigger]")
              .removeAttribute("tabindex"),
            e.removeAttribute("open"),
            this.setBodyHeight(r, ""))
          : (e.setAttribute("disabled", ""),
            e.setAttribute("open", !0),
            e
              .querySelector("[data-collapsible-trigger]")
              .setAttribute("tabindex", -1));
      });
    }
    open(t) {
      if ("true" == t.getAttribute("open")) return;
      const e = t.querySelector("[data-collapsible-body]"),
        i = t.querySelector("[data-collapsible-content]");
      t.setAttribute("open", !0), this.setBodyHeight(e, i.offsetHeight);
    }
    close(t) {
      if (!t.hasAttribute("open")) return;
      const e = t.querySelector("[data-collapsible-body]"),
        i = t.querySelector("[data-collapsible-content]");
      this.setBodyHeight(e, i.offsetHeight),
        t.setAttribute("open", !1),
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(e, 0);
          });
        });
    }
    setBodyHeight(t, e) {
      t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
    }
    onTransitionEnd(t) {
      const e = t.target,
        i = e.closest("[data-collapsible]");
      t.target === e &&
        i &&
        ("true" == i.getAttribute("open") && this.setBodyHeight(e, "auto"),
        "false" == i.getAttribute("open") &&
          (i.removeAttribute("open"), this.setBodyHeight(e, "")));
    }
    onCollapsibleClick(t) {
      t.preventDefault();
      const e = t.target.closest("[data-collapsible]");
      this.single &&
        this.collapsibles.forEach((t) => {
          t.hasAttribute("open") &&
            t != e &&
            requestAnimationFrame(() => {
              this.close(t);
            });
        }),
        e.hasAttribute("open") ? this.close(e) : this.open(e),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        ),
        e.dispatchEvent(
          new CustomEvent("theme:collapsible:toggle", { bubbles: !0 })
        );
    }
    constructor() {
      super(),
        (this.single = this.hasAttribute("single")),
        (this.toggle = this.toggle.bind(this)),
        (this.onCollapsibleClickBound = this.onCollapsibleClick.bind(this)),
        (this.onTransitionEndBound = this.onTransitionEnd.bind(this));
    }
  };
  customElements.get("collapsible-elements") ||
    customElements.define("collapsible-elements", qt);
  const Tt = "[data-deferred-media-button]",
    Mt = "video, model-viewer, iframe",
    xt = '[data-host="youtube"]',
    It = '[data-host="vimeo"]',
    Pt = "template",
    Ot = "video",
    Dt = "product-model",
    Ht = "loaded",
    Ft = "autoplay";
  let _t = class extends HTMLElement {
    loadContent(t = !0) {
      if ((this.pauseAllMedia(), !this.getAttribute(Ht))) {
        const e = document.createElement("div"),
          i = this.querySelector(Pt).content.firstElementChild.cloneNode(!0);
        e.appendChild(i), this.setAttribute(Ht, !0);
        const s = this.appendChild(e.querySelector(Mt));
        t && s.focus(), "VIDEO" == s.nodeName && s.getAttribute(Ft) && s.play();
      }
    }
    pauseAllMedia() {
      document.querySelectorAll(xt).forEach((t) => {
        t.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }),
        document.querySelectorAll(It).forEach((t) => {
          t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll(Ot).forEach((t) => t.pause()),
        document.querySelectorAll(Dt).forEach((t) => {
          t.modelViewerUI && t.modelViewerUI.pause();
        });
    }
    constructor() {
      super();
      const t = this.querySelector(Tt);
      null == t || t.addEventListener("click", this.loadContent.bind(this));
    }
  };
  customElements.get("deferred-media") ||
    customElements.define("deferred-media", _t),
    (window.theme.DeferredMedia = window.theme.DeferredMedia || _t);
  const Bt = "is-visible";
  class $t {
    init() {
      var t;
      const e = { root: this.container, threshold: [0.01, 0.5, 0.75, 0.99] };
      (this.observer = new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.intersectionRatio >= 0.99
            ? t.target.classList.add(Bt)
            : t.target.classList.remove(Bt);
        });
      }, e)),
        null === (t = this.container.querySelectorAll(this.itemSelector)) ||
          void 0 === t ||
          t.forEach((t) => {
            this.observer.observe(t);
          });
    }
    destroy() {
      this.observer.disconnect();
    }
    constructor(t, e) {
      t &&
        e &&
        ((this.observer = null),
        (this.container = t),
        (this.itemSelector = e),
        this.init());
    }
  }
  const Wt = "is-dragging",
    Nt = "is-enabled",
    Rt = "is-scrolling",
    Vt = "is-visible",
    Ut = "[data-grid-item]";
  class zt {
    handleMouseDown(t) {
      t.preventDefault(),
        (this.isDown = !0),
        (this.startX = t.pageX - this.slider.offsetLeft),
        (this.scrollLeft = this.slider.scrollLeft),
        this.cancelMomentumTracking();
    }
    handleMouseLeave() {
      this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
    }
    handleMouseUp() {
      (this.isDown = !1), this.beginMomentumTracking();
    }
    handleMouseMove(t) {
      if (!this.isDown) return;
      t.preventDefault();
      const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
        i = this.slider.scrollLeft,
        s = e > 0 ? 1 : -1;
      this.slider.classList.add(Wt, Rt),
        (this.slider.scrollLeft = this.scrollLeft - e),
        this.slider.scrollLeft !== i &&
          (this.velX = this.slider.scrollLeft - i || s);
          this.slider.closest("grid-slider")?.printScrollPercent();
    }
    handleMouseWheel() {
      this.cancelMomentumTracking(), this.slider.classList.remove(Rt);
    }
    beginMomentumTracking() {
      (this.isScrolling = !1),
        this.slider.classList.remove(Wt),
        this.cancelMomentumTracking(),
        this.scrollToSlide();
    }
    cancelMomentumTracking() {
      cancelAnimationFrame(this.scrollAnimation);
    }
    scrollToSlide() {
                if (!this.velX && !this.isScrolling) return;
            const t = this.slider.querySelector(`${Ut}.${Vt}`);
            if (!t) return;
            const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
                    i = t.offsetWidth + e,
                    s = t.offsetLeft,
                    o = this.velX > 0 ? 1 : -1,
                    r = Math.floor(Math.abs(this.velX) / 100) || 1;
            (this.startPosition = this.slider.scrollLeft),
                (this.distance = s - this.startPosition),
                (this.startTime = performance.now()),
                (this.isScrolling = !0),
                o < 0 && this.velX < i && (this.distance -= i * r),
                o > 0 && this.velX < i && (this.distance += i * r);

            // ✅ update dots after deciding the target slide
            const index = Array.from(this.slider.querySelectorAll(Ut)).indexOf(t);
            this.slider.closest("grid-slider")?.updateActiveDot(index);

            (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
    }
    scrollStep() {
      const t = performance.now() - this.startTime,
        e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(
          1
        );
      (this.slider.scrollLeft = e),
        t < this.duration
          ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep))
          : (this.slider.classList.remove(Rt),
            (this.velX = 0),
            (this.isScrolling = !1));
    }
    easeOutCubic(t) {
      return (
        (t /= this.duration),
        t--,
        this.distance * (t * t * t + 1) + this.startPosition
      );
    }
    destroy() {
      this.slider.classList.remove(Nt),
        this.slider.removeEventListener("mousedown", this.handleMouseDown),
        this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
        this.slider.removeEventListener("mouseup", this.handleMouseUp),
        this.slider.removeEventListener("mousemove", this.handleMouseMove),
        this.slider.removeEventListener("wheel", this.handleMouseWheel);
    }
    constructor(t) {
      (this.slider = t),
        (this.isDown = !1),
        (this.startX = 0),
        (this.scrollLeft = 0),
        (this.velX = 0),
        (this.scrollAnimation = null),
        (this.isScrolling = !1),
        (this.duration = 800),
        (this.scrollStep = this.scrollStep.bind(this)),
        (this.scrollToSlide = this.scrollToSlide.bind(this)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
        this.slider.addEventListener("mousedown", this.handleMouseDown),
        this.slider.addEventListener("mouseleave", this.handleMouseLeave),
        this.slider.addEventListener("mouseup", this.handleMouseUp),
        this.slider.addEventListener("mousemove", this.handleMouseMove),
        this.slider.addEventListener("wheel", this.handleMouseWheel, {
          passive: !0,
        }),
        this.slider.classList.add(Nt);
    }
  }
  const jt = "[data-button-arrow]",
    Jt = "[data-collection-image]",
    Xt = "[data-column-image]",
    Qt = "[data-product-image]",
    Kt = "[data-grid-item]",
    Yt = "[data-grid-slider]",
    Gt = "data-button-prev",
    Zt = "data-button-next",
    te = "align-arrows",
    ee = "images-widths-different",
    ie = "slider__arrows",
    se = "is-visible",
    oe = "scroll-snap-disabled";
  customElements.get("grid-slider") ||
    customElements.define(
      "grid-slider",
      class extends HTMLElement {
        connectedCallback() {
          this.init(),
            this.addEventListener("theme:grid-slider:init", this.init);
            this.slider.addEventListener("scroll", () => {
            const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
            const percent = maxScroll > 0 
                ? Math.round((this.slider.scrollLeft / maxScroll) * 100) 
                : 0;

            const bar = this.querySelector('[data-slider-progress]');
            if (bar) {
                bar.style.width = percent + "%"; // smooth with CSS transition
            }
            });
        }
        init() {

          (this.slider = this.querySelector(Yt)),
            (this.slides = this.querySelectorAll(Kt)),
            (this.buttons = this.querySelectorAll(jt)),
            this.slider.classList.add(oe),
            this.toggleSlider(),
            document.addEventListener("theme:resize:width", this.toggleSlider),
            window.theme
              .waitForAllAnimationsEnd(this)
              .then(() => {
                this.slider.classList.remove(oe);
              })
              .catch(() => {
                this.slider.classList.remove(oe);
              });
              this.initDots();
        }

        printScrollPercent() {
            if (!this.slider) return;
            const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
            const percent = maxScroll > 0 
                ? Math.round((this.slider.scrollLeft / maxScroll) * 100) 
                : 0;
            console.log(`Scrolled: ${percent}%`);
            // ✅ update bar directly
            const bar = this.slider.closest("grid-slider")?.querySelector('[data-slider-progress]');
            if (bar) {
            bar.style.setProperty("--progress", percent + "%");
            bar.style.setProperty("width", percent + "%"); // smooth via CSS transition
            }
            
            }

        initDots() {
                // If dots container exists in Liquid
                this.dotsContainer = this.querySelector('[data-slider-dots]');
                if (!this.dotsContainer) return;

                this.dotsContainer.innerHTML = '';
                this.slides.forEach((_, index) => {
                    const dot = document.createElement('button');
                    dot.classList.add('slider-dot');
                    dot.setAttribute('data-index', index);
                    if (index === 0) dot.classList.add('active');

                    dot.addEventListener('click', () => this.goToSlideByIndex(index));
                    this.dotsContainer.appendChild(dot);
                });
        }

        goToSlideByIndex(index) {
        const slide = this.slides[index];
        if (!slide) return;

        this.slider.scrollTo({
            top: 0,
            left: slide.offsetLeft,
            behavior: 'smooth',
        });

        this.updateActiveDot(index);

        }

        updateActiveDot(index) {
        if (!this.dotsContainer) return;
        this.dotsContainer.querySelectorAll('.slider-dot').forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
        });

        }

        toggleSlider() {
          if (
            !(this.slider.clientWidth < this.getSlidesWidth()) ||
            (window.theme.isMobile() && window.theme.touch)
          )
            this.destroy();
          else {
            if (this.isInitialized) return;
            (this.slidesObserver = new $t(this.slider, Kt)),
              this.initArrows(),
              (this.isInitialized = !0),
              (this.draggableSlider = new zt(this.slider));
          }
        }
        initArrows() {
          if (!this.buttons.length) {
            const t = document.createElement("div");
            t.classList.add(ie),
              (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
              this.append(t),
              (this.buttons = this.querySelectorAll(jt)),
              (this.buttonPrev = this.querySelector(`[${Gt}]`)),
              (this.buttonNext = this.querySelector(`[${Zt}]`));
          }
          this.toggleArrowsObserver(),
            this.hasAttribute(te) &&
              (this.positionArrows(), this.arrowsResizeObserver()),
            this.buttons.forEach((t) => {
              t.addEventListener("click", this.onButtonArrowClick);
            });
        }
        buttonArrowClickEvent(t) {
          t.preventDefault();
          const e = this.slider.querySelector(`${Kt}.${se}`);
          let i = null;
          t.target.hasAttribute(Gt) &&
            (i = null == e ? void 0 : e.previousElementSibling),
            t.target.hasAttribute(Zt) &&
              (i = null == e ? void 0 : e.nextElementSibling),
            this.goToSlide(i);

         
            if (i) {
                const index = Array.from(this.slides).indexOf(i);
                this.updateActiveDot(index);
            }
        }
        removeArrows() {
          var t;
          null === (t = this.querySelector(`.${ie}`)) ||
            void 0 === t ||
            t.remove();
        }
        goToSlide(t) {
          t &&
            this.slider.scrollTo({
              top: 0,
              left: t.offsetLeft,
              behavior: "smooth",
            });
        }
        getSlidesWidth() {
          var t;
          return (
            (null === (t = this.slider.querySelector(Kt)) || void 0 === t
              ? void 0
              : t.clientWidth) * this.slider.querySelectorAll(Kt).length
          );
        }
        toggleArrowsObserver() {
          if (this.buttonPrev && this.buttonNext) {
            const t = this.slides.length,
              e = this.slides[0],
              i = this.slides[t - 1],
              s = { attributes: !0, childList: !1, subtree: !1 },
              o = (t) => {
                for (const s of t)
                  if ("attributes" === s.type) {
                    const t = s.target,
                      o = Boolean(t.classList.contains(se));
                    t == e && (this.buttonPrev.disabled = o),
                      t == i && (this.buttonNext.disabled = o);

                      // ✅ dot sync
                
                  const index = Array.from(this.slides).indexOf(slide);
                  this.updateActiveDot(index);
              
                  }
              };
            e &&
              i &&
              ((this.firstLastSlidesObserver = new MutationObserver(o)),
              this.firstLastSlidesObserver.observe(e, s),
              this.firstLastSlidesObserver.observe(i, s));
          }
        }
        positionArrows() {
          if (this.hasAttribute(ee)) {
            const t = this.slider.querySelectorAll("figure"),
              e = Math.max(0, ...Array.from(t).map((t) => t.clientHeight));
            return void this.style.setProperty(
              "--button-position",
              e / 2 + "px"
            );
          }
          const t =
            this.slider.querySelector(Qt) ||
            this.slider.querySelector(Jt) ||
            this.slider.querySelector(Xt) ||
            this.slider;
          t &&
            this.style.setProperty(
              "--button-position",
              t.clientHeight / 2 + "px"
            );
        }
        arrowsResizeObserver() {
          document.addEventListener("theme:resize:width", this.positionArrows);
        }
        disconnectedCallback() {
          this.destroy(),
            document.removeEventListener(
              "theme:resize:width",
              this.toggleSlider
            );
        }
        destroy() {
          var t, e;
          (this.isInitialized = !1),
            null === (t = this.draggableSlider) || void 0 === t || t.destroy(),
            (this.draggableSlider = null),
            null === (e = this.slidesObserver) || void 0 === e || e.destroy(),
            (this.slidesObserver = null),
            this.removeArrows(),
            document.removeEventListener(
              "theme:resize:width",
              this.positionArrows
            );
        }
        constructor() {
          super(),
            (this.isInitialized = !1),
            (this.draggableSlider = null),
            (this.positionArrows = this.positionArrows.bind(this)),
            (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
            (this.slidesObserver = null),
            (this.firstLastSlidesObserver = null),
            (this.isDragging = !1),
            (this.toggleSlider = this.toggleSlider.bind(this));
        }
      }
    ),
    (window.theme.hasOpenModals = function () {
      const t = Boolean(
          document.querySelectorAll("dialog[open][data-scroll-lock-required]")
            .length
        ),
        e = Boolean(document.querySelectorAll(".drawer.is-open").length);
      return t || e;
    });
  const re = "cart-drawer",
    ne = "[data-cart-toggle]",
    ae = '.navlink[href="#"]',
    le = "[data-header-desktop]",
    de =
      ".main-content > .shopify-section.section-overlay-header:first-of-type",
    ce = ".page-header",
    he = "[data-prevent-transparent-header]",
    ue = "[data-child-takes-space]",
    pe = "[data-takes-space-wrapper]",
    me = "js__header__clone",
    ve = "has-first-section-overlay-header",
    ge = "shopify-section-group-header-group",
    be = "js__show__mobile",
    we = "has-header-sticky",
    fe = "js__header__stuck",
    ye = "has-header-transparent",
    Ee = "header-wrapper",
    Le = "data-drawer",
    Se = "data-drawer-toggle",
    Ae = "data-scroll-locked",
    ke = "data-header-sticky",
    Ce = "data-header-transparent";
  customElements.get("header-component") ||
    customElements.define(
      "header-component",
      class extends HTMLElement {
        connectedCallback() {
          this.killDeadLinks(),
            this.drawerToggleEvent(),
            this.cartToggleEvent(),
            this.initSticky(),
            "drawer" !== this.style &&
              this.desktop &&
              ((this.minWidth = this.getMinWidth()), this.listenWidth());
        }
        listenWidth() {
          "ResizeObserver" in window
            ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)),
              this.resizeObserver.observe(this))
            : document.addEventListener("theme:resize", this.checkWidth);
        }
        drawerToggleEvent() {
          var t;
          null === (t = this.querySelectorAll(`[${Se}]`)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.addEventListener("click", () => {
                let e;
                const i = t.hasAttribute(Se) ? t.getAttribute(Se) : "",
                  s = document.querySelector(`[${Le}="${i}"]`),
                  o = document.querySelector(`mobile-menu > [${Le}]`);
                (e = ("new" === theme.settings.mobileMenuType && o) || s),
                  e.dispatchEvent(
                    new CustomEvent("theme:drawer:toggle", {
                      bubbles: !1,
                      detail: { button: t },
                    })
                  );
              });
            });
        }
        killDeadLinks() {
          this.deadLinks.forEach((t) => {
            t.onclick = (t) => {
              t.preventDefault();
            };
          });
        }
        checkWidth() {
          if (document.body.clientWidth < this.minWidth) {
            this.classList.add(be);
            const { headerHeight: t } = window.theme.readHeights();
            document.documentElement.style.setProperty(
              "--header-height",
              `${t}px`
            );
          } else this.classList.remove(be);
        }
        getMinWidth() {
          const t = document.createElement("div");
          t.classList.add(me, Ee),
            t.appendChild(this.querySelector("header").cloneNode(!0)),
            document.body.appendChild(t);
          const e = t.querySelectorAll(pe);
          let i = 0,
            s = 0;
          return (
            e.forEach((t) => {
              const e = t.querySelectorAll(ue);
              let o = 0;
              (o =
                3 === e.length ? this._sumSplitWidths(e) : this._sumWidths(e)),
                o > i && ((i = o), (s = 20 * e.length));
            }),
            document.body.removeChild(t),
            i + s
          );
        }
        cartToggleEvent() {
          var t;
          "drawer" === theme.settings.cartType &&
            (null === (t = this.querySelectorAll(ne)) ||
              void 0 === t ||
              t.forEach((t) => {
                t.addEventListener("click", (e) => {
                  const i = document.querySelector(re);
                  i &&
                    (e.preventDefault(),
                    i.dispatchEvent(new CustomEvent("theme:cart-drawer:show")),
                    (window.a11y.lastElement = t));
                });
              }));
        }
        toggleButtonClick(t) {
          t.preventDefault(),
            document.dispatchEvent(
              new CustomEvent("theme:cart:toggle", { bubbles: !0 })
            );
        }
        initSticky() {
          var t;
          this.isSticky &&
            ((this.isStuck = !1),
            (this.cls = this.classList),
            (this.headerOffset =
              null === (t = document.querySelector(ce)) || void 0 === t
                ? void 0
                : t.offsetTop),
            (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
            (this.scrollEvent = (t) => this.onScroll(t)),
            this.listen(),
            this.stickOnLoad());
        }
        listen() {
          document.addEventListener("theme:scroll", this.scrollEvent),
            document.addEventListener(
              "shopify:section:load",
              this.updateHeaderOffset
            ),
            document.addEventListener(
              "shopify:section:unload",
              this.updateHeaderOffset
            );
        }
        onScroll(t) {
          t.detail.down
            ? !this.isStuck &&
              t.detail.position > this.headerOffset &&
              this.stickSimple()
            : t.detail.position <= this.headerOffset && this.unstickSimple();
        }
        updateHeaderOffset(t) {
          t.target.classList.contains(ge) &&
            setTimeout(() => {
              var t;
              this.headerOffset =
                null === (t = document.querySelector(ce)) || void 0 === t
                  ? void 0
                  : t.offsetTop;
            });
        }
        stickOnLoad() {
          window.scrollY > this.headerOffset && this.stickSimple();
        }
        stickSimple() {
          this.cls.add(fe), (this.isStuck = !0);
        }
        unstickSimple() {
          document.documentElement.hasAttribute(Ae) ||
            (this.cls.remove(fe), (this.isStuck = !1));
        }
        _sumSplitWidths(t) {
          let e = [];
          t.forEach((t) => {
            t.firstElementChild && e.push(t.firstElementChild.clientWidth);
          }),
            e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]);
          return e.reduce((t, e) => t + e);
        }
        _sumWidths(t) {
          let e = 0;
          return (
            t.forEach((t) => {
              e += t.clientWidth;
            }),
            e
          );
        }
        disconnectedCallback() {
          var t;
          "ResizeObserver" in window
            ? null === (t = this.resizeObserver) ||
              void 0 === t ||
              t.unobserve(this)
            : document.removeEventListener("theme:resize", this.checkWidth);
          this.isSticky &&
            (document.removeEventListener("theme:scroll", this.scrollEvent),
            document.removeEventListener(
              "shopify:section:load",
              this.updateHeaderOffset
            ),
            document.removeEventListener(
              "shopify:section:unload",
              this.updateHeaderOffset
            ));
        }
        constructor() {
          super(),
            (this.style = this.dataset.style),
            (this.desktop = this.querySelector(le)),
            (this.deadLinks = document.querySelectorAll(ae)),
            (this.resizeObserver = null),
            (this.checkWidth = this.checkWidth.bind(this)),
            (this.isSticky = this.hasAttribute(ke)),
            document.body.classList.toggle(we, this.isSticky);
          let t = !1;
          const e = document.querySelector(de);
          e && !e.querySelector(he) && (t = !0),
            document.body.classList.toggle(ye, this.hasAttribute(Ce)),
            document.body.classList.toggle(ve, t);
        }
      }
    );
  const qe = "[data-top-link]",
    Te = "[data-header-wrapper]",
    Me = "[data-stagger]",
    xe = "[data-stagger-first]",
    Ie = "[data-stagger-second]",
    Pe = "is-visible",
    Oe = "meganav--visible",
    De = "meganav--is-transitioning";
  customElements.get("hover-disclosure") ||
    customElements.define(
      "hover-disclosure",
      class extends HTMLElement {
        connectedCallback() {
          this.setAttribute("aria-haspopup", !0),
            this.setAttribute("aria-expanded", !1),
            this.setAttribute("aria-controls", this.key),
            this.connectHoverToggle(),
            this.handleTablets(),
            this.staggerChildAnimations(),
            this.addEventListener("theme:disclosure:show", (t) => {
              this.showDisclosure(t);
            }),
            this.addEventListener("theme:disclosure:hide", (t) => {
              this.hideDisclosure(t);
            });
        }
        showDisclosure(t) {
          t &&
            t.type &&
            "mouseenter" === t.type &&
            this.wrapper.classList.add(De),
            this.grandparent
              ? this.wrapper.classList.add(Oe)
              : this.wrapper.classList.remove(Oe),
            this.setAttribute("aria-expanded", !0),
            this.classList.add(Pe),
            this.disclosure.classList.add(Pe),
            this.transitionTimeout && clearTimeout(this.transitionTimeout),
            (this.transitionTimeout = setTimeout(() => {
              this.wrapper.classList.remove(De);
            }, 200));
        }
        hideDisclosure() {
          this.classList.remove(Pe),
            this.disclosure.classList.remove(Pe),
            this.setAttribute("aria-expanded", !1),
            this.wrapper.classList.remove(Oe, De);
        }
        staggerChildAnimations() {
          const t = this.querySelectorAll(Me);
          let e = 50;
          t.forEach((t, i) => {
            (t.style.transitionDelay = i * e + 10 + "ms"), (e *= 0.95);
          });
          this.querySelectorAll(xe).forEach((t, e) => {
            const i = 100 * e;
            (t.style.transitionDelay = `${i}ms`),
              t.parentElement.querySelectorAll(Ie).forEach((t, e) => {
                const s = 20 * (e + 1);
                t.style.transitionDelay = `${i + s}ms`;
              });
          });
        }
        handleTablets() {
          this.addEventListener(
            "touchstart",
            function (t) {
              this.classList.contains(Pe) ||
                (t.preventDefault(), this.showDisclosure(t));
            }.bind(this),
            { passive: !0 }
          );
        }
        connectHoverToggle() {
          this.addEventListener("mouseenter", (t) => this.showDisclosure(t)),
            this.link.addEventListener("focus", (t) => this.showDisclosure(t)),
            this.addEventListener("mouseleave", () => this.hideDisclosure()),
            this.addEventListener("focusout", (t) => {
              this.contains(t.relatedTarget) || this.hideDisclosure();
            }),
            this.addEventListener("keyup", (t) => {
              "Escape" === t.code && this.hideDisclosure();
            });
        }
        constructor() {
          super(),
            (this.wrapper = this.closest(Te)),
            (this.key = this.getAttribute("aria-controls")),
            (this.link = this.querySelector(qe)),
            (this.grandparent = this.classList.contains("grandparent")),
            (this.disclosure = document.getElementById(this.key)),
            (this.transitionTimeout = 0);
        }
      }
    );
  const He = "[data-drawer-inner]",
    Fe = "[data-drawer-close]",
    _e = "[data-drawer-underlay]",
    Be = "[data-stagger-animation]",
    $e = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    We = "drawer--animated",
    Ne = "is-open",
    Re = "is-closing",
    Ve = "is-focused";
  customElements.get("header-drawer") ||
    customElements.define(
      "header-drawer",
      class extends HTMLElement {
        connectDrawer() {
          this.addEventListener("theme:drawer:toggle", (t) => {
            var e;
            (this.triggerButton =
              null === (e = t.detail) || void 0 === e ? void 0 : e.button),
              this.classList.contains(Ne)
                ? this.dispatchEvent(
                    new CustomEvent("theme:drawer:close", { bubbles: !0 })
                  )
                : this.dispatchEvent(
                    new CustomEvent("theme:drawer:open", { bubbles: !0 })
                  );
          }),
            this.addEventListener("theme:drawer:close", this.hideDrawer),
            this.addEventListener("theme:drawer:open", this.showDrawer),
            document.addEventListener(
              "theme:cart-drawer:open",
              this.hideDrawer
            );
        }
        closers() {
          var t;
          null === (t = this.querySelectorAll(Fe)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.addEventListener("click", () => {
                this.hideDrawer();
              });
            }),
            document.addEventListener("keyup", (t) => {
              "Escape" === t.code && this.hideDrawer();
            }),
            this.underlay.addEventListener("click", () => {
              this.hideDrawer();
            });
        }
        showDrawer() {
          var t;
          this.isAnimating ||
            ((this.isAnimating = !0),
            null === (t = this.triggerButton) ||
              void 0 === t ||
              t.setAttribute("aria-expanded", !0),
            this.classList.add(Ne, We),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", { bubbles: !0 })
            ),
            this.drawerInner &&
              (this.a11y.removeTrapFocus(),
              window.theme.waitForAnimationEnd(this.drawerInner).then(() => {
                (this.isAnimating = !1),
                  this.a11y.trapFocus(this.drawerInner, {
                    elementToFocus: this.querySelector($e),
                  });
              })));
        }
        hideDrawer() {
          !this.isAnimating &&
            this.classList.contains(Ne) &&
            ((this.isAnimating = !0),
            this.classList.add(Re),
            this.classList.remove(Ne),
            this.a11y.removeTrapFocus(),
            this.triggerButton &&
              (this.triggerButton.setAttribute("aria-expanded", !1),
              document.body.classList.contains(Ve) &&
                this.triggerButton.focus()),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
            window.theme.waitForAnimationEnd(this.drawerInner).then(() => {
              this.classList.remove(Re, We),
                (this.isAnimating = !1),
                document.dispatchEvent(
                  new CustomEvent("theme:sliderule:close", { bubbles: !1 })
                );
            }));
        }
        disconnectedCallback() {
          document.removeEventListener(
            "theme:cart-drawer:open",
            this.hideDrawer
          );
        }
        constructor() {
          super(),
            (this.a11y = window.theme.a11y),
            (this.isAnimating = !1),
            (this.drawer = this),
            (this.drawerInner = this.querySelector(He)),
            (this.underlay = this.querySelector(_e)),
            (this.triggerButton = null),
            (this.staggers = this.querySelectorAll(Be)),
            (this.showDrawer = this.showDrawer.bind(this)),
            (this.hideDrawer = this.hideDrawer.bind(this)),
            this.connectDrawer(),
            this.closers();
        }
      }
    );
  const Ue = {
      animates: "data-animates",
      sliderule: "[data-sliderule]",
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * > [data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    ze = "is-visible",
    je = "is-hiding",
    Je = "is-hidden",
    Xe = "is-focused",
    Qe = "is-scrolling";
  customElements.get("mobile-sliderule") ||
    customElements.define(
      "mobile-sliderule",
      class extends HTMLElement {
        clickEvents() {
          this.trigger.addEventListener("click", () => {
            (this.cachedButton = this.trigger), this.showSliderule();
          }),
            this.exit.forEach((t) => {
              t.addEventListener("click", () => {
                this.hideSliderule();
              });
            });
        }
        keyboardEvents() {
          this.addEventListener("keyup", (t) => {
            t.stopPropagation(), "Escape" === t.code && this.hideSliderule();
          });
        }
        trapFocusSliderule(t = !0) {
          const e = t
            ? this.querySelector(this.exitSelector)
            : this.cachedButton;
          this.a11y.removeTrapFocus(),
            e &&
              this.drawerContent &&
              this.a11y.trapFocus(this.drawerContent, {
                elementToFocus: document.body.classList.contains(Xe) ? e : null,
              });
        }
        hideSliderule(t = !1) {
          const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
          this.pane.setAttribute(Ue.sliderulePane, e),
            this.pane.classList.add(je),
            this.sliderule.classList.add(je);
          const i = t ? `[${Ue.animates}].${Je}` : `[${Ue.animates}="${e}"]`,
            s = this.pane.querySelectorAll(i);
          s.length &&
            s.forEach((t) => {
              t.classList.remove(Je);
            });
          const o = t
            ? this.pane.querySelectorAll(`.${ze}, .${je}`)
            : this.childrenElements;
          o.forEach((i, s) => {
            const r = o.length - 1 == s;
            i.classList.remove(ze),
              t && (i.classList.remove(je), this.pane.classList.remove(je));
            const n = () => {
              parseInt(this.pane.getAttribute(Ue.sliderulePane)) === e &&
                this.sliderule.classList.remove(ze),
                this.sliderule.classList.remove(je),
                this.pane.classList.remove(je),
                r &&
                  (this.a11y.removeTrapFocus(),
                  t || this.trapFocusSliderule(!1)),
                i.removeEventListener("animationend", n);
            };
            window.theme.settings.enableAnimations
              ? i.addEventListener("animationend", n)
              : n();
          });
        }
        showSliderule() {
          let t = null;
          const e = this.closest(`.${ze}`);
          let i = this.pane;
          e && (i = e),
            i.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
            i.classList.add(Qe);
          const s = () => {
            i.scrollTop <= 0
              ? (i.classList.remove(Qe), t && cancelAnimationFrame(t))
              : (t = requestAnimationFrame(s));
          };
          t = requestAnimationFrame(s);
          const o = parseInt(this.pane.dataset.sliderulePane, 10),
            r = o + 1;
          this.sliderule.classList.add(ze),
            this.pane.setAttribute(Ue.sliderulePane, r);
          const n = this.pane.querySelectorAll(`[${Ue.animates}="${o}"]`);
          n.length &&
            n.forEach((t, e) => {
              const i = n.length - 1 == e;
              t.classList.add(je);
              const s = () => {
                t.classList.remove(je),
                  parseInt(this.pane.getAttribute(Ue.sliderulePane)) !== o &&
                    t.classList.add(Je),
                  i && this.trapFocusSliderule(),
                  t.removeEventListener("animationend", s);
              };
              window.theme.settings.enableAnimations
                ? t.addEventListener("animationend", s)
                : s();
            });
        }
        closeSliderule() {
          this.pane &&
            this.pane.hasAttribute(Ue.sliderulePane) &&
            parseInt(this.pane.getAttribute(Ue.sliderulePane)) > 0 &&
            (this.hideSliderule(!0),
            parseInt(this.pane.getAttribute(Ue.sliderulePane)) > 0 &&
              this.pane.setAttribute(Ue.sliderulePane, 0));
        }
        disconnectedCallback() {
          document.removeEventListener(
            "theme:sliderule:close",
            this.closeSliderule
          );
        }
        constructor() {
          super(),
            (this.key = this.id),
            (this.sliderule = this.querySelector(Ue.sliderule));
          const t = `[${Ue.slideruleOpen}='${this.key}']`;
          (this.exitSelector = `[${Ue.slideruleClose}='${this.key}']`),
            (this.trigger = this.querySelector(t)),
            (this.exit = document.querySelectorAll(this.exitSelector)),
            (this.pane = this.trigger.closest(`[${Ue.sliderulePane}]`)),
            (this.childrenElements = this.querySelectorAll(Ue.children)),
            (this.drawerContent = this.closest(Ue.drawerContent)),
            (this.cachedButton = null),
            (this.a11y = window.theme.a11y),
            this.trigger.setAttribute("aria-haspopup", !0),
            this.trigger.setAttribute("aria-expanded", !1),
            this.trigger.setAttribute("aria-controls", this.key),
            (this.closeSliderule = this.closeSliderule.bind(this)),
            this.clickEvents(),
            this.keyboardEvents(),
            document.addEventListener(
              "theme:sliderule:close",
              this.closeSliderule
            );
        }
      }
    );
  const Ke = "details",
    Ye = "[data-popdown]",
    Ge = "[data-popdown-close]",
    Ze = 'input:not([type="hidden"])',
    ti = "mobile-menu",
    ei = "data-popdown-underlay",
    ii = "data-scroll-locked",
    si = "is-open";
  let oi = class extends HTMLElement {
    connectedCallback() {
      this.popdown.addEventListener(
        "transitionend",
        this.popdownTransitionCallback
      ),
        this.popdownContainer.addEventListener(
          "keyup",
          (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
        ),
        this.popdownContainer.addEventListener(
          "toggle",
          this.detailsToggleCallback
        ),
        this.popdownClose.addEventListener("click", this.close.bind(this));
    }
    detailsToggleCallback(t) {
      t.target.hasAttribute("open") && this.open();
    }
    popdownTransitionCallback(t) {
      t.target === this.popdown &&
        (this.classList.contains(si)
          ? ("transform" !== t.propertyName && "opacity" !== t.propertyName) ||
            this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector(Ze),
            })
          : (this.popdownContainer.removeAttribute("open"),
            this.a11y.removeTrapFocus()));
    }
    onBodyClick(t) {
      (this.contains(t.target) && !t.target.hasAttribute(ei)) || this.close();
    }
    open() {
      (this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.documentElement.hasAttribute(ii) ||
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ),
        requestAnimationFrame(() => {
          this.classList.add(si);
        });
    }
    close() {
      this.classList.remove(si),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        this.mobileMenu ||
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }
    constructor() {
      super(),
        (this.popdown = this.querySelector(Ye)),
        (this.popdownContainer = this.querySelector(Ke)),
        (this.popdownClose = this.querySelector(Ge)),
        (this.popdownTransitionCallback =
          this.popdownTransitionCallback.bind(this)),
        (this.detailsToggleCallback = this.detailsToggleCallback.bind(this)),
        (this.mobileMenu = this.closest(ti)),
        (this.a11y = window.theme.a11y);
    }
  };
  customElements.get("header-search-popdown") ||
    customElements.define("header-search-popdown", oi);
  const ri = 'input[type="search"]',
    ni = '[aria-selected="true"] a',
    ai = 'button[type="reset"]',
    li = "hidden";
  let di = class extends HTMLElement {
    toggleResetButton() {
      const t = this.resetButton.classList.contains(li);
      this.input.value.length > 0 && t
        ? this.resetButton.classList.remove(li)
        : 0 !== this.input.value.length ||
          t ||
          this.resetButton.classList.add(li);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(ni);
    }
    onFormReset(t) {
      t.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          t.target.querySelector(ri).focus());
    }
    constructor() {
      super(),
        (this.input = this.querySelector(ri)),
        (this.resetButton = this.querySelector(ai)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            window.theme
              .debounce((t) => {
                this.onChange(t);
              }, 300)
              .bind(this)
          ));
    }
  };
  customElements.define("header-search-form", di);
  const ci = 'input[type="search"]';
  let hi = class extends di {
    setupEventListeners() {
      let t = [];
      this.allSearchInputs.forEach((e) => t.push(e.form)),
        this.input.addEventListener("focus", this.onInputFocus.bind(this)),
        t.length < 2 ||
          (t.forEach((t) =>
            t.addEventListener("reset", this.onFormReset.bind(this))
          ),
          this.allSearchInputs.forEach((t) =>
            t.addEventListener("input", this.onInput.bind(this))
          ));
    }
    onFormReset(t) {
      super.onFormReset(t),
        super.shouldResetForm() && this.keepInSync("", this.input);
    }
    onInput(t) {
      const e = t.target;
      this.keepInSync(e.value, e);
    }
    onInputFocus() {
      window.theme.isMobile() && this.scrollIntoView({ behavior: "smooth" });
    }
    keepInSync(t, e) {
      this.allSearchInputs.forEach((i) => {
        i !== e && (i.value = t);
      });
    }
    constructor() {
      super(),
        (this.allSearchInputs = document.querySelectorAll(ci)),
        this.setupEventListeners();
    }
  };
  customElements.get("main-search") || customElements.define("main-search", hi);
  const ui = "[data-scrollbar]",
    pi = "[data-scrollbar-arrow-prev]",
    mi = "[data-scrollbar-arrow-next]",
    vi = "is-hidden",
    gi = "data-scrollbar-slider",
    bi = "data-scrollbar-slide-fullwidth";
  customElements.get("native-scrollbar") ||
    customElements.define(
      "native-scrollbar",
      class extends HTMLElement {
        connectedCallback() {
          document.addEventListener("theme:resize", this.toggleNextArrow),
            this.scrollbar.hasAttribute(gi) && this.scrollToVisibleElement(),
            this.arrowNext &&
              this.arrowPrev &&
              (this.events(), this.toggleNextArrow());
        }
        disconnectedCallback() {
          document.removeEventListener("theme:resize", this.toggleNextArrow);
        }
        events() {
          this.arrowNext.addEventListener("click", (t) => {
            t.preventDefault(), this.goToNext();
          }),
            this.arrowPrev.addEventListener("click", (t) => {
              t.preventDefault(), this.goToPrev();
            }),
            this.scrollbar.addEventListener("scroll", () => {
              this.togglePrevArrow(), this.toggleNextArrow();
            });
        }
        goToNext() {
          const t =
            (this.scrollbar.hasAttribute(bi)
              ? this.scrollbar.getBoundingClientRect().width
              : this.scrollbar.getBoundingClientRect().width / 2) +
            this.scrollbar.scrollLeft;
          this.move(t),
            this.arrowPrev.classList.remove(vi),
            this.toggleNextArrow();
        }
        goToPrev() {
          const t = this.scrollbar.hasAttribute(bi)
              ? this.scrollbar.getBoundingClientRect().width
              : this.scrollbar.getBoundingClientRect().width / 2,
            e = this.scrollbar.scrollLeft - t;
          this.move(e),
            this.arrowNext.classList.remove(vi),
            this.togglePrevArrow();
        }
        toggleNextArrow() {
          requestAnimationFrame(() => {
            var t;
            null === (t = this.arrowNext) ||
              void 0 === t ||
              t.classList.toggle(
                vi,
                Math.round(
                  this.scrollbar.scrollLeft +
                    this.scrollbar.getBoundingClientRect().width +
                    1
                ) >= this.scrollbar.scrollWidth
              );
          });
        }
        togglePrevArrow() {
          requestAnimationFrame(() => {
            this.arrowPrev.classList.toggle(vi, this.scrollbar.scrollLeft <= 0);
          });
        }
        scrollToVisibleElement() {
          [].forEach.call(this.scrollbar.children, (t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
            });
          });
        }
        move(t) {
          this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
        }
        constructor() {
          super(),
            (this.scrollbar = this.querySelector(ui)),
            (this.arrowNext = this.querySelector(mi)),
            (this.arrowPrev = this.querySelector(pi)),
            (this.toggleNextArrow = this.toggleNextArrow.bind(this)),
            this.addEventListener(
              "theme:swatches:loaded",
              this.toggleNextArrow
            );
        }
      }
    );
  const wi = "[data-popout-list]",
    fi = "[data-popout-toggle]",
    yi = "[data-popout-toggle-text]",
    Ei = "[data-popout-input]",
    Li = "[data-popout-option]",
    Si = "[data-product-image]",
    Ai = "[data-grid-item]",
    ki = "popout-list--visible",
    Ci = "is-visible",
    qi = "is-active",
    Ti = "popout-list--top",
    Mi = "aria-expanded",
    xi = "aria-current",
    Ii = "data-value",
    Pi = "data-popout-toggle-text",
    Oi = "submit";
  customElements.get("popout-select") ||
    customElements.define(
      "popout-select",
      class extends HTMLElement {
        connectedCallback() {
          (this.popoutList = this.querySelector(wi)),
            (this.popoutToggle = this.querySelector(fi)),
            (this.popoutToggleText = this.querySelector(yi)),
            (this.popoutInput =
              this.querySelector(Ei) || this.parentNode.querySelector(Ei)),
            (this.popoutOptions = this.querySelectorAll(Li)),
            (this.productGridItem = this.popoutList.closest(Ai)),
            (this.fireSubmitEvent = this.hasAttribute(Oi)),
            (this.popupToggleFocusoutEvent = (t) =>
              this.onPopupToggleFocusout(t)),
            (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
            (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
            (this.keyUpEvent = (t) => this.onKeyUp(t)),
            (this.bodyClickEvent = (t) => this.onBodyClick(t)),
            this._connectOptions(),
            this._connectToggle(),
            this._onFocusOut(),
            this.popupListSetDimensions();
        }
        onPopupToggleClick(t) {
          const e = "true" === t.currentTarget.getAttribute(Mi);
          if (this.productGridItem) {
            const t = this.productGridItem.querySelector(Si);
            t && t.classList.toggle(Ci, !e),
              (this.popoutList.style.maxHeight = `${Math.abs(
                this.popoutToggle.getBoundingClientRect().bottom -
                  this.productGridItem.getBoundingClientRect().bottom
              )}px`);
          }
          t.currentTarget.setAttribute(Mi, !e),
            this.popoutList.classList.toggle(ki),
            this.popupListSetDimensions(),
            this.toggleListPosition(),
            document.body.addEventListener("click", this.bodyClickEvent);
        }
        onPopupToggleFocusout(t) {
          this.contains(t.relatedTarget) || this._hideList();
        }
        onPopupListFocusout(t) {
          const e = t.currentTarget.contains(t.relatedTarget);
          this.popoutList.classList.contains(ki) && !e && this._hideList();
        }
        toggleListPosition() {
          const t = this.querySelector(fi),
            e = this.getBoundingClientRect().top + this.clientHeight,
            i = () => {
              "true" !== t.getAttribute(Mi) &&
                this.popoutList.classList.remove(Ti),
                this.popoutList.removeEventListener("transitionend", i);
            };
          "true" === t.getAttribute(Mi)
            ? window.innerHeight / 2 < e && this.popoutList.classList.add(Ti)
            : this.popoutList.addEventListener("transitionend", i);
        }
        popupListSetDimensions() {
          this.popoutList.style.setProperty("--max-width", "100vw"),
            this.popoutList.style.setProperty("--max-height", "100vh"),
            requestAnimationFrame(() => {
              this.popoutList.style.setProperty(
                "--max-width",
                `${parseInt(
                  document.body.clientWidth -
                    this.popoutList.getBoundingClientRect().left
                )}px`
              ),
                this.popoutList.style.setProperty(
                  "--max-height",
                  `${parseInt(
                    document.body.clientHeight -
                      this.popoutList.getBoundingClientRect().top
                  )}px`
                );
            });
        }
        popupOptionsClick(t) {
          if ("#" === t.target.closest(Li).attributes.href.value) {
            t.preventDefault();
            const e = t.currentTarget.hasAttribute(Ii)
              ? t.currentTarget.getAttribute(Ii)
              : "";
            if (
              ((this.popoutInput.value = e),
              this.popoutInput.disabled &&
                this.popoutInput.removeAttribute("disabled"),
              this.fireSubmitEvent)
            )
              this._submitForm(e);
            else {
              const i = t.currentTarget.parentElement,
                s = this.popoutList.querySelector(`.${qi}`),
                o = this.popoutList.querySelector(`[${xi}]`);
              this.popoutInput.dispatchEvent(new Event("change")),
                s && (s.classList.remove(qi), i.classList.add(qi)),
                "quantity" != this.popoutInput.name ||
                  i.nextSibling ||
                  this.classList.add(qi),
                o &&
                  o.hasAttribute(`${xi}`) &&
                  (o.removeAttribute(`${xi}`),
                  t.currentTarget.setAttribute(`${xi}`, "true")),
                "" !== e &&
                  ((this.popoutToggleText.innerHTML = e),
                  this.popoutToggleText.hasAttribute(Pi) &&
                    "" !== this.popoutToggleText.getAttribute(Pi) &&
                    this.popoutToggleText.setAttribute(Pi, e)),
                this.onPopupToggleFocusout(t),
                this.onPopupListFocusout(t);
            }
          }
        }
        onKeyUp(t) {
          "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
        }
        onBodyClick(t) {
          const e = this.contains(t.target);
          this.popoutList.classList.contains(ki) && !e && this._hideList();
        }
        _connectToggle() {
          this.popoutToggle.addEventListener(
            "click",
            this.popupToggleClickEvent
          );
        }
        _connectOptions() {
          this.popoutOptions.length &&
            this.popoutOptions.forEach((t) => {
              t.addEventListener("click", (t) => this.popupOptionsClick(t));
            });
        }
        _onFocusOut() {
          this.addEventListener("keyup", this.keyUpEvent),
            this.popoutToggle.addEventListener(
              "focusout",
              this.popupToggleFocusoutEvent
            ),
            this.popoutList.addEventListener(
              "focusout",
              this.popupListFocusoutEvent
            );
        }
        _submitForm() {
          const t = this.closest("form");
          t && t.submit();
        }
        _hideList() {
          this.popoutList.classList.remove(ki),
            this.popoutToggle.setAttribute(Mi, !1),
            this.toggleListPosition(),
            document.body.removeEventListener("click", this.bodyClickEvent);
        }
        constructor() {
          super();
        }
      }
    );
  const Di = {
      open: "[data-popup-open]",
      close: "[data-popup-close]",
      dialog: "dialog",
      focusable:
        'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
      newsletterForm: "[data-newsletter-form]",
      newsletterHeading: "[data-newsletter-heading]",
      newsletterField: "[data-newsletter-field]",
    },
    Hi = {
      closing: "closing",
      delay: "data-popup-delay",
      scrollLock: "data-scroll-lock-required",
      cookieName: "data-cookie-name",
      cookieValue: "data-cookie-value",
      preventTopLayer: "data-prevent-top-layer",
    },
    Fi = "hidden",
    _i = "has-value",
    Bi = "cart-bar-visible",
    $i = "is-visible",
    Wi = "has-success",
    Ni = "mobile",
    Ri = "desktop",
    Vi = "bottom";
  let Ui = class extends HTMLElement {
      checkTargetReferrer() {
        this.popup.hasAttribute(Hi.referrer) &&
          (-1 !== location.href.indexOf(this.popup.getAttribute(Hi.referrer)) ||
            window.Shopify.designMode ||
            this.popup.parentNode.removeChild(this.popup));
      }
      checkCookie() {
        (this.cookie && !1 !== this.cookie.read()) ||
          (this.showPopupEvents(),
          this.popup.addEventListener("theme:popup:onclose", () =>
            this.cookie.write()
          ));
      }
      bindListeners() {
        var t, e;
        null === (t = this.buttonPopupOpen) ||
          void 0 === t ||
          t.addEventListener("click", (t) => {
            t.preventDefault(),
              this.popupOpen(),
              (window.theme.a11y.lastElement = this.buttonPopupOpen);
          }),
          null === (e = this.popup.querySelectorAll(Di.close)) ||
            void 0 === e ||
            e.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault(), this.popupClose();
              });
            }),
          this.popup.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.popupClose();
          }),
          this.popup.addEventListener("keydown", (t) => {
            "Escape" === t.code && (t.preventDefault(), this.popupClose());
          }),
          this.popup.addEventListener("close", () => this.popupCloseActions());
      }
      popupOpen() {
        (this.isAnimating = !0),
          "function" != typeof this.popup.showModal || this.preventTopLayer
            ? "function" == typeof this.popup.show
              ? this.popup.show()
              : this.popup.setAttribute("open", "")
            : this.popup.showModal(),
          this.popup.removeAttribute("inert"),
          this.popup.setAttribute("aria-hidden", !1),
          this.popup.focus(),
          this.enableScrollLock &&
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", { bubbles: !0 })
            ),
          window.theme.waitForAnimationEnd(this.popup).then(() => {
            (this.isAnimating = !1),
              this.enableScrollLock && this.a11y.trapFocus(this.popup);
            const t =
              this.popup.querySelector("[autofocus]") ||
              this.popup.querySelector(Di.focusable);
            null == t || t.focus();
          });
      }
      popupClose() {
        if (!this.isAnimating && !this.popup.hasAttribute("inert")) {
          if (!this.popup.hasAttribute(Hi.closing))
            return (
              this.popup.setAttribute(Hi.closing, ""),
              (this.isAnimating = !0),
              void window.theme.waitForAnimationEnd(this.popup).then(() => {
                (this.isAnimating = !1), this.popupClose();
              })
            );
          "function" == typeof this.popup.close
            ? this.popup.close()
            : (this.popup.removeAttribute("open"),
              this.popup.setAttribute("aria-hidden", !0)),
            this.popupCloseActions();
        }
      }
      popupCloseActions() {
        this.popup.hasAttribute("inert") ||
          (this.popup.setAttribute("inert", ""),
          this.popup.setAttribute("aria-hidden", !0),
          this.popup.removeAttribute(Hi.closing),
          !window.theme.hasOpenModals() &&
            this.enableScrollLock &&
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
          this.popup.dispatchEvent(
            new CustomEvent("theme:popup:onclose", { bubbles: !1 })
          ),
          this.enableScrollLock &&
            (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()));
      }
      showPopupEvents() {
        this.popup.hasAttribute("open") &&
          1 == this.popup.getAttribute("open") &&
          this.popupOpen(),
          (this.delay = this.popup.hasAttribute(Hi.delay)
            ? this.popup.getAttribute(Hi.delay)
            : null),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.showOnScrollEvent = window.theme.throttle(
            this.showOnScroll.bind(this),
            200
          )),
          ("always" === this.delay || this.isSubmitted) && this.popupOpen(),
          this.delay &&
            this.delay.includes("delayed") &&
            !this.isSubmitted &&
            this.showDelayed(),
          "bottom" !== this.delay ||
            this.isSubmitted ||
            this.showOnBottomReached(),
          "idle" !== this.delay || this.isSubmitted || this.showOnIdle();
      }
      showDelayed() {
        const t = this.delay.includes("_")
          ? parseInt(this.delay.split("_")[1])
          : 10;
        setTimeout(() => {
          this.popupOpen();
        }, 1e3 * t);
      }
      showOnIdle() {
        let t = 0;
        const e = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          i = ["load", "resize", "scroll"],
          s = () => {
            (t = setTimeout(() => {
              (t = 0), this.popupOpen();
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, o);
              }),
              i.forEach((t) => {
                window.addEventListener(t, o);
              });
          },
          o = () => {
            t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, o);
              }),
              i.forEach((t) => {
                window.removeEventListener(t, o);
              }),
              s();
          };
        s();
      }
      showOnBottomReached() {
        document.addEventListener("theme:scroll", this.showOnScrollEvent);
      }
      showOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (this.popupOpen(),
          document.removeEventListener("theme:scroll", this.showOnScrollEvent));
      }
      disconnectedCallback() {
        document.removeEventListener("theme:scroll", this.showOnScrollEvent);
      }
      constructor() {
        super(),
          (this.popup = this.querySelector(Di.dialog)),
          (this.preventTopLayer = this.popup.hasAttribute(Hi.preventTopLayer)),
          (this.enableScrollLock = this.popup.hasAttribute(Hi.scrollLock)),
          (this.buttonPopupOpen = this.querySelector(Di.open)),
          (this.a11y = window.theme.a11y),
          (this.isAnimating = !1),
          (this.cookie = new (class {
            write() {
              ((-1 !== document.cookie.indexOf("; ") &&
                !document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name))) ||
                -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.config.expires}; path=${this.config.path}; domain=${this.config.domain}; sameSite=${this.config.sameSite}; secure=${this.config.secure}`);
            }
            read() {
              return (
                !(
                  -1 === document.cookie.indexOf("; ") ||
                  !document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.name))
                ) &&
                document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name))
                  .split("=")[1]
              );
            }
            destroy() {
              document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name)) &&
                (document.cookie = `${this.name}=null; expires=${this.config.expires}; path=${this.config.path}; domain=${this.config.domain}`);
            }
            constructor(t, e, i = 7) {
              const s = new Date(),
                o = new Date();
              o.setTime(s.getTime() + 864e5 * i),
                (this.config = {
                  expires: o.toGMTString(),
                  path: "/",
                  domain: window.location.hostname,
                  sameSite: "none",
                  secure: !0,
                }),
                (this.name = t),
                (this.value = e);
            }
          })(
            this.popup.getAttribute(Hi.cookieName),
            this.popup.getAttribute(Hi.cookieValue)
          )),
          this.checkTargetReferrer(),
          this.checkCookie(),
          this.bindListeners();
      }
    },
    zi = class extends Ui {
      connectedCallback() {
        var t;
        const e =
            !1 !==
            (null === (t = this.cookie) || void 0 === t ? void 0 : t.read()),
          i = -1 !== window.location.search.indexOf("?customer_posted=true"),
          s = [...this.classList].toString().includes(Vi),
          o = this.popup.classList.contains(Ni),
          r = this.popup.classList.contains(Ri),
          n = window.theme.isMobile();
        let a = !0;
        if ((((o && !n) || (r && n)) && (a = !1), !a))
          return (
            super.a11y.removeTrapFocus(),
            void document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            )
          );
        (e && !window.Shopify.designMode) ||
          (window.Shopify.designMode ||
            window.location.pathname.endsWith("/challenge") ||
            super.showPopupEvents(),
          this.form &&
            this.form.classList.contains(Wi) &&
            (super.popupOpen(), this.cookie.write()),
          this.popup.addEventListener("theme:popup:onclose", () =>
            this.cookie.write()
          )),
          i && (this.delay = 0),
          (e && !window.Shopify.designMode) ||
            (this.show(),
            this.form.classList.contains(Wi) &&
              (this.popupOpen(), this.cookie.write())),
          s && this.observeCartBar();
      }
      show() {
        window.location.pathname.endsWith("/challenge") ||
          (window.Shopify.designMode
            ? super.popupOpen()
            : super.showPopupEvents()),
          this.showForm(),
          this.inputField(),
          this.popup.addEventListener("theme:popup:onclose", () =>
            this.cookie.write()
          );
      }
      observeCartBar() {
        if (
          ((this.cartBar = document.getElementById(Di.cartBar)), !this.cartBar)
        )
          return;
        let t = this.cartBar.classList.contains($i);
        document.body.classList.toggle(Bi, t);
        (this.observer = new MutationObserver((e) => {
          for (const i of e)
            "attributes" === i.type &&
              ((t = i.target.classList.contains($i)),
              document.body.classList.toggle(Bi, t));
        })),
          this.observer.observe(this.cartBar, {
            attributes: !0,
            childList: !1,
            subtree: !1,
          });
      }
      showForm() {
        var t, e;
        null === (t = this.heading) ||
          void 0 === t ||
          t.addEventListener("click", (t) => {
            t.preventDefault(),
              this.heading.classList.add(Fi),
              this.form.classList.remove(Fi),
              this.newsletterField.focus();
          }),
          null === (e = this.heading) ||
            void 0 === e ||
            e.addEventListener("keyup", (t) => {
              "Enter" === t.code &&
                this.heading.dispatchEvent(new Event("click"));
            });
      }
      inputField() {
        const t = () => {
          this.resetClassTimer && clearTimeout(this.resetClassTimer),
            "" !== this.newsletterField.value && this.popup.classList.add(_i);
        };
        this.newsletterField.addEventListener("input", t),
          this.newsletterField.addEventListener("focus", t),
          this.newsletterField.addEventListener("focusout", () => {
            this.resetClassTimer && clearTimeout(this.resetClassTimer),
              (this.resetClassTimer = setTimeout(() => {
                this.popup.classList.remove(_i);
              }, 2e3));
          });
      }
      disconnectedCallback() {
        this.observer && this.observer.disconnect();
      }
      constructor() {
        super(),
          (this.form = this.popup.querySelector(Di.newsletterForm)),
          (this.heading = this.popup.querySelector(Di.newsletterHeading)),
          (this.newsletterField = this.popup.querySelector(Di.newsletterField));
      }
    };
  customElements.get("popup-component") ||
    customElements.define("popup-component", Ui),
    customElements.get("popup-newsletter") ||
      customElements.define("popup-newsletter", zi);
  const ji = '[role="option"]',
    Ji = '[aria-selected="true"]',
    Xi = "[data-popular-searches]",
    Qi = "predictive-search",
    Ki = "[data-predictive-search-results]",
    Yi = "[data-predictive-search-status]",
    Gi = 'input[type="search"]',
    Zi = "[data-popdown]",
    ts = "[data-predictive-search-live-region-count-value]",
    es = "[data-search-results-groups-wrapper]",
    is = "[data-predictive-search-search-for-text]",
    ss = "#shopify-section-predictive-search",
    os = '[aria-selected="true"] a',
    rs = '[aria-selected="true"] a, button[aria-selected="true"]';
  function ns() {
    this.entries = [];
  }
  function as(t, e) {
    ls(t);
    var i = (function (t, e) {
      ls(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var i = [];
      return (
        e.forEach(function (e) {
          for (var s = 0; s < t.options.length; s++) {
            if (
              (t.options[s].name || t.options[s]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              i[s] = e.value;
              break;
            }
          }
        }),
        i
      );
    })(t, e);
    return (function (t, e) {
      return (
        ls(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e),
        t.variants.filter(function (t) {
          return e.every(function (e, i) {
            return t.options[i] === e;
          });
        })[0] || null
      );
    })(t, i);
  }
  function ls(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  customElements.get("predictive-search") ||
    customElements.define(
      "predictive-search",
      class extends di {
        connectedCallback() {
          this.input.addEventListener("focus", this.onFocus.bind(this)),
            this.input.form.addEventListener(
              "submit",
              this.onFormSubmit.bind(this)
            ),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.addEventListener("keyup", this.onKeyup.bind(this)),
            this.addEventListener("keydown", this.onKeydown.bind(this));
        }
        getQuery() {
          return this.input.value.trim();
        }
        onChange() {
          super.onChange();
          const t = this.getQuery();
          var e;
          (this.searchTerm && t.startsWith(this.searchTerm)) ||
            null === (e = this.querySelector(es)) ||
            void 0 === e ||
            e.remove();
          this.updateSearchForTerm(this.searchTerm, t),
            (this.searchTerm = t),
            this.searchTerm.length
              ? this.getSearchResults(this.searchTerm)
              : this.reset();
        }
        onFormSubmit(t) {
          (this.getQuery().length && !this.querySelector(os)) ||
            t.preventDefault();
        }
        onFormReset(t) {
          super.onFormReset(t),
            super.shouldResetForm() &&
              ((this.searchTerm = ""),
              this.abortController.abort(),
              (this.abortController = new AbortController()),
              this.closeResults(!0));
        }
        shouldResetForm() {
          return !document.querySelector(os);
        }
        onFocus() {
          const t = this.getQuery();
          t.length &&
            (this.searchTerm !== t
              ? this.onChange()
              : "true" === this.getAttribute("results")
              ? this.open()
              : this.getSearchResults(this.searchTerm));
        }
        onFocusOut() {
          setTimeout(() => {
            this.contains(document.activeElement) || this.close();
          });
        }
        onKeyup(t) {
          switch (
            (this.getQuery().length || this.close(!0),
            t.preventDefault(),
            t.code)
          ) {
            case "ArrowUp":
              this.switchOption("up");
              break;
            case "ArrowDown":
              this.switchOption("down");
              break;
            case "Enter":
              this.selectOption();
          }
        }
        onKeydown(t) {
          ("ArrowUp" !== t.code && "ArrowDown" !== t.code) ||
            t.preventDefault();
        }
        updateSearchForTerm(t, e) {
          const i = this.querySelector(is),
            s = null == i ? void 0 : i.innerText;
          if (s) {
            var o;
            if (
              (null === (o = s.match(new RegExp(t, "g"))) || void 0 === o
                ? void 0
                : o.length) > 1
            )
              return;
            const r = s.replace(t, e);
            i.innerText = r;
          }
        }
        switchOption(t) {
          if (!this.getAttribute("open")) return;
          const e = "up" === t,
            i = this.querySelector(Ji),
            s = Array.from(this.querySelectorAll(ji)).filter(
              (t) => null !== t.offsetParent
            );
          let o = 0;
          if (e && !i) return;
          let r = -1,
            n = 0;
          for (; -1 === r && n <= s.length; ) s[n] === i && (r = n), n++;
          if (
            ((this.statusElement.textContent = ""),
            !e && i
              ? (o = r === s.length - 1 ? 0 : r + 1)
              : e && (o = 0 === r ? s.length - 1 : r - 1),
            o === r)
          )
            return;
          const a = s[o];
          a.setAttribute("aria-selected", !0),
            i && i.setAttribute("aria-selected", !1),
            this.input.setAttribute("aria-activedescendant", a.id);
        }
        selectOption() {
          const t = this.querySelector(rs);
          t && t.click();
        }
        getSearchResults(t) {
          const e = t.replace(" ", "-").toLowerCase();
          this.setLiveRegionLoadingState(),
            this.cachedResults[e]
              ? this.renderSearchResults(this.cachedResults[e])
              : fetch(
                  `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                    t
                  )}&section_id=predictive-search`,
                  { signal: this.abortController.signal }
                )
                  .then((t) => {
                    if (!t.ok) {
                      var e = new Error(t.status);
                      throw (this.close(), e);
                    }
                    return t.text();
                  })
                  .then((t) => {
                    const i = new DOMParser()
                      .parseFromString(t, "text/html")
                      .querySelector(ss).innerHTML;
                    this.allPredictiveSearchInstances.forEach((t) => {
                      t.cachedResults[e] = i;
                    }),
                      this.renderSearchResults(i);
                  })
                  .catch((t) => {
                    if (20 !== (null == t ? void 0 : t.code))
                      throw (this.close(), t);
                  });
        }
        setLiveRegionLoadingState() {
          (this.statusElement = this.statusElement || this.querySelector(Yi)),
            (this.loadingText =
              this.loadingText || this.getAttribute("data-loading-text")),
            this.setLiveRegionText(this.loadingText),
            this.setAttribute("loading", !0);
        }
        setLiveRegionText(t) {
          this.statusElement.setAttribute("aria-hidden", "false"),
            (this.statusElement.textContent = t),
            setTimeout(() => {
              this.statusElement.setAttribute("aria-hidden", "true");
            }, 1e3);
        }
        renderSearchResults(t) {
          (this.predictiveSearchResults.innerHTML = t),
            this.setAttribute("results", !0),
            this.setLiveRegionResults(),
            this.open();
        }
        setLiveRegionResults() {
          this.removeAttribute("loading"),
            this.setLiveRegionText(this.querySelector(ts).textContent);
        }
        open() {
          this.setAttribute("open", !0),
            this.input.setAttribute("aria-expanded", !0),
            (this.isOpen = !0),
            this.predictiveSearchResults.style.setProperty(
              "--results-height",
              window.visualViewport.height -
                this.predictiveSearchResults.getBoundingClientRect().top +
                "px"
            );
        }
        close(t = !1) {
          this.closeResults(t),
            (this.isOpen = !1),
            this.predictiveSearchResults.style.removeProperty(
              "--results-height"
            );
        }
        closeResults(t = !1) {
          var e;
          t && ((this.input.value = ""), this.removeAttribute("results"));
          const i = this.querySelector(Ji);
          i && i.setAttribute("aria-selected", !1),
            this.input.setAttribute("aria-activedescendant", ""),
            this.removeAttribute("loading"),
            this.removeAttribute("open"),
            this.input.setAttribute("aria-expanded", !1),
            null === (e = this.predictiveSearchResults) ||
              void 0 === e ||
              e.removeAttribute("style");
        }
        reset() {
          (this.predictiveSearchResults.innerHTML = ""),
            (this.input.val = ""),
            this.a11y.removeTrapFocus(),
            this.popularSearches &&
              (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })),
              this.a11y.trapFocus(this.searchPopdown, {
                elementToFocus: this.input,
              }));
        }
        constructor() {
          var t;
          super(),
            (this.a11y = window.theme.a11y),
            (this.abortController = new AbortController()),
            (this.allPredictiveSearchInstances = document.querySelectorAll(Qi)),
            (this.cachedResults = {}),
            (this.input = this.querySelector(Gi)),
            (this.isOpen = !1),
            (this.predictiveSearchResults = this.querySelector(Ki)),
            (this.searchPopdown = this.closest(Zi)),
            (this.popularSearches =
              null === (t = this.searchPopdown) || void 0 === t
                ? void 0
                : t.querySelector(Xi)),
            (this.searchTerm = "");
        }
      }
    ),
    (ns.prototype.add = function (t, e, i) {
      this.entries.push({ element: t, event: e, fn: i }),
        t.addEventListener(e, i);
    }),
    (ns.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var ds = '[name="id"]',
    cs = '[name="selling_plan"]',
    hs = '[name^="options"]',
    us = '[name="quantity"]',
    ps = '[name^="properties"]';
  const ms = "data-option-position",
    vs = '[name^="options"], [data-popout-option]',
    gs = '[name^="options"]:checked, [name^="options"][type="hidden"]',
    bs = "data-value",
    ws = "[data-popout]",
    fs = "sold-out",
    ys = "unavailable",
    Es = "sale";
  const Ls = {
      product: "[data-product]",
      productForm: "[data-product-form]",
      productNotification: "product-notification",
      variantTitle: "[data-variant-title]",
      notificationProduct: "[data-notification-product]",
      itemCountForVariant: "[data-item-count-for-variant]",
      maxInventory: "[data-max-inventory]",
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      cartPage: "[data-cart-page]",
      comparePrice: "[data-compare-price]",
      comparePriceText: "[data-compare-text]",
      finalSaleBadge: "[data-final-sale-badge]",
      colorDescriptionMetafield: "[data-color-description-metafield]",
      colorDescription: "[data-color-description]",
      formWrapper: "[data-form-wrapper]",
      originalSelectorId: "[data-product-select]",
      priceWrapper: "[data-price-wrapper]",
      productImages: "product-images",
      productImage: "[data-product-image]",
      productMediaList: "[data-product-media-list]",
      productJson: "[data-product-json]",
      productPrice: "[data-product-price]",
      productUpsell: "[data-product-upsell-ajax]",
      unitPrice: "[data-product-unit-price]",
      unitBase: "[data-product-base]",
      unitWrapper: "[data-product-unit]",
      productPreorderInput: "[data-product-preorder]",
      productSlide: ".product__slide",
      subPrices: "[data-subscription-watch-price]",
      subSelectors: "[data-subscription-selectors]",
      subsToggle: "[data-toggles-group]",
      subsChild: "data-group-toggle",
      subDescription: "[data-plan-description]",
      section: "[data-section-type]",
      variantSku: "[data-variant-sku]",
      variantMetafields: "[data-variant-metafields]",
      variantButtons: "[data-variant-buttons]",
      variantOptionImage: "[data-variant-option-image]",
      quickAddModal: "[data-quick-add-modal]",
      priceOffAmount: "[data-price-off-amount]",
      priceOffBadge: "[data-price-off-badge]",
      priceOffType: "[data-price-off-type]",
      priceOffWrap: "[data-price-off]",
      remainingCount: "[data-remaining-count]",
      remainingMax: "[data-remaining-max]",
      remainingWrapper: "[data-remaining-wrapper]",
      remainingJSON: "[data-product-remaining-json]",
      optionValue: "[data-option-value]",
      optionPosition: "[data-option-position]",
      installment: "[data-product-form-installment]",
      inputId: 'input[name="id"]',
    },
    Ss = "hidden",
    As = "variant--soldout",
    ks = "variant--unavailable",
    Cs = "product__price--sale",
    qs = "count-is-low",
    Ts = "count-is-in",
    Ms = "count-is-out",
    xs = "count-is-unavailable",
    Is = "data-remaining-max",
    Ps = "data-enable-history-state",
    Os = "data-fader-desktop",
    Ds = "data-fader-mobile",
    Hs = "data-option-position",
    Fs = "data-image-id",
    _s = "data-media-id",
    Bs = "data-quick-add-btn",
    $s = "data-final-sale",
    Ws = "data-variant-image-scroll",
    Ns = "data-max-inventory-reached",
    Rs = "data-error-message-position",
    Vs = "data-preorder-type-product";
  customElements.get("product-form") ||
    customElements.define(
      "product-form",
      class extends HTMLElement {
        connectedCallback() {
          if (this.hasAttribute("onboarding")) return;
          if (
            (this.cartAddEvents(),
            (this.container =
              this.closest(Ls.section) || this.closest(Ls.quickAddModal)),
            !this.container)
          )
            return;
          if (
            ((this.sectionId = this.container.dataset.sectionId),
            (this.product = this.container.querySelector(Ls.product)),
            (this.productForm = this.container.querySelector(Ls.productForm)),
            (this.productNotification = this.container.querySelector(
              Ls.productNotification
            )),
            (this.productImages = this.container.querySelector(
              Ls.productImages
            )),
            (this.productMediaList = this.container.querySelector(
              Ls.productMediaList
            )),
            (this.installmentForm = this.container.querySelector(
              Ls.installment
            )),
            (this.skuWrapper = this.container.querySelector(Ls.variantSku)),
            (this.sellout = null),
            (this.variantImageScroll =
              "true" === this.container.getAttribute(Ws)),
            (this.priceOffWrap = this.container.querySelector(Ls.priceOffWrap)),
            (this.priceOffAmount = this.container.querySelector(
              Ls.priceOffAmount
            )),
            (this.priceOffType = this.container.querySelector(Ls.priceOffType)),
            (this.planDescription = this.container.querySelector(
              Ls.subDescription
            )),
            (this.remainingWrapper = this.container.querySelector(
              Ls.remainingWrapper
            )),
            (this.colorDescriptionMetafield = this.container.querySelector(
              Ls.colorDescriptionMetafield
            )),
            (this.colorDescription = this.container.querySelector(
              Ls.colorDescription
            )),
            (this.colorDescriptionData = null),
            this.colorDescriptionMetafield &&
              this.colorDescriptionMetafield.textContent)
          )
            try {
              this.colorDescriptionData = JSON.parse(
                this.colorDescriptionMetafield.textContent
              );
            } catch (t) {
              console.warn(
                "Error parsing color description metafield data:",
                t
              );
            }
          if (this.remainingWrapper) {
            const t = this.container.querySelector(Ls.remainingMax);
            t &&
              ((this.remainingMaxInt = parseInt(t.getAttribute(Is), 10)),
              (this.remainingCount = this.container.querySelector(
                Ls.remainingCount
              )),
              (this.remainingJSONWrapper = this.container.querySelector(
                Ls.remainingJSON
              )),
              (this.remainingJSON = null),
              this.remainingJSONWrapper &&
              "" !== this.remainingJSONWrapper.innerHTML
                ? (this.remainingJSON = JSON.parse(
                    this.remainingJSONWrapper.innerHTML
                  ))
                : console.warn("Missing product quantity JSON"));
          }
          (this.preorderInput = this.container.querySelector(
            Ls.productPreorderInput
          )),
            (this.enableHistoryState =
              "true" === this.container.getAttribute(Ps)),
            (this.hasUnitPricing = this.container.querySelector(
              Ls.unitWrapper
            )),
            (this.subSelectors = this.container.querySelector(Ls.subSelectors)),
            (this.subPrices = this.container.querySelector(Ls.subPrices)),
            (this.isPreOrder = this.container.querySelector(Ls.isPreOrder));
          let t = null;
          const e = this.container.querySelector(Ls.productJson);
          e && (t = e.innerHTML),
            t
              ? ((this.productJSON = JSON.parse(t)),
                this.linkForm(),
                (this.sellout = new (class {
                  init() {
                    this.update();
                  }
                  update() {
                    this.getCurrentState(),
                      this.optionElements.forEach((t) => {
                        const e = t.closest(`[${ms}]`);
                        if (!e) return;
                        const i = t.value || t.getAttribute(bs),
                          s = e.getAttribute(ms),
                          o = parseInt(s, 10) - 1,
                          r = t.closest(ws);
                        let n = [...this.selections];
                        n[o] = i;
                        const a = this.productJSON.variants.find((t) => {
                          let e = !0;
                          for (let i = 0; i < n.length; i++)
                            t.options[i] !== n[i] && (e = !1);
                          return e;
                        });
                        t.classList.remove(fs, ys),
                          t.parentNode.classList.remove(Es),
                          r && r.classList.remove(fs, ys, Es),
                          void 0 === a
                            ? (t.classList.add(ys), r && r.classList.add(ys))
                            : a &&
                              !1 === a.available &&
                              (t.classList.add(fs), r && r.classList.add(fs)),
                          a &&
                            a.compare_at_price > a.price &&
                            theme.settings.variantOnSale &&
                            t.parentNode.classList.add(Es);
                      });
                  }
                  getCurrentState() {
                    this.selections = [];
                    const t = this.container.querySelectorAll(gs);
                    t.length &&
                      t.forEach((t) => {
                        const e = t.value;
                        e && "" !== e && this.selections.push(e);
                      });
                  }
                  constructor(t, e) {
                    (this.container = t),
                      (this.productJSON = e),
                      (this.optionElements =
                        this.container.querySelectorAll(vs)),
                      this.productJSON &&
                        this.optionElements.length &&
                        this.init();
                  }
                })(this.container, this.productJSON)))
              : console.error("Missing product JSON"),
            (this.variantOptionImages = this.container.querySelectorAll(
              Ls.variantOptionImage
            )),
            (this.variantButtons = this.container.querySelectorAll(
              Ls.variantButtons
            )),
            this.variantOptionImages.length > 1 && this.optionImagesWidth();
        }
        cartAddEvents() {
          (this.buttonATC = this.querySelector(Ls.addToCart)),
            this.buttonATC.addEventListener("click", (t) => {
              t.preventDefault(),
                document.dispatchEvent(
                  new CustomEvent("theme:cart:add", {
                    detail: { button: this.buttonATC },
                    bubbles: !1,
                  })
                ),
                this.closest(Ls.quickAddModal) ||
                  (window.a11y.lastElement = this.buttonATC);
            });
        }
        destroy() {
          this.productForm.destroy();
        }
        linkForm() {
          (this.productForm = new (class {
            destroy() {
              this._listeners.removeAll();
            }
            options() {
              return this._serializeInputValues(
                this.optionInputs,
                function (t) {
                  return (
                    (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t
                  );
                }
              );
            }
            variant() {
              const t = this.options();
              return t.length ? as(this.product, t) : this.product.variants[0];
            }
            plan(t) {
              let e = { allocation: null, group: null, detail: null };
              const i = this.element.querySelector(`${cs}:checked`);
              if (!i) return null;
              const s = i.value,
                o = s && "" !== s ? s : null;
              return (
                o &&
                  t &&
                  (e.allocation = t.selling_plan_allocations.find(function (t) {
                    return t.selling_plan_id.toString() === o.toString();
                  })),
                e.allocation &&
                  (e.group = this.product.selling_plan_groups.find(function (
                    t
                  ) {
                    return (
                      t.id.toString() ===
                      e.allocation.selling_plan_group_id.toString()
                    );
                  })),
                e.group &&
                  (e.detail = e.group.selling_plans.find(function (t) {
                    return t.id.toString() === o.toString();
                  })),
                e && e.allocation && e.detail && e.allocation ? e : null
              );
            }
            properties() {
              return this._serializeInputValues(
                this.propertyInputs,
                function (t) {
                  return (
                    (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]),
                    t
                  );
                }
              );
            }
            quantity() {
              return this.quantityInputs[0]
                ? Number.parseInt(this.quantityInputs[0].value, 10)
                : 1;
            }
            getFormState() {
              const t = this.variant();
              return {
                options: this.options(),
                variant: t,
                properties: this.properties(),
                quantity: this.quantity(),
                plan: this.plan(t),
              };
            }
            _setIdInputValue(t) {
              t && t.id
                ? (this.variantElement.value = t.id.toString())
                : (this.variantElement.value = ""),
                this.variantElement.dispatchEvent(new Event("change"));
            }
            _onSubmit(t, e) {
              (e.dataset = this.getFormState()),
                t.onFormSubmit && t.onFormSubmit(e);
            }
            _onOptionChange(t) {
              this._setIdInputValue(t.dataset.variant);
            }
            _onFormEvent(t) {
              return void 0 === t
                ? Function.prototype.bind()
                : function (e) {
                    (e.dataset = this.getFormState()),
                      this._setIdInputValue(e.dataset.variant),
                      t(e);
                  }.bind(this);
            }
            _initInputs(t, e) {
              return Array.prototype.slice
                .call(this.element.querySelectorAll(t))
                .map(
                  function (t) {
                    return (
                      this._listeners.add(t, "change", this._onFormEvent(e)), t
                    );
                  }.bind(this)
                );
            }
            _serializeInputValues(t, e) {
              return t.reduce(function (t, i) {
                return (
                  (i.checked ||
                    ("radio" !== i.type && "checkbox" !== i.type)) &&
                    t.push(e({ name: i.name, value: i.value })),
                  t
                );
              }, []);
            }
            _validateProductObject(t) {
              if ("object" != typeof t)
                throw new TypeError(t + " is not an object.");
              if (void 0 === t.variants[0].options)
                throw new TypeError(
                  "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
                );
              return t;
            }
            constructor(t, e, i) {
              (this.element = t),
                (this.product = this._validateProductObject(e)),
                (this.variantElement = this.element.querySelector(ds)),
                (i = i || {}),
                (this._listeners = new ns()),
                this._listeners.add(
                  this.element,
                  "submit",
                  this._onSubmit.bind(this, i)
                ),
                (this.optionInputs = this._initInputs(hs, i.onOptionChange)),
                (this.planInputs = this._initInputs(cs, i.onPlanChange)),
                (this.quantityInputs = this._initInputs(
                  us,
                  i.onQuantityChange
                )),
                (this.propertyInputs = this._initInputs(
                  ps,
                  i.onPropertyChange
                ));
            }
          })(this.container, this.productJSON, {
            onOptionChange: this.onOptionChange.bind(this),
            onPlanChange: this.onPlanChange.bind(this),
            onQuantityChange: this.onQuantityChange.bind(this),
          })),
            this.pushState(this.productForm.getFormState(), !0),
            this.subsToggleListeners(),
            (this.checkLiveCartInfoCallback = () => this.checkLiveCartInfo()),
            document.addEventListener(
              "theme:cart-drawer:close",
              this.checkLiveCartInfoCallback
            );
        }
        onOptionChange(t) {
          this.pushState(t.dataset);
        }
        onPlanChange(t) {
          this.subPrices && this.pushState(t.dataset);
        }
        onQuantityChange(t) {
          this.pushState(t.dataset);
        }
        pushState(t, e = !1) {
          var i;
          (this.productState = this.setProductState(t)),
            this.updateAddToCartState(t),
            this.updateNotificationForm(t),
            this.updateProductPrices(t),
            this.updateProductImage(t),
            this.updateSaleText(t),
            this.updateSku(t),
            this.updateSubscriptionText(t),
            this.updateRemaining(t),
            this.checkLiveCartInfo(t),
            this.updateLegend(t),
            this.updateColorDescription(t),
            this.updatePreorderState(t),
            this.fireHookEvent(t),
            null === (i = this.sellout) || void 0 === i || i.update(t),
            this.enableHistoryState && !e && this.updateHistoryState(t);
        }
        updateAddToCartState(t) {
          const e = t.variant;
          let i = theme.strings.addToCart;
          const s = this.container.querySelectorAll(Ls.priceWrapper),
            o = this.container.querySelectorAll(Ls.addToCart),
            r = this.container.querySelectorAll(Ls.addToCartText),
            n = this.container.querySelectorAll(Ls.formWrapper);
          if (this.installmentForm && e) {
            const t = this.installmentForm.querySelector(Ls.inputId);
            (t.value = e.id),
              t.dispatchEvent(new Event("change", { bubbles: !0 }));
          }
          const a = this.isVariantPreorder(e),
            l = this.hasAttribute(Vs),
            d = this.container.querySelector("[data-preorder-badge]");
          if (
            ((a || l) && (i = theme.strings.preOrder),
            l || null == d || d.classList.toggle("hidden", !a),
            theme.settings.atcButtonShowPrice)
          ) {
            var c;
            const t =
                (null ===
                  (c = this.container.querySelector(
                    "quantity-counter input"
                  )) || void 0 === c
                  ? void 0
                  : c.value) || 1,
              s = e.price * t;
            let o =
              0 === s
                ? window.theme.strings.free
                : window.theme.formatMoney(s, theme.moneyFormat);
            if (e.compare_at_price && e.compare_at_price > e.price) {
              const i = e.compare_at_price * t;
              o = `${o} <s>${window.theme.formatMoney(
                i,
                theme.moneyFormat
              )}</s>`;
            }
            i = `${i} <span class="btn__price">${o}</span>`;
          }
          s.length &&
            e &&
            s.forEach((t) => {
              t.classList.remove(Ss);
            }),
            null == o ||
              o.forEach((t) => {
                t.hasAttribute(Bs) ||
                  (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
              }),
            null == r ||
              r.forEach((t) => {
                let s = i;
                e
                  ? e.available || (s = theme.strings.soldOut)
                  : (s = theme.strings.unavailable),
                  (t.innerHTML = s);
              }),
            n.length &&
              n.forEach((t) => {
                if (e) {
                  e.available
                    ? t.classList.remove(As, ks)
                    : (t.classList.add(As), t.classList.remove(ks));
                  const i = t.querySelector(Ls.originalSelectorId);
                  i && (i.value = e.id);
                  const s = t.querySelector(`${Ls.inputId}[form]`);
                  s && ((s.value = e.id), s.dispatchEvent(new Event("change")));
                } else t.classList.add(ks), t.classList.remove(As);
              });
        }
        updateNotificationForm(t) {
          if (!this.productNotification) return;
          const e = this.productNotification.querySelector(Ls.variantTitle),
            i = this.productNotification.querySelector(Ls.notificationProduct);
          null != e &&
            null != i &&
            ((e.textContent = t.variant.title),
            i && (i.value = t.variant.name));
        }
        updatePreorderState(t) {
          if (!this.preorderInput) return;
          const e = this.isVariantPreorder(t.variant) || this.hasAttribute(Vs);
          this.preorderInput.toggleAttribute("disabled", !e);
        }
        updateHistoryState(t) {
          const e = t.variant,
            i = t.plan,
            s = window.location.href;
          if (e && s.includes("/product")) {
            const t = new window.URL(s),
              o = t.searchParams;
            o.set("variant", e.id),
              i && i.detail && i.detail.id && this.productState.hasPlan
                ? o.set("selling_plan", i.detail.id)
                : o.delete("selling_plan"),
              (t.search = o.toString());
            const r = t.toString();
            window.history.replaceState({ path: r }, "", r);
          }
        }
        updateRemaining(t) {
          var e;
          const i = t.variant;
          if (
            (null === (e = this.remainingWrapper) ||
              void 0 === e ||
              e.classList.remove(Ts, Ms, xs, qs),
            i && this.remainingWrapper && this.remainingJSON)
          ) {
            const t = this.remainingJSON[i.id];
            ("out" === t || t < 1) && this.remainingWrapper.classList.add(Ms),
              ("in" === t || t >= this.remainingMaxInt) &&
                this.remainingWrapper.classList.add(Ts),
              ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
                (this.remainingWrapper.classList.add(qs),
                this.remainingCount && (this.remainingCount.innerHTML = t));
          } else
            !i &&
              this.remainingWrapper &&
              this.remainingWrapper.classList.add(xs);
        }
        checkLiveCartInfo(t) {
          const e = (t || this.productForm.getFormState()).variant;
          if (!e) return;
          const i = `${theme.routes.root}products/${this.productJSON.handle}?section_id=api-live-cart-info&variant=${e.id}`;
          fetch(i)
            .then((t) => t.text())
            .then((t) => {
              const e = new DOMParser().parseFromString(t, "text/html"),
                i = Number(e.querySelector(Ls.itemCountForVariant).innerHTML),
                s = e.querySelector(Ls.maxInventory).innerHTML,
                o = Number(s),
                r = Boolean(this.productForm.quantity() + i > o),
                n = "" !== s && r,
                a = "" !== s && i === o ? "form" : "cart";
              this.productForm.element.form &&
                (this.productForm.element.form.setAttribute(Ns, n),
                this.productForm.element.form.setAttribute(Rs, a));
            })
            .catch((t) => console.log("error: ", t));
        }
        optionImagesWidth() {
          if (!this.variantButtons) return;
          let t = 0;
          requestAnimationFrame(() => {
            this.variantOptionImages.forEach((e) => {
              const i = e.clientWidth;
              i > t && (t = i);
            }),
              this.variantButtons.forEach((e) => {
                var i;
                null === (i = e.style) ||
                  void 0 === i ||
                  i.setProperty("--option-image-width", t + "px");
              });
          });
        }
        getBaseUnit(t) {
          return 1 === t.unit_price_measurement.reference_value
            ? t.unit_price_measurement.reference_unit
            : t.unit_price_measurement.reference_value +
                t.unit_price_measurement.reference_unit;
        }
        subsToggleListeners() {
          this.container.querySelectorAll(Ls.subsToggle).forEach((t) => {
            t.addEventListener(
              "change",
              function (t) {
                const e = t.target.value.toString(),
                  i = this.container.querySelector(`[${Ls.subsChild}="${e}"]`),
                  s = this.container.querySelectorAll(`[${Ls.subsChild}]`);
                if (i) {
                  i.classList.remove(Ss);
                  const t = i.querySelector('[name="selling_plan"]');
                  (t.checked = !0), t.dispatchEvent(new Event("change"));
                }
                s.forEach((t) => {
                  if (t !== i) {
                    t.classList.add(Ss);
                    t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                      (t.checked = !1), t.dispatchEvent(new Event("change"));
                    });
                  }
                });
              }.bind(this)
            );
          });
        }
        updateSaleText(t) {
          this.priceOffWrap &&
            (this.productState.planSale
              ? this.updateSaleTextSubscription(t)
              : this.productState.onSale
              ? this.updateSaleTextStandard(t)
              : this.priceOffWrap.classList.add(Ss));
        }
        isVariantMetafield(t, e) {
          const i = (
              this.closest(Ls.productUpsell) || this.container
            ).querySelector(Ls.variantMetafields),
            s = i ? i.textContent : null;
          if (!s) return !1;
          const o = JSON.parse(s);
          let r = !1;
          return (
            o.forEach((i) => {
              Number(i.variant_id) === t.id && (r = "true" === i[e]);
            }),
            r
          );
        }
        isVariantFinalSale(t) {
          return this.isVariantMetafield(t, "final_sale");
        }
        isVariantPreorder(t) {
          return this.isVariantMetafield(t, "preorder");
        }
        updateSaleTextStandard(t) {
          var e, i, s;
          const o = t.variant,
            r =
              null === (e = this.priceOffWrap) || void 0 === e
                ? void 0
                : e.querySelector(Ls.finalSaleBadge),
            n =
              null === (i = this.priceOffWrap) || void 0 === i
                ? void 0
                : i.querySelector(Ls.priceOffBadge),
            a = null == o ? void 0 : o.compare_at_price,
            l = null == o ? void 0 : o.price;
          if (
            (this.priceOffType &&
              (this.priceOffType.innerHTML =
                window.theme.strings.sale || "sale"),
            !n || !this.priceOffAmount || !a || a <= l)
          )
            null == n || n.classList.add(Ss);
          else {
            const { saleType: t } = n.dataset;
            let e;
            "money" == t &&
              (e = window.theme.formatMoney(
                Math.round(a - l),
                theme.moneyFormat
              )),
              "percentage" == t && (e = `${Math.round(((a - l) / a) * 100)}%`),
              e &&
                ((this.priceOffAmount.innerHTML = e), n.classList.remove(Ss));
          }
          const d =
            (null === (s = this.priceOffWrap) || void 0 === s
              ? void 0
              : s.hasAttribute($s)) || this.isVariantFinalSale(o);
          r && r.classList.toggle(Ss, !d),
            this.priceOffWrap.classList.remove(Ss);
        }
        updateSubscriptionText(t) {
          t.plan && this.planDescription
            ? ((this.planDescription.innerHTML = t.plan.detail.description),
              this.planDescription.classList.remove(Ss))
            : this.planDescription && this.planDescription.classList.add(Ss);
        }
        updateSaleTextSubscription(t) {
          if (
            (this.priceOffType &&
              (this.priceOffType.innerHTML =
                window.theme.strings.subscription || "subscripton"),
            this.priceOffAmount && this.priceOffWrap)
          ) {
            const e = t.plan.detail.price_adjustments[0],
              i = e.value;
            e && "percentage" === e.value_type
              ? (this.priceOffAmount.innerHTML = `${i}%`)
              : (this.priceOffAmount.innerHTML = window.theme.formatMoney(
                  i,
                  theme.moneyFormat
                )),
              this.priceOffWrap.classList.remove(Ss);
          }
        }
        updateProductPrices(t) {
          const e = t.variant,
            i = t.plan;
          this.container.querySelectorAll(Ls.priceWrapper).forEach((t) => {
            const s = t.querySelector(Ls.comparePrice),
              o = t.querySelector(Ls.productPrice),
              r = t.querySelector(Ls.comparePriceText);
            let n = "",
              a = "";
            this.productState.available &&
              ((n = e.compare_at_price), (a = e.price)),
              this.productState.hasPlan && (a = i.allocation.price),
              this.productState.planSale &&
                ((n = i.allocation.compare_at_price), (a = i.allocation.price)),
              s &&
                (this.productState.onSale || this.productState.planSale
                  ? (s.classList.remove(Ss),
                    r.classList.remove(Ss),
                    o.classList.add(Cs))
                  : (s.classList.add(Ss),
                    r.classList.add(Ss),
                    o.classList.remove(Cs)),
                (s.innerHTML = window.theme.formatMoney(n, theme.moneyFormat))),
              (o.innerHTML =
                0 === a
                  ? window.theme.strings.free
                  : window.theme.formatMoney(a, theme.moneyFormat));
          }),
            this.hasUnitPricing && this.updateProductUnits(t);
        }
        updateProductUnits(t) {
          const e = t.variant,
            i = t.plan;
          let s = null;
          if (
            (e && e.unit_price && (s = e.unit_price),
            i &&
              i.allocation &&
              i.allocation.unit_price &&
              (s = i.allocation.unit_price),
            s)
          ) {
            const t = this.getBaseUnit(e),
              i = window.theme.formatMoney(s, theme.moneyFormat);
            (this.container.querySelector(Ls.unitPrice).innerHTML = i),
              (this.container.querySelector(Ls.unitBase).innerHTML = t),
              this.container.querySelector(Ls.unitWrapper).classList.remove(Ss);
          } else this.container.querySelector(Ls.unitWrapper).classList.add(Ss);
        }
        updateSku(t) {
          this.skuWrapper &&
            (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${t.variant.sku}`);
        }
        fireHookEvent(t) {
          const e = t.variant;
          this.container.dispatchEvent(
            new CustomEvent("theme:variant:change", {
              detail: { variant: e },
              bubbles: !0,
            })
          );
        }
        setProductState(t) {
          const e = t.variant,
            i = t.plan,
            s = {
              available: !0,
              soldOut: !1,
              onSale: !1,
              showUnitPrice: !1,
              requiresPlan: !1,
              hasPlan: !1,
              planPerDelivery: !1,
              planSale: !1,
            };
          return (
            !e || (e.requires_selling_plan && !i)
              ? (s.available = !1)
              : (e.available || (s.soldOut = !0),
                e.compare_at_price > e.price && (s.onSale = !0),
                e.unit_price && (s.showUnitPrice = !0),
                this.product &&
                  this.product.requires_selling_plan &&
                  (s.requiresPlan = !0),
                i &&
                  this.subPrices &&
                  ((s.hasPlan = !0),
                  i.allocation.per_delivery_price !== i.allocation.price &&
                    (s.planPerDelivery = !0),
                  e.price > i.allocation.price && (s.planSale = !0))),
            s
          );
        }
        updateProductImage(t) {
          var e;
          const i =
            (null === (e = t.dataset) || void 0 === e ? void 0 : e.variant) ||
            t.variant;
          if (i && i.featured_media) {
            const t = this.container.querySelector(
              `[${Fs}="${i.featured_media.id}"]`
            );
            if (t) {
              const e = t.getAttribute(_s),
                i = !window.theme.isMobile();
              if (
                (t.dispatchEvent(
                  new CustomEvent("theme:media:select", {
                    bubbles: !0,
                    detail: { id: e },
                  })
                ),
                i &&
                  !this.productImages.hasAttribute(Os) &&
                  this.variantImageScroll)
              ) {
                const e = t.getBoundingClientRect().top;
                document.dispatchEvent(
                  new CustomEvent("theme:tooltip:close", {
                    bubbles: !1,
                    detail: { hideTransition: !1 },
                  })
                ),
                  window.theme.scrollTo(e);
              }
              i ||
                this.productImages.hasAttribute(Ds) ||
                this.productMediaList.scrollTo({ left: t.offsetLeft });
            }
          }
        }
        updateLegend(t) {
          const e = t.variant;
          if (e) {
            const t = this.container.querySelectorAll(Ls.optionValue);
            t.length &&
              t.forEach((t) => {
                const i = t.closest(Ls.optionPosition);
                if (i) {
                  const s = i.getAttribute(Hs),
                    o = parseInt(s, 10) - 1,
                    r = e.options[o];
                  t.innerHTML = r;
                }
              });
          }
        }
        updateColorDescription(t) {
          const e = t.variant;
          if (!e || !this.colorDescription || !this.colorDescriptionData.length)
            return;
          const i = e.id.toString();
          let s = "";
          for (const t of this.colorDescriptionData) {
            if (t.variant_id.toString() === i && t.metafield_value) {
              s = t.metafield_value;
              break;
            }
          }
          (this.colorDescription.textContent = s),
            s
              ? this.colorDescription.classList.remove(Ss)
              : this.colorDescription.classList.add(Ss);
        }
        constructor() {
          super();
        }
      }
    );
  const Us = "[data-grid-swatch-fieldset]",
    zs = "[data-grid-item]",
    js = "[data-product-information]",
    Js = "[data-product-image]",
    Xs = "[data-swatch-button]",
    Qs = "[data-swatch-link]",
    Ks = "[data-swatch-text]",
    Ys = "[data-swatch-template]",
    Gs = "native-scrollbar",
    Zs = "is-visible",
    to = "no-events",
    eo = "swatch",
    io = "data-swatch-handle",
    so = "data-swatch-label",
    oo = "data-swatch-count",
    ro = "data-swatch-variant-name",
    no = "data-variant-title",
    ao = "data-swatch-values",
    lo = "data-mobile-columns-small";
  let co = class extends HTMLElement {
    connectedCallback() {
      (this.handle = this.getAttribute(io)),
        (this.nativeScrollbar = this.closest(Gs)),
        (this.productItem = this.closest(zs)),
        (this.productInfo = this.closest(js)),
        (this.productImage = this.productItem.querySelector(Js)),
        (this.template = document.querySelector(Ys).innerHTML),
        (this.swatchesJSON = this.getSwatchesJSON()),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle),
        document.addEventListener("theme:resize:width", this.resizeEvent);
      const t = this.getAttribute(so).trim().toLowerCase();
      (function (t) {
        const e = `${window.theme.routes.root}products/${t}.js`;
        return window
          .fetch(e)
          .then((t) => t.json())
          .catch((t) => {
            console.error(t);
          });
      })(this.handle).then((e) => {
        (this.product = e),
          (this.colorOption = e.options.find(function (e) {
            return e.name.toLowerCase() === t || null;
          })),
          this.colorOption && this.init();
      });
    }
    init() {
      (this.innerHTML = ""),
        (this.count = 0),
        (this.limitedCount = 0),
        (this.swatches = this.colorOption.values),
        (this.swatchesCount = 0),
        (this.mobileSwatches = !1);
      if (
        ("true" != this.getAttribute(lo) ||
          !window.theme.isMobile() ||
          ("slider" != this.swatchesStyle &&
            "grid" != this.swatchesStyle &&
            "limited" != this.swatchesStyle) ||
          (this.mobileSwatches = !0),
        this.swatches.forEach((t) => {
          let e = null,
            i = !1,
            s = "";
          for (const i of this.product.variants) {
            const o = i.options.includes(t);
            if ((!e && o && (e = i), o && i.featured_media)) {
              (s = i.featured_media.preview_image.src), (e = i);
              break;
            }
          }
          for (const e of this.product.variants) {
            if (e.options.includes(t) && e.available) {
              i = !0;
              break;
            }
          }
          if (e) {
            const n = document.createElement("div");
            n.innerHTML = this.template;
            const a = n.querySelector(Xs),
              l = n.querySelector(Qs),
              d = n.querySelector(Ks),
              c = this.swatchesJSON[t],
              h = "native" == theme.settings.swatchesType ? c : `var(--${c})`,
              u = e.title.replaceAll('"', "'");
            (a.style = `--animation-delay: ${(100 * this.count) / 1250}s`),
              a.classList.add(`${eo}-${c}`),
              (a.dataset.tooltip = t),
              (a.dataset.swatchVariant = e.id),
              (a.dataset.swatchVariantName = u),
              (a.dataset.swatchImage = s),
              (a.dataset.variant = e.id),
              a.style.setProperty("--swatch", h),
              (l.href =
                ((o = this.product.url),
                (r = e.id),
                /variant=/.test(o)
                  ? o.replace(/(variant=)[^&]+/, "$1" + r)
                  : /\?/.test(o)
                  ? o.concat("&variant=").concat(r)
                  : o.concat("?variant=").concat(r))),
              (l.dataset.swatch = t),
              (l.disabled = !i),
              (d.innerText = t),
              this.mobileSwatches
                ? this.count <= 2 &&
                  this.mobileSwatches &&
                  ((this.innerHTML += n.innerHTML), this.limitedCount++)
                : "limited" != this.swatchesStyle
                ? (this.innerHTML += n.innerHTML)
                : this.count <= 4 &&
                  ((this.innerHTML += n.innerHTML), this.limitedCount++),
              this.count++;
          }
          var o, r, n;
          (this.swatchesCount++, this.swatchesCount == this.swatches.length) &&
            (null === (n = this.nativeScrollbar) ||
              void 0 === n ||
              n.dispatchEvent(new Event("theme:swatches:loaded")));
        }),
        (this.swatchCount = this.productInfo.querySelector(`[${oo}]`)),
        (this.swatchElements = this.querySelectorAll(Qs)),
        (this.swatchFieldset = this.productInfo.querySelector(Us)),
        (this.hideSwatchesTimer = 0),
        this.swatchCount.hasAttribute(oo))
      ) {
        if (
          "text" == this.swatchesStyle ||
          "text-slider" == this.swatchesStyle
        ) {
          if (
            ((this.swatchCount.innerText = `${this.count} ${
              this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor
            }`),
            "text" == this.swatchesStyle)
          )
            return;
          this.swatchCount.addEventListener("mouseenter", () => {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
              this.productInfo.classList.add(to),
              this.swatchFieldset.classList.add(Zs);
          }),
            this.productInfo.addEventListener("mouseleave", () => {
              this.hideSwatchesTimer = setTimeout(() => {
                this.productInfo.classList.remove(to),
                  this.swatchFieldset.classList.remove(Zs);
              }, 100);
            });
        }
        if (
          (("slider" != this.swatchesStyle && "grid" != this.swatchesStyle) ||
            this.swatchFieldset.classList.add(Zs),
          "limited" == this.swatchesStyle ||
            (this.count >= 2 && this.mobileSwatches))
        ) {
          const t = this.count - this.limitedCount;
          this.swatchFieldset.classList.add(Zs),
            t > 0 &&
              (this.innerHTML += `<div class="swatch-limited">+${t}</div>`);
        }
      }
      this.bindSwatchButtonEvents();
    }
    bindSwatchButtonEvents() {
      var t;
      null === (t = this.querySelectorAll(Xs)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.addEventListener("mouseenter", this.showVariantImageEvent);
        }),
        this.productItem.addEventListener(
          "mouseleave",
          this.productItemMouseLeaveEvent
        );
    }
    showVariantImage(t) {
      var e;
      const i =
          null === (e = t.target.getAttribute(ro)) || void 0 === e
            ? void 0
            : e.replaceAll('"', "'"),
        s = this.productImage.querySelectorAll(`[${no}]`),
        o = this.productImage.querySelector(`[${no}="${i}"]`);
      null == s ||
        s.forEach((t) => {
          t.classList.remove(Zs);
        }),
        null == o || o.classList.add(Zs);
    }
    hideVariantImages() {
      var t;
      null === (t = this.productImage.querySelectorAll(`[${no}].${Zs}`)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.classList.remove(Zs);
        });
    }
    getSwatchesJSON() {
      if (!this.hasAttribute(ao)) return {};
      const t = this.getAttribute(ao).split(","),
        e = {};
      return (
        null == t ||
          t.forEach((t) => {
            const [i, s] = t.split(":");
            e[i.trim()] = s.trim();
          }),
        e
      );
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    constructor() {
      super(),
        (this.productItemMouseLeaveEvent = () => this.hideVariantImages()),
        (this.showVariantImageEvent = (t) => this.showVariantImage(t)),
        (this.resizeEvent = () => this.init());
    }
  };
  const ho = ".flickity-prev-next-button",
    uo = "[data-product-link]",
    po = "[data-hover-slide]",
    mo = "[data-hover-slide-touch]",
    vo = "[data-hover-slider]",
    go = "recently-viewed",
    bo = "video",
    wo = '[data-host="vimeo"]',
    fo = '[data-host="youtube"]';
  let yo = class extends HTMLElement {
    connectedCallback() {
      this.addArrowClickHandler(),
        this.recentlyViewed
          ? this.recentlyViewed.addEventListener(
              "theme:recently-viewed:loaded",
              () => {
                this.initBasedOnDevice();
              }
            )
          : this.initBasedOnDevice();
    }
    disconnectedCallback() {
      this.flkty &&
        ((this.flkty.options.watchCSS = !1),
        this.flkty.destroy(),
        (this.flkty = null)),
        this.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.removeEventListener("mouseleave", this.mouseLeaveEvent);
    }
    initBasedOnDevice() {
      window.theme.touch ? this.initTouch() : this.initFlickity();
    }
    addArrowClickHandler() {
      const t = this.closest(uo);
      t &&
        t.addEventListener("click", (t) => {
          t.target.matches(ho) && t.preventDefault();
        });
    }
    initTouch() {
      this.style.setProperty(
        "--slides-count",
        this.querySelectorAll(mo).length
      ),
        this.slider.addEventListener("scroll", this.handleScroll);
    }
    handleScroll() {
      const t = this.slider.scrollLeft / this.slider.clientWidth;
      this.style.setProperty("--slider-index", t);
    }
    initFlickity() {
      this.flkty ||
        !this.slider ||
        this.slider.classList.contains("flickity-enabled") ||
        this.querySelectorAll(po).length < 2 ||
        ((this.flkty = new window.theme.Flickity(this.slider, {
          cellSelector: po,
          contain: !0,
          wrapAround: !0,
          watchCSS: !0,
          autoPlay: !1,
          draggable: !1,
          pageDots: !1,
          prevNextButtons: !0,
        })),
        this.flkty.pausePlayer(),
        this.addEventListener("mouseenter", () => {
          this.flkty.unpausePlayer();
        }),
        this.addEventListener("mouseleave", () => {
          this.flkty.pausePlayer();
        }));
    }
    mouseEnterActions() {
      (this.hovered = !0), this.videoActions();
    }
    mouseLeaveActions() {
      (this.hovered = !1), this.videoActions();
    }
    videoActions() {
      const t = this.querySelector(fo),
        e = this.querySelector(wo),
        i = t || e,
        s = this.querySelector(bo);
      if (i) {
        let t = this.hovered ? "playVideo" : "pauseVideo",
          s = `{"event":"command","func":"${t}","args":""}`;
        e && ((t = this.hovered ? "play" : "pause"), (s = `{"method":"${t}"}`)),
          i.contentWindow.postMessage(s, "*"),
          i.addEventListener("load", (t) => {
            this.videoActions();
          });
      } else s && (this.hovered ? s.play() : s.pause());
    }
    constructor() {
      super(),
        (this.flkty = null),
        (this.slider = this.querySelector(vo)),
        (this.handleScroll = this.handleScroll.bind(this)),
        (this.recentlyViewed = this.closest(go)),
        (this.hovered = !1),
        (this.mouseEnterEvent = () => this.mouseEnterActions()),
        (this.mouseLeaveEvent = () => this.mouseLeaveActions()),
        this.addEventListener("mouseenter", this.mouseEnterEvent),
        this.addEventListener("mouseleave", this.mouseLeaveEvent);
    }
  };
  const Eo = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
    },
    Lo = "[data-animation]",
    So = "[data-api-content]",
    Ao = "[data-quick-add-btn]",
    ko = "[data-add-to-cart]",
    Co = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    qo = "[data-message-error]",
    To = "[data-quick-add-modal-handle]",
    Mo = "[data-product-upsell-ajax]",
    xo = "[data-quick-add-modal-close]",
    Io = "data-grid-item",
    Po = "[data-product-information]",
    Oo = "[data-quick-add-holder]",
    Do = "[data-quick-add-modal]",
    Ho = "[data-quick-add-modal-template]",
    Fo = "closing",
    _o = "data-product-id",
    Bo = "data-quick-add-modal-handle",
    $o = "data-sibling-swapper",
    Wo = "data-quick-add-holder";
  let No = class extends HTMLElement {
    connectedCallback() {
      this.modalButton &&
        this.modalButton.addEventListener("click", this.modalButtonClickEvent),
        this.buttonATC &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              (window.a11y.lastElement = this.buttonATC),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: { button: this.buttonATC },
                })
              );
          }),
        this.quickAddHolder &&
          (this.quickAddHolder.addEventListener(
            "animationend",
            this.quickAddLoadingToggle
          ),
          this.errorHandler());
    }
    modalButtonClickEvent(t) {
      t.preventDefault();
      const e = this.modalButton.hasAttribute($o),
        i = this.modalButton.classList.contains(Eo.siblingLinkCurrent);
      i ||
        (this.modalButton.classList.add(Eo.loading),
        (this.modalButton.disabled = !0),
        e &&
          !i &&
          ((this.currentModal = t.target.closest(Do)),
          this.currentModal.classList.add(Eo.loading)),
        this.renderModal());
    }
    modalCreate(t) {
      const e = document.querySelector(`${Do}[${_o}="${this.productId}"]`);
      if (e) (this.modal = e), this.modalOpen();
      else {
        const e = this.quickAddHolder.querySelector(Ho);
        if (!e) return;
        const i = document.createElement("div");
        (i.innerHTML = e.innerHTML),
          document.body.appendChild(i.querySelector(Do)),
          e.remove(),
          (this.modal = document.querySelector(
            `${Do}[${_o}="${this.productId}"]`
          )),
          (this.modal.querySelector(Mo).innerHTML = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(So).innerHTML),
          this.modalCreatedCallback();
      }
    }
    modalOpen() {
      this.currentModal &&
        this.currentModal.dispatchEvent(
          new CustomEvent("theme:modal:close", { bubbles: !1 })
        ),
        "function" == typeof this.modal.show && this.modal.show(),
        this.modal.setAttribute("open", !0),
        this.modal.removeAttribute("inert"),
        this.quickAddHolder.classList.add(Eo.disabled),
        this.modalButton &&
          (this.modalButton.classList.remove(Eo.loading),
          (this.modalButton.disabled = !1),
          (window.a11y.lastElement = this.modalButton)),
        requestAnimationFrame(() => {
          this.modal.querySelectorAll(Lo).forEach((t) => {
            t.classList.add(Eo.animated);
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:quick-add:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        document.addEventListener(
          "theme:product:added",
          this.modalCloseOnProductAdded,
          { once: !0 }
        );
    }
    modalClose() {
      if (!this.isAnimating) {
        if (!this.modal.hasAttribute(Fo))
          return this.modal.setAttribute(Fo, ""), void (this.isAnimating = !0);
        "function" == typeof this.modal.close
          ? this.modal.close()
          : this.modal.removeAttribute("open"),
          this.modal.removeAttribute(Fo),
          this.modal.setAttribute("inert", ""),
          this.modal.classList.remove(Eo.loading),
          this.modalButton && (this.modalButton.disabled = !1),
          this.quickAddHolder &&
            this.quickAddHolder.classList.contains(Eo.disabled) &&
            this.quickAddHolder.classList.remove(Eo.disabled),
          this.resetAnimatedItems(),
          window.theme.hasOpenModals() ||
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
          document.removeEventListener(
            "theme:product:added",
            this.modalCloseOnProductAdded
          ),
          this.a11y.removeTrapFocus(),
          this.a11y.autoFocusLastElement();
      }
    }
    modalEvents() {
      var t;
      null === (t = this.modal.querySelector(xo)) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(), this.modalClose();
        }),
        this.modal.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName &&
            "click" === t.type &&
            this.modalClose();
        }),
        this.modal.addEventListener("keydown", (t) => {
          "Escape" == t.code && (t.preventDefault(), this.modalClose());
        }),
        this.modal.addEventListener("theme:modal:close", () => {
          this.modalClose();
        }),
        this.modal.addEventListener("animationend", (t) => {
          t.target === this.modal &&
            ((this.isAnimating = !1),
            this.modal.hasAttribute(Fo)
              ? this.modalClose()
              : setTimeout(() => {
                  this.a11y.trapFocus(this.modal);
                  const t =
                    this.modal.querySelector("[autofocus]") ||
                    this.modal.querySelector(Co);
                  null == t || t.focus();
                }, 50));
        });
    }
    modalCloseOnProductAdded() {
      this.resetQuickAddButtons(),
        this.modal && this.modal.hasAttribute("open") && this.modalClose();
    }
    quickAddLoadingToggle(t) {
      t.target == this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Eo.disabled);
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
        const e = t.detail.holder,
          i = e.closest(`[${Io}]`);
        if (!i) return;
        const s = e.querySelector(qo),
          o = i.classList.contains(Eo.overlayText),
          r = i.querySelector(Po),
          n = e.querySelector(ko);
        if (n) {
          n.classList.remove(Eo.added, Eo.loading), e.classList.add(Eo.error);
          const t = () => {
            this.resetQuickAddButtons(),
              o && r.classList.remove(Eo.hidden),
              e.removeEventListener("animationend", t);
          };
          e.addEventListener("animationend", t);
        }
        s && (s.innerText = t.detail.description),
          o && r.classList.add(Eo.hidden);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Eo.visible, Eo.error),
        this.buttonQuickAdd &&
          (this.buttonQuickAdd.classList.remove(Eo.added),
          (this.buttonQuickAdd.disabled = !1));
    }
    renderModal() {
      this.modal
        ? this.modalOpen()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((t) => t.text())
            .then((t) => {
              this.modalCreate(t);
            });
    }
    modalCreatedCallback() {
      this.modalEvents(), this.modalOpen(), L(this.modal);
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new $({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    resetAnimatedItems() {
      var t;
      null === (t = this.modal) ||
        void 0 === t ||
        t.querySelectorAll(Lo).forEach((t) => {
          t.classList.remove(Eo.animated);
        });
    }
    constructor() {
      var t;
      (super(),
      (this.quickAddHolder = this.querySelector(Oo)),
      this.quickAddHolder) &&
        ((this.modal = null),
        (this.currentModal = null),
        (this.productId = this.quickAddHolder.getAttribute(Wo)),
        (this.modalButton = this.quickAddHolder.querySelector(To)),
        (this.handle =
          null === (t = this.modalButton) || void 0 === t
            ? void 0
            : t.getAttribute(Bo)),
        (this.buttonQuickAdd = this.quickAddHolder.querySelector(Ao)),
        (this.buttonATC = this.quickAddHolder.querySelector(ko)),
        (this.button = this.modalButton || this.buttonATC),
        (this.modalClose = this.modalClose.bind(this)),
        (this.modalCloseOnProductAdded =
          this.modalCloseOnProductAdded.bind(this)),
        (this.a11y = window.theme.a11y),
        (this.isAnimating = !1),
        (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
        (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
    }
  };
  customElements.get("quick-add-product") ||
    customElements.define("quick-add-product", No),
    customElements.get("grid-swatch") ||
      customElements.define("grid-swatch", co),
    customElements.get("hover-images") ||
      customElements.define("hover-images", yo);
  const Ro = "[data-button-arrow]",
    Vo = "[data-deferred-media-button]",
    Uo = "model-viewer, video, iframe, button, [href], input, [tabindex]",
    zo = "[data-image-id]",
    jo = "[data-product-media-list]",
    Jo = "[data-section-type]",
    Xo = "slider__arrows",
    Qo = "is-dragging",
    Ko = "is-focused",
    Yo = "media--active",
    Go = "media--hidden",
    Zo = "media--hiding",
    tr = "data-active-media",
    er = "data-button-prev",
    ir = "data-button-next",
    sr = "data-image-id",
    or = "data-media-id",
    rr = "data-type",
    nr = "data-fader-desktop",
    ar = "data-fader-mobile";
  function lr(t) {
    return t.replace(/http(s)?:/, "");
  }
  customElements.get("product-images") ||
    customElements.define(
      "product-images",
      class extends HTMLElement {
        connectedCallback() {
          Object.keys(this.productMediaItems).length < 2 ||
            (this.productMediaObserver(),
            this.toggleEvents(),
            this.listen(),
            this.setHeight());
        }
        disconnectedCallback() {
          this.unlisten();
        }
        listen() {
          document.addEventListener("theme:resize:width", this.toggleEvents),
            document.addEventListener("theme:resize:width", this.setHeight),
            this.addEventListener("theme:media:select", this.selectMediaEvent);
        }
        unlisten() {
          document.removeEventListener("theme:resize:width", this.toggleEvents),
            document.removeEventListener("theme:resize:width", this.setHeight),
            this.removeEventListener(
              "theme:media:select",
              this.selectMediaEvent
            );
        }
        toggleEvents() {
          const t = window.theme.isMobile();
          (t && this.hasAttribute(ar)) || (!t && this.hasAttribute(nr))
            ? this.bindEventListeners()
            : this.unbindEventListeners();
        }
        bindEventListeners() {
          this.initialized ||
            (this.productMediaList.addEventListener(
              "mousedown",
              this.handleMouseDown
            ),
            this.productMediaList.addEventListener(
              "mouseleave",
              this.handleMouseLeave
            ),
            this.productMediaList.addEventListener(
              "mouseup",
              this.handleMouseUp
            ),
            this.productMediaList.addEventListener(
              "mousemove",
              this.handleMouseMove
            ),
            this.productMediaList.addEventListener(
              "touchstart",
              this.handleMouseDown,
              { passive: !0 }
            ),
            this.productMediaList.addEventListener(
              "touchend",
              this.handleMouseUp,
              { passive: !0 }
            ),
            this.productMediaList.addEventListener(
              "touchmove",
              this.handleMouseMove,
              { passive: !0 }
            ),
            this.productMediaList.addEventListener("keyup", this.handleKeyUp),
            this.initArrows(),
            this.resetScrollPosition(),
            (this.initialized = !0));
        }
        unbindEventListeners() {
          this.initialized &&
            (this.productMediaList.removeEventListener(
              "mousedown",
              this.handleMouseDown
            ),
            this.productMediaList.removeEventListener(
              "mouseleave",
              this.handleMouseLeave
            ),
            this.productMediaList.removeEventListener(
              "mouseup",
              this.handleMouseUp
            ),
            this.productMediaList.removeEventListener(
              "mousemove",
              this.handleMouseMove
            ),
            this.productMediaList.removeEventListener(
              "touchstart",
              this.handleMouseDown
            ),
            this.productMediaList.removeEventListener(
              "touchend",
              this.handleMouseUp
            ),
            this.productMediaList.removeEventListener(
              "touchmove",
              this.handleMouseMove
            ),
            this.productMediaList.removeEventListener(
              "keyup",
              this.handleKeyUp
            ),
            this.removeArrows(),
            (this.initialized = !1));
        }
        handleMouseDown(t) {
          (this.isDown = !0),
            (this.startX =
              (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft),
            (this.startY =
              (t.pageY || t.changedTouches[0].screenY) - this.offsetTop);
        }
        handleMouseLeave() {
          this.isDown && (this.isDown = !1);
        }
        handleMouseUp(t) {
          const e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft,
            i = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop,
            s = e - this.startX,
            o = i - this.startY,
            r = s > 0 ? 1 : -1,
            n =
              this.getCurrentMedia().hasAttribute(rr) &&
              "image" === this.getCurrentMedia().getAttribute(rr);
          Math.abs(s) > 10 &&
            Math.abs(s) > Math.abs(o) &&
            n &&
            (r < 0 ? this.showNextImage() : this.showPreviousImage()),
            (this.isDown = !1),
            requestAnimationFrame(() => {
              this.classList.remove(Qo);
            });
        }
        handleMouseMove() {
          this.isDown && this.classList.add(Qo);
        }
        handleKeyUp(t) {
          "ArrowLeft" === t.code && this.showPreviousImage(),
            "ArrowRight" === t.code && this.showNextImage();
        }
        handleArrowsClickEvent() {
          var t;
          null === (t = this.querySelectorAll(Ro)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault(),
                  t.target.hasAttribute(er) && this.showPreviousImage(),
                  t.target.hasAttribute(ir) && this.showNextImage();
              });
            });
        }
        resetScrollPosition() {
          0 !== this.productMediaList.scrollLeft &&
            (this.productMediaList.scrollLeft = 0);
        }
        initArrows() {
          if (!this.buttons.length) {
            const t = document.createElement("div");
            t.classList.add(Xo),
              (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
              this.productMediaList.append(t),
              (this.buttons = this.querySelectorAll(Ro)),
              (this.buttonPrev = this.querySelector(`[${er}]`)),
              (this.buttonNext = this.querySelector(`[${ir}]`));
          }
          this.handleArrowsClickEvent(), this.preloadImageOnArrowHover();
        }
        removeArrows() {
          var t;
          null === (t = this.querySelector(`.${Xo}`)) ||
            void 0 === t ||
            t.remove();
        }
        preloadImageOnArrowHover() {
          var t, e;
          null === (t = this.buttonPrev) ||
            void 0 === t ||
            t.addEventListener("mouseover", () => {
              const t = this.getPreviousMediaId();
              this.preloadImage(t);
            }),
            null === (e = this.buttonNext) ||
              void 0 === e ||
              e.addEventListener("mouseover", () => {
                const t = this.getNextMediaId();
                this.preloadImage(t);
              });
        }
        preloadImage(t) {
          var e;
          null === (e = this.querySelector(`[${or}="${t}"] img`)) ||
            void 0 === e ||
            e.setAttribute("loading", "eager");
        }
        showMediaOnVariantSelect(t) {
          const e = t.detail.id;
          this.setActiveMedia(e);
        }
        getCurrentMedia() {
          return this.querySelector(`${zo}.${Yo}`);
        }
        getNextMediaId() {
          const t = this.getCurrentMedia(),
            e = (null == t ? void 0 : t.nextElementSibling.hasAttribute(sr))
              ? null == t
                ? void 0
                : t.nextElementSibling
              : this.querySelector(zo);
          return null == e ? void 0 : e.getAttribute(or);
        }
        getPreviousMediaId() {
          const t = this.getCurrentMedia(),
            e = this.productMediaItems.length - 1,
            i =
              (null == t ? void 0 : t.previousElementSibling) ||
              this.productMediaItems[e];
          return null == i ? void 0 : i.getAttribute(or);
        }
        showNextImage() {
          const t = this.getNextMediaId();
          this.selectMedia(t);
        }
        showPreviousImage() {
          const t = this.getPreviousMediaId();
          this.selectMedia(t);
        }
        selectMedia(t) {
          this.dispatchEvent(
            new CustomEvent("theme:media:select", { detail: { id: t } })
          );
        }
        setActiveMedia(t) {
          if (!t) return;
          this.setAttribute(tr, t);
          const e = this.querySelector(`${zo}.${Yo}`),
            i = this.querySelector(`[${or}="${t}"]`),
            s = null == i ? void 0 : i.querySelector(Uo),
            o = i.querySelector("deferred-media");
          var r;
          (null == e || e.classList.add(Zo),
          null == e || e.classList.remove(Yo),
          null == i || i.classList.remove(Zo, Go),
          null == i || i.classList.add(Yo),
          o && !0 !== o.getAttribute("loaded")) &&
            (null === (r = i.querySelector(Vo)) ||
              void 0 === r ||
              r.dispatchEvent(new Event("click", { bubbles: !1 })));
          requestAnimationFrame(() => {
            this.setHeight(),
              document.body.classList.contains(Ko) && (null == s || s.focus());
          });
        }
        setHeight() {
          var t, e;
          const i =
            (null === (t = this.querySelector(`${zo}.${Yo}`)) || void 0 === t
              ? void 0
              : t.offsetHeight) ||
            (null === (e = this.productMediaItems[0]) || void 0 === e
              ? void 0
              : e.offsetHeight);
          this.style.setProperty("--height", `${i}px`);
        }
        productMediaObserver() {
          this.productMediaItems.forEach((t) => {
            t.addEventListener("transitionend", (e) => {
              e.target == t &&
                t.classList.contains(Zo) &&
                (t.classList.remove(Zo), t.classList.add(Go));
            }),
              t.addEventListener("transitioncancel", (e) => {
                e.target == t &&
                  t.classList.contains(Zo) &&
                  (t.classList.remove(Zo), t.classList.add(Go));
              });
          });
        }
        constructor() {
          super(),
            (this.initialized = !1),
            (this.buttons = !1),
            (this.isDown = !1),
            (this.startX = 0),
            (this.startY = 0),
            (this.scrollLeft = 0),
            (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
            (this.container = this.closest(Jo)),
            (this.handleMouseDown = this.handleMouseDown.bind(this)),
            (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
            (this.handleMouseUp = this.handleMouseUp.bind(this)),
            (this.handleMouseMove = this.handleMouseMove.bind(this)),
            (this.handleKeyUp = this.handleKeyUp.bind(this)),
            (this.productMediaItems = this.querySelectorAll(zo)),
            (this.productMediaList = this.querySelector(jo)),
            (this.setHeight = this.setHeight.bind(this)),
            (this.toggleEvents = this.toggleEvents.bind(this)),
            (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t));
        }
      }
    );
  const dr = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingCount: "[data-sibling-count]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
    },
    cr = "is-visible",
    hr = "is-fade",
    ur = "no-events",
    pr = "is-active",
    mr = "data-sibling-cutline",
    vr = "data-sibling-image",
    gr = "data-sibling-link",
    br = "data-sibling-price",
    wr = "data-product-link",
    fr = "data-mobile-columns-small";
  let yr = class extends HTMLElement {
    handleResize() {
      this.siblingFieldset &&
        this.productInfo &&
        (("grid" != this.swatchesStyle &&
          "slider" != this.swatchesStyle &&
          "limited" != this.swatchesStyle) ||
          (this.siblingFieldset.classList.add(cr),
          this.limitVisibleSwatches()));
    }
    connectedCallback() {
      (this.product = this.closest(dr.productGridItem)),
        (this.siblingCount = this.querySelector(dr.siblingCount)),
        (this.siblingFieldset = this.querySelector(dr.siblingFieldset)),
        (this.siblingLinks = this.querySelectorAll(dr.siblingLink)),
        (this.productInfo = this.closest(dr.productInfo)),
        (this.productLink = this.closest(dr.link)),
        (this.hideSwatchesTimer = 0),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle),
        document.addEventListener("theme:resize:width", this.resizeEvent),
        this.siblingFieldset &&
          this.productInfo &&
          (("grid" != this.swatchesStyle &&
            "slider" != this.swatchesStyle &&
            "limited" != this.swatchesStyle) ||
            (this.siblingFieldset.classList.add(cr),
            this.limitVisibleSwatches()),
          this.siblingCount &&
            (this.siblingCount.addEventListener("mouseenter", () =>
              this.showSiblings()
            ),
            this.productInfo.addEventListener("mouseleave", () =>
              this.hideSiblings()
            ))),
        this.siblingLinks.length &&
          new (class {
            init() {
              this.cacheDefaultValues(),
                this.product.addEventListener("mouseleave", () =>
                  this.resetProductValues()
                ),
                this.swatches.forEach((t) => {
                  t.addEventListener("mouseenter", (t) => this.showSibling(t));
                }),
                this.productLinks.length &&
                  this.swatches.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.productLinks[0].click();
                    });
                  });
            }
            cacheDefaultValues() {
              (this.productLinkValue = this.productLinks[0].hasAttribute(wr)
                ? this.productLinks[0].getAttribute(wr)
                : ""),
                (this.productPriceValue = this.productPrice.innerHTML),
                this.productCutline &&
                  (this.productCutlineValue = this.productCutline.innerHTML);
            }
            resetProductValues() {
              this.product.classList.remove(pr),
                this.productLinkValue &&
                  this.productLinks.forEach((t) => {
                    t.href = this.productLinkValue;
                  }),
                this.productPrice &&
                  (this.productPrice.innerHTML = this.productPriceValue),
                this.productCutline &&
                  this.productCutline &&
                  ((this.productCutline.innerHTML = this.productCutlineValue),
                  (this.productCutline.title = this.productCutlineValue)),
                this.hideSiblingImage();
            }
            showSibling(t) {
              const e = t.target,
                i = e.hasAttribute(gr) ? e.getAttribute(gr) : "",
                s = e.hasAttribute(br) ? e.getAttribute(br) : "",
                o = e.hasAttribute(mr) ? e.getAttribute(mr) : "",
                r = e.hasAttribute(vr) ? e.getAttribute(vr) : "";
              i &&
                this.productLinks.forEach((t) => {
                  t.href = i;
                }),
                s &&
                  (this.productPrice.innerHTML = `<span class="price">${s}</span>`),
                this.productCutline &&
                  (o
                    ? ((this.productCutline.innerHTML = o),
                      (this.productCutline.title = o))
                    : ((this.productCutline.innerHTML = ""),
                      (this.productCutline.title = ""))),
                r && this.showSiblingImage(r);
            }
            showSiblingImage(t) {
              if (!this.productImageSibling) return;
              const e = window.devicePixelRatio || 1,
                i = this.productImage.offsetWidth * e,
                s = (function (t, e) {
                  if (null === e) return t;
                  if ("master" === e) return lr(t);
                  const i = t.match(
                    /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
                  );
                  if (i) {
                    const s = t.split(i[0]),
                      o = i[0];
                    return lr(`${s[0]}_${e}${o}`);
                  }
                  return null;
                })(t, 180 * Math.ceil(i / 180) + "x"),
                o = this.productImageSibling.querySelector(`[src="${s}"]`),
                r = () => {
                  this.productImageSibling.classList.add(cr),
                    this.productImageSibling
                      .querySelector(`[src="${s}"]`)
                      .classList.add(hr);
                },
                n = () => {
                  this.productImageSibling
                    .querySelectorAll("img")
                    .forEach((t) => {
                      t.classList.remove(hr);
                    }),
                    requestAnimationFrame(r);
                };
              if (o) n();
              else {
                const t = document.createElement("img");
                (t.src = s),
                  this.productCutline &&
                    (t.alt = this.productCutline.innerText),
                  t.addEventListener("load", () => {
                    this.productImageSibling.append(t), n();
                  });
              }
            }
            hideSiblingImage() {
              this.productImageSibling &&
                (this.productImageSibling.classList.remove(cr),
                this.productImageSibling
                  .querySelectorAll("img")
                  .forEach((t) => {
                    t.classList.remove(hr);
                  }));
            }
            constructor(t, e) {
              (this.swatches = t),
                (this.product = e),
                (this.productLinks = this.product.querySelectorAll(
                  dr.productLink
                )),
                (this.productCutline = this.product.querySelector(
                  dr.productCutline
                )),
                (this.productPrice = this.product.querySelector(
                  dr.productPrice
                )),
                (this.productImage = this.product.querySelector(
                  dr.productImage
                )),
                (this.productImageSibling = this.product.querySelector(
                  dr.productImageSibling
                )),
                this.init();
            }
          })(this.siblingLinks, this.product);
    }
    limitVisibleSwatches() {
      var t;
      const e = window.theme.isMobile(),
        i = this.querySelector(`[${fr}]`),
        s = "true" === (null == i ? void 0 : i.getAttribute(fr));
      if (
        !(null === (t = this.siblingLinks) || void 0 === t
          ? void 0
          : t.length) ||
        (e && !s)
      )
        return;
      if (!e && "limited" !== this.swatchesStyle) {
        this.siblingLinks.forEach((t) => {
          t.style.display = "";
        });
        const t = this.querySelector(".swatch-limited");
        return void (t && t.remove());
      }
      const o = e ? 3 : 5,
        r = this.siblingLinks.length,
        n = Math.min(o, r),
        a = r - n;
      this.siblingLinks.forEach((t, e) => {
        t.style.display = e < n ? "" : "none";
      });
      const l = this.querySelector(".swatch-limited");
      if (a > 0)
        if (l) l.textContent = `+${a}`;
        else {
          const t = document.createElement("div");
          (t.className = "swatch-limited"),
            (t.textContent = `+${a}`),
            null == i || i.appendChild(t);
        }
      else l && l.remove();
    }
    showSiblings() {
      this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
        this.productLink && this.productLink.classList.add(ur),
        "text" != this.swatchesStyle && this.siblingFieldset.classList.add(cr);
    }
    hideSiblings() {
      this.hideSwatchesTimer = setTimeout(() => {
        this.productLink && this.productLink.classList.remove(ur),
          this.siblingFieldset.classList.remove(cr);
      }, 100);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    constructor() {
      super(), (this.resizeEvent = () => this.handleResize());
    }
  };
  customElements.get("product-siblings") ||
    customElements.define("product-siblings", yr),
    (Shopify.Products = (function () {
      const t = {
        howManyToShow: 4,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        section: null,
        target: "api-product-grid-item",
        onComplete: null,
      };
      let e = [],
        i = null,
        s = null;
      const o = new Date(),
        r = new Date();
      r.setTime(o.getTime() + 7776e6);
      const n = {
          configuration: {
            expires: r.toGMTString(),
            path: "/",
            domain: window.location.hostname,
            sameSite: "none",
            secure: !0,
          },
          name: "shopify_recently_viewed",
          write: function (t) {
            const e = encodeURIComponent(t.join(" "));
            document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
          },
          read: function () {
            let t = [],
              e = null;
            return (
              -1 !== document.cookie.indexOf("; ") &&
                document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name)) &&
                (e = document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name))
                  .split("=")[1]),
              null !== e && (t = decodeURIComponent(e).split(" ")),
              t
            );
          },
          destroy: function () {
            document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
          },
          remove: function (t) {
            const e = this.read(),
              i = e.indexOf(t);
            -1 !== i && (e.splice(i, 1), this.write(e));
          },
        },
        a = (e, i, o, r, l, d) => {
          i.length && e < d
            ? fetch(
                `${window.theme.routes.root}products/${i[0]}?section_id=${l}`
              )
                .then((t) => t.text())
                .then((t) => {
                  const s = 100 * e,
                    n = o.id ? `#${o.id}` : "",
                    c = document.createElement("div");
                  let h = t;
                  (h = h.includes("||itemAnimationDelay||")
                    ? h.replaceAll("||itemAnimationDelay||", s)
                    : h),
                    (h = h.includes("||itemAnimationAnchor||")
                      ? h.replaceAll("||itemAnimationAnchor||", n)
                      : h),
                    (c.innerHTML = h),
                    (o.innerHTML +=
                      c.querySelector("[data-api-content]").innerHTML),
                    i.shift(),
                    e++,
                    a(e, i, o, r, l, d);
                })
                .catch(() => {
                  n.remove(i[0]), i.shift(), a(e, i, o, r, l, d);
                })
            : ((e, i) => {
                e.classList.remove("hidden");
                const o = n.read().length;
                if (
                  Shopify.recentlyViewed &&
                  s &&
                  o &&
                  o < s &&
                  e.children.length
                ) {
                  let t = [],
                    i = [],
                    s = 0;
                  for (const e in Shopify.recentlyViewed) {
                    s += 1;
                    const o = Shopify.recentlyViewed[e].split(" "),
                      r = parseInt(e.split("_")[1]);
                    (t = [...t, ...o]),
                      (n.read().length === r ||
                        (s === Object.keys(Shopify.recentlyViewed).length &&
                          !i.length)) &&
                        (i = [...i, ...o]);
                  }
                  for (let s = 0; s < e.children.length; s++) {
                    const o = e.children[s];
                    t.length && o.classList.remove(...t),
                      i.length && o.classList.add(...i);
                  }
                }
                if (t.onComplete)
                  try {
                    t.onComplete(e, i);
                  } catch (t) {
                    console.log(t);
                  }
              })(o, r);
        };
      return {
        showRecentlyViewed: function (o) {
          if (Shopify.visualPreviewMode) return;
          const r = o || {};
          Object.assign(t, r),
            (e = n.read()),
            (i = document.querySelector(`#${t.wrapperId}`)),
            (s = t.howManyToShow),
            (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
            t.howManyToShow && i && a(0, e, i, t.section, t.target, s);
        },
        getConfig: function () {
          return t;
        },
        clearList: function () {
          n.destroy();
        },
        recordRecentlyViewed: function (e) {
          const i = e || {};
          Object.assign(t, i);
          let s = n.read();
          if (-1 !== window.location.pathname.indexOf("/products/")) {
            let e = decodeURIComponent(window.location.pathname)
              .match(
                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
              )[0]
              .split("/products/")[1];
            t.handle && (e = t.handle);
            const i = s.indexOf(e);
            -1 === i
              ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory)))
              : (s.splice(i, 1), s.unshift(e)),
              n.write(s);
          }
        },
        hasProducts: n.read().length > 0,
      };
    })());
  const Er = "[data-aos]",
    Lr = ".collection-item__image",
    Sr = "[data-column-image]",
    Ar = ".flickity-button.next",
    kr = ".flickity-button.previous",
    Cr = "a:not(.btn)",
    qr = ".product-item__image",
    Tr = "[data-section-type]",
    Mr = "[data-slide]",
    xr = "[data-slider-thumb]",
    Ir = "data-arrow-position-middle",
    Pr = "data-slide-index",
    Or = "data-options",
    Dr = "data-slide-text-color",
    Hr = "aos-animate",
    Fr = "desktop",
    _r = "is-focused",
    Br = "hidden",
    $r = "is-initialized",
    Wr = "is-loading",
    Nr = "is-selected",
    Rr = "mobile",
    Vr = "single-slide";
  customElements.get("slider-component") ||
    customElements.define(
      "slider-component",
      class extends HTMLElement {
        connectedCallback() {
          this.initSlider();
        }
        initSlider() {
          var t;
          if (this.slides.length <= 1) return;
          this.hasAttribute(Or) &&
            (this.customOptions = JSON.parse(
              decodeURIComponent(this.getAttribute(Or))
            )),
            this.classList.add(Wr);
          let e = Mr;
          const i = !window.theme.isMobile(),
            s = `${Mr}:not(.${Rr})`,
            o = `${Mr}:not(.${Fr})`;
          var r;
          (this.querySelectorAll(s).length ||
            this.querySelectorAll(o).length) &&
            ((e = i ? s : o),
            null === (r = this.flkty) || void 0 === r || r.destroy());
          if (this.querySelectorAll(e).length <= 1)
            return this.classList.add(Vr), void this.classList.remove(Wr);
          (this.sliderOptions = {
            cellSelector: e,
            contain: !0,
            wrapAround: !0,
            adaptiveHeight: !0,
            ...this.customOptions,
            on: {
              ready: () => {
                requestAnimationFrame(() => {
                  this.classList.add($r),
                    this.classList.remove(Wr),
                    this.parentNode.dispatchEvent(
                      new CustomEvent("theme:slider:loaded", {
                        bubbles: !0,
                        detail: { slider: this },
                      })
                    );
                }),
                  this.slideActions(),
                  this.sliderOptions.prevNextButtons && this.positionArrows();
              },
              change: (t) => {
                const e = this.slides[t];
                if (!e || this.sliderOptions.groupCells) return;
                const i = e.querySelectorAll(Er);
                i.length &&
                  i.forEach((t) => {
                    t.classList.remove(Hr),
                      requestAnimationFrame(() => {
                        setTimeout(() => {
                          t.classList.add(Hr);
                        }, 0);
                      });
                  });
              },
              resize: () => {
                this.sliderOptions.prevNextButtons && this.positionArrows();
              },
            },
          }),
            this.initFlickity(),
            this.flkty.on("change", () => this.slideActions(!0)),
            null === (t = this.thumbs) ||
              void 0 === t ||
              t.forEach((t) => {
                t.addEventListener("click", (e) => {
                  e.preventDefault();
                  const i = [...t.parentElement.children].indexOf(t);
                  this.flkty.select(i);
                });
              }),
            (this.flkty && this.flkty.isActive) || this.classList.remove(Wr);
        }
        initFlickity() {
          this.sliderOptions.fade
            ? (this.flkty = new window.theme.FlickityFade(
                this,
                this.sliderOptions
              ))
            : (this.flkty = new window.theme.Flickity(
                this,
                this.sliderOptions
              ));
        }
        bindEvents() {
          this.addEventListener("theme:slider:init", () => {
            this.initSlider();
          }),
            this.addEventListener("theme:slider:select", (t) => {
              this.flkty.selectCell(t.detail.index), this.flkty.stopPlayer();
            }),
            this.addEventListener("theme:slider:deselect", () => {
              this.flkty &&
                this.sliderOptions.hasOwnProperty("autoPlay") &&
                this.sliderOptions.autoPlay &&
                this.flkty.playPlayer();
            }),
            this.addEventListener("theme:slider:reposition", () => {
              var t;
              null === (t = this.flkty) || void 0 === t || t.reposition();
            }),
            this.addEventListener("theme:slider:destroy", () => {
              var t;
              null === (t = this.flkty) || void 0 === t || t.destroy();
            }),
            this.addEventListener("theme:slider:remove-slide", (t) => {
              var e, i;
              t.detail.slide &&
                (null === (e = this.flkty) ||
                  void 0 === e ||
                  e.remove(t.detail.slide),
                0 ===
                  (null === (i = this.flkty) || void 0 === i
                    ? void 0
                    : i.cells.length) && this.section.classList.add(Br));
            });
        }
        slideActions(t = !1) {
          const e = this.querySelector(`.${Nr}`);
          if (!e) return;
          const i = e.hasAttribute(Dr) ? e.getAttribute(Dr) : "",
            s = e.querySelector(Cr),
            o = this.querySelectorAll(`${Mr} a, ${Mr} button`);
          if (
            (document.body.classList.contains(_r) &&
              s &&
              this.sliderOptions.groupCells &&
              t &&
              s.focus(),
            o.length &&
              o.forEach((t) => {
                const e = t.closest(Mr);
                if (e) {
                  const i = e.classList.contains(Nr) ? 0 : -1;
                  t.setAttribute("tabindex", i);
                }
              }),
            this.style.setProperty("--text", i),
            this.thumbs.length &&
              this.thumbs.length === this.slides.length &&
              e.hasAttribute(Pr))
          ) {
            const t = parseInt(e.getAttribute(Pr)),
              i = this.querySelector(`${xr}.${Nr}`);
            i && i.classList.remove(Nr), this.thumbs[t].classList.add(Nr);
          }
        }
        positionArrows() {
          if (!this.hasAttribute(Ir) || !this.sliderOptions.prevNextButtons)
            return;
          const t =
            this.querySelector(Lr) ||
            this.querySelector(qr) ||
            this.querySelector(Sr);
          t &&
            ((this.querySelector(kr).style.top = t.clientHeight / 2 + "px"),
            (this.querySelector(Ar).style.top = t.clientHeight / 2 + "px"));
        }
        disconnectedCallback() {
          this.flkty &&
            ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
        }
        constructor() {
          super(),
            (this.flkty = null),
            (this.slides = this.querySelectorAll(Mr)),
            (this.thumbs = this.querySelectorAll(xr)),
            (this.section = this.closest(Tr)),
            this.bindEvents();
        }
      }
    );
  const Ur = "[data-related-section]",
    zr = "[data-aos]",
    jr = "[data-tab]",
    Jr = ".tab-link__recent",
    Xr = ".tab-content",
    Qr = "current",
    Kr = "hidden",
    Yr = "aos-animate",
    Gr = "aos-no-transition",
    Zr = "is-focused",
    tn = "data-tab",
    en = "data-tab-index";
  customElements.get("tabs-component") ||
    customElements.define(
      "tabs-component",
      class extends HTMLElement {
        connectedCallback() {
          const t = this.querySelectorAll(jr);
          this.addEventListener("theme:tab:check", () => this.checkRecentTab()),
            this.addEventListener("theme:tab:hide", () =>
              this.hideRelatedTab()
            ),
            null == t ||
              t.forEach((t) => {
                const e = parseInt(t.getAttribute(tn)),
                  i = this.querySelector(`${Xr}-${e}`);
                t.addEventListener("click", () => {
                  this.tabChange(t, i);
                }),
                  t.addEventListener("keyup", (e) => {
                    ("Space" !== e.code && "Enter" !== e.code) ||
                      !document.body.classList.contains(Zr) ||
                      this.tabChange(t, i);
                  });
              });
        }
        tabChange(t, e) {
          if (t.classList.contains(Qr)) return;
          const i = this.querySelector(`${jr}.${Qr}`),
            s = this.querySelector(`${Xr}.${Qr}`);
          null == i || i.classList.remove(Qr),
            null == s || s.classList.remove(Qr),
            t.classList.add(Qr),
            e.classList.add(Qr),
            t.classList.contains(Kr) && e.classList.add(Kr),
            this.a11y.a11y.removeTrapFocus(),
            this.dispatchEvent(
              new CustomEvent("theme:tab:change", { bubbles: !0 })
            ),
            t.dispatchEvent(
              new CustomEvent("theme:form:sticky", {
                bubbles: !0,
                detail: { element: "tab" },
              })
            ),
            this.animateItems(e);
        }
        animateItems(t, e = !0) {
          const i = t.querySelectorAll(zr);
          i.length &&
            i.forEach((t) => {
              t.classList.remove(Yr),
                e &&
                  (t.classList.add(Gr),
                  requestAnimationFrame(() => {
                    t.classList.remove(Gr), t.classList.add(Yr);
                  }));
            });
        }
        checkRecentTab() {
          const t = this.querySelector(Jr);
          if (t) {
            t.classList.remove(Kr);
            const e = parseInt(t.getAttribute(tn)),
              i = this.querySelector(`${Xr}[${en}="${e}"]`);
            i && (i.classList.remove(Kr), this.animateItems(i, !1));
          }
        }
        hideRelatedTab() {
          const t = this.querySelector(Ur);
          if (!t) return;
          const e = t.closest(`${Xr}.${Qr}`);
          if (!e) return;
          const i = parseInt(e.getAttribute(en)),
            s = this.querySelectorAll(jr);
          if (s.length > i) {
            const t = s[i].nextSibling;
            t && (s[i].classList.add(Kr), t.dispatchEvent(new Event("click")));
          }
        }
        constructor() {
          super(), (this.a11y = window.a11y);
        }
      }
    );
  const sn = "[data-actions]",
    on = "[data-content]",
    rn = "[data-button]",
    nn = "data-height",
    an = "is-open",
    ln = "is-enabled";
  let dn = class extends HTMLElement {
    connectedCallback() {
      this.setHeight(this.initialHeight),
        this.trigger.addEventListener("click", () => {
          this.setHeight(this.content.offsetHeight), this.classList.add(an);
        }),
        this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener("theme:resize", this.toggleActions),
        document.addEventListener(
          "theme:collapsible:toggle",
          this.toggleActions
        );
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions),
        document.removeEventListener(
          "theme:collapsible:toggle",
          this.toggleActions
        );
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      this.classList.toggle(
        ln,
        this.content.offsetHeight + this.actions.offsetHeight >
          this.initialHeight
      );
    }
    constructor() {
      super(),
        (this.initialHeight = this.getAttribute(nn)),
        (this.content = this.querySelector(on)),
        (this.trigger = this.querySelector(rn)),
        (this.actions = this.querySelector(sn)),
        (this.toggleActions = this.toggleActions.bind(this));
    }
  };
  customElements.get("toggle-ellipsis") ||
    customElements.define("toggle-ellipsis", dn);
  const cn = "[data-section-id]",
    hn = "data-tooltip",
    un = "data-tooltip-stop-mouseenter",
    pn = "tooltip-default",
    mn = "is-visible",
    vn = "is-hiding";
  customElements.get("tooltip-component") ||
    customElements.define(
      "tooltip-component",
      class extends HTMLElement {
        connectedCallback() {
          if (!document.querySelector(`.${pn}`)) {
            const t = `<div class="${pn}__arrow"></div><div class="${pn}__inner"><div class="${pn}__text"></div></div>`,
              e = document.createElement("div");
            (e.className = pn), (e.innerHTML = t), document.body.appendChild(e);
          }
          this.addEventListener("mouseenter", this.addPinMouseEvent),
            this.addEventListener("mouseleave", this.removePinMouseEvent),
            this.addEventListener("theme:tooltip:init", this.addPinEvent),
            document.addEventListener(
              "theme:tooltip:close",
              this.removePinEvent
            );
        }
        addPin(t = !1) {
          const e = document.querySelector(`.${pn}`),
            i = this.closest(cn),
            s = Array.from(i.classList).find((t) =>
              t.startsWith("color-scheme-")
            );
          if (
            (null == e || e.classList.add(s),
            this.label && e && ((t && !this.hasAttribute(un)) || !t))
          ) {
            const t = e.querySelector(`.${pn}__arrow`),
              i = e.querySelector(`.${pn}__inner`);
            e.querySelector(`.${pn}__text`).innerHTML = this.label;
            const s = i.offsetWidth,
              o = this.getBoundingClientRect(),
              r = o.top,
              n = o.width,
              a = r + o.height + window.scrollY;
            let l = o.left - s / 2 + n / 2;
            const d = 24,
              c = l + s - window.theme.getWindowWidth() + d;
            c > 0 && (l -= c),
              l < 0 && (l = 0),
              (t.style.left = `${o.left + n / 2}px`),
              e.style.setProperty("--tooltip-top", `${a}px`),
              (i.style.transform = `translateX(${l}px)`),
              e.classList.remove(vn),
              e.classList.add(mn),
              document.addEventListener("theme:scroll", this.removePinEvent);
          }
        }
        removePin(t, e = !1, i = !1) {
          const s = document.querySelector(`.${pn}`),
            o = s.classList.contains(mn);
          s &&
            ((e && !this.hasAttribute(un)) || !e) &&
            (o &&
              (i || t.detail.hideTransition) &&
              (s.classList.add(vn),
              this.hideTransitionTimeout &&
                clearTimeout(this.hideTransitionTimeout),
              (this.hideTransitionTimeout = setTimeout(() => {
                s.classList.remove(vn);
              }, this.transitionSpeed))),
            s.classList.remove(mn),
            document.removeEventListener("theme:scroll", this.removePinEvent));
        }
        disconnectedCallback() {
          this.removeEventListener("mouseenter", this.addPinMouseEvent),
            this.removeEventListener("mouseleave", this.removePinMouseEvent),
            this.removeEventListener("theme:tooltip:init", this.addPinEvent),
            document.removeEventListener(
              "theme:tooltip:close",
              this.removePinEvent
            ),
            document.removeEventListener("theme:scroll", this.removePinEvent);
        }
        constructor() {
          super(),
            (this.label = this.hasAttribute(hn) ? this.getAttribute(hn) : ""),
            (this.transitionSpeed = 200),
            (this.hideTransitionTimeout = 0),
            (this.addPinEvent = () => this.addPin()),
            (this.addPinMouseEvent = () => this.addPin(!0)),
            (this.removePinEvent = (t) =>
              window.theme.throttle(this.removePin(t), 50)),
            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0));
        }
      }
    );
  const gn = {};
  function bn(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return gn[t.url]
        ? gn[t.url]
        : (function (t, e) {
            const i = new Promise((i, s) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      i(t);
                    })
                    .catch((t) => {
                      s(t);
                    })
                : (function (t, e, i) {
                    let s = document.getElementsByTagName("head")[0],
                      o = !1,
                      r = document.createElement("script");
                    (r.src = t),
                      (r.onload = r.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? i()
                            : ((o = !0), e());
                        }),
                      s.appendChild(r);
                  })(
                    t,
                    function () {
                      i();
                    },
                    function () {
                      s();
                    }
                  );
            });
            return (gn[t] = i), i;
          })(t.url, t.type);
    if (t.json)
      return gn[t.json]
        ? Promise.resolve(gn[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((gn[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return gn[e]
        ? gn[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              i = new Promise((e, i) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, i) {
                          i ? e(i) : t();
                        })(e, i, t);
                      },
                    },
                  ]);
                } catch (t) {
                  i(t);
                }
              });
            return (gn[e] = i), i;
          })(t);
    }
    return Promise.reject();
  }
  document.addEventListener("DOMContentLoaded", function () {
    const t = document.querySelector("[data-scroll-top-button]");
    t &&
      (t.addEventListener("click", () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }),
      document.addEventListener("theme:scroll", () => {
        t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
      })),
      window.self !== window.top &&
        document.querySelector("html").classList.add("iframe"),
      "scrollBehavior" in document.documentElement.style ||
        bn({ url: window.theme.assets.smoothscroll });
  }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(themeVendor.ScrollLock);
